<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
          
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          
          </v-btn>
          
        </v-col>-->
        <v-col cols="2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-8 header_btn"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length > 0"
                @click="addRecord()"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add Project</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-5 header_btn" icon dark v-bind="attrs" v-on="on" disabled>
                <v-icon size="28px">mdi-clipboard-edit-outline</v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-5 header_btn">
                <v-icon size="28px">mdi-eye-outline</v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>-->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length < 1 || open_doc_model_falg || open_log_model_falg || task_list_modal==true"
                @click="delete_dialog = true"
                class="ml-8 header_btn"
              >
                <v-icon size="28px">mdi-delete-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" class="d-flex align-center">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-1 header_btn">
                <v-icon size="28px">mdi-bookmark-remove-outline</v-icon>
                <span class="lable_class">Cancel</span>
              </v-btn>
            </template>
            <span>Cancel Order</span>
          </v-tooltip>-->
          <!-- <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="open_doc_model_falg || open_log_model_falg" icon small dark v-bind="attrs" v-on="on" class="mr-0">
                
                    <v-badge overlap dot :value="search" color="error">
                
                        <v-icon size="28px">mdi-magnify</v-icon>
                
                    </v-badge>
                
                </v-btn>
            </template>
                        <v-card tile width="400">
                          <v-row no-gutters>
                          <v-col cols="12">
                            <v-text-field
                              v-model="search"
                              append-icon="mdi-magnify"
                              label="Search"
                              single-line
                              hide-details
                              dense
                              solo
                              clearable
                              autofocus
                              v-on:keyup.enter="search_menu = false"
                            ></v-text-field>
                          </v-col>
                          </v-row>
                        </v-card>
          </v-menu>-->
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                size="22px"
                :disabled="open_doc_model_falg || open_log_model_falg || task_list_modal==true"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-5 header_btn"
              >
                <span class="lable_class">Filter</span>
                <v-badge
                  :content="filtersCount"
                  :value="filtersCount"
                  color="error"
                  overlap
                  size="30"
                >
                  <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile max-width="310" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-subheader style="height:32px" class="mt-2 mb-2">
                  <v-row dense>
                    <v-col cols="10">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        dense
                        outlined
                        placeholder=" "
                        clearable
                        autofocus
                        v-on:keyup.enter="search_menu = false"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="error"
                            @click="resetFilter()"
                            icon
                            small
                          >
                            <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-subheader>
                <v-subheader style="height:32px" class="mt-5 mb-2">
                  <v-row dense>
                    <v-col cols="12">
                      <v-autocomplete
                        dense
                        flat
                        :items="date_filter"
                        outlined
                        label="Date Filter"
                        hide-details
                        class="body-2"
                        placeholder="All"
                        v-model="pagination.filters.date_filter"
                        clearable
                        :menu-props="{
                        maxHeight : 340 
                        }"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-subheader>
                <v-list-item v-if="pagination.filters.date_filter == '8'">
                  <v-menu
                    v-model="tran_start_date"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="pagination.filters.tran_start_date"
                        label="Start Date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        placeholder=" "
                        hide-details
                        outlined
                        clearable
                        @click:clear="disable_dates = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFormatted"
                      @input="tran_start_date = false; parseDate('tran_start_date')"
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                  <v-menu
                    v-model="tran_end_date"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="pagination.filters.tran_end_date"
                        label="End Date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        placeholder=" "
                        hide-details
                        outlined
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFormatted"
                      @input="tran_end_date = false; parseDate('tran_end_date')"
                      no-title
                      scrollable
                      :min="disable_dates"
                    ></v-date-picker>
                  </v-menu>
                </v-list-item>
                <!-- <v-list-item>
                  <v-autocomplete
                    dense
                    flat
                    :items="types"
                    outlined
                    label="Type"
                    hide-details
                    class="body-2"
                    placeholder=" "
                    v-model="pagination.filters.type"
                  ></v-autocomplete>
                </v-list-item>-->
                <v-list-item>
                  <v-autocomplete
                    dense
                    flat
                    :items="customer_list"
                    outlined
                    label="Customer"
                    hide-details
                    small
                    class="body-2"
                    placeholder="All"
                    clearable
                    v-model="pagination.filters.customer"
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-0">
                  <v-autocomplete
                    dense
                    flat
                    :items="status2"
                    outlined
                    label="Status"
                    hide-details
                    class="body-2"
                    v-model="pagination.filters.p_active"
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-0">
                  <v-autocomplete
                    dense
                    flat
                    :items="status"
                    outlined
                    label="Project Status"
                    hide-details
                    class="body-2"
                    placeholder="All"
                    v-model="pagination.filters.status"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-0">
                  <v-autocomplete
                    dense
                    flat
                    outlined
                    label="User"
                    v-model="pagination.filters.user"
                    :items="users"
                    hide-details
                    item-text="full_name"
                    item-value="user_id"
                    class="body-2"
                    placeholder="All"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-0">
                  <v-autocomplete
                    dense
                    flat
                    outlined
                    label="Assign To"
                    v-model="pagination.filters.assign_to"
                    :items="users"
                    hide-details
                    item-text="full_name"
                    item-value="user_id"
                    class="body-2"
                    placeholder="All"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-0">
                  <v-autocomplete
                    dense
                    flat
                    outlined
                    label="Access To"
                    v-model="pagination.filters.access_to"
                    :items="users"
                    hide-details
                    item-text="full_name"
                    item-value="user_id"
                    class="body-2"
                    placeholder="All"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="3">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon dark v-bind="attrs" v-on="on" @click="openDocList(selectedRows[0]);" :disabled="selectedRows.length != 1" class="ml-1 header_btn">
                
                    <span class="lable_class">Documents</span>
                
                    <v-badge color="error" :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''" :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''" overlap>
                
                        <v-icon size="28px">mdi-dresser-outline</v-icon>
                
                    </v-badge>
                
                </v-btn>
            </template>
                        <span>Documents</span>
          </v-tooltip>-->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openDocList(selectedRows[0])"
                :disabled="selectedRows.length != 1  || task_list_modal==true"
                class="ml-1 header_btn"
              >
                <span class="lable_class">Documents</span>
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  overlap
                >
                  <v-icon size="28px">mdi-dresser-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Documents</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openLogList(selectedRows[0])"
                :disabled="selectedRows.length != 1 || task_list_modal==true"
                class="ml-5 header_btn"
              >
                <v-badge
                  color="error"
                  style="font-size:8px;"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  overlap
                >
                  <span class="lable_class">Logs</span>
                  <v-icon size="22px">mdi-file-document-multiple-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Logs</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openTaskList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-5 header_btn"
              >
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].calendartask_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].calendartask_count:''"
                  overlap
                >
                  <span class="lable_class">Calendar Task</span>
                  <v-icon size="28px" class="ml-5">mdi-calendar-clock</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Calendar Task</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3" class>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="header_btn"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="disable_order_type || task_list_modal==true "
                @click="showProjectWorkPopup();"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add Job</span>
              </v-btn>
            </template>
            <span>{{projectWorkTooltip}}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <!-- (selectedRows[0].project_work != 'remodeling' && selectedRows[0].project_work != 'new_construction') -->
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="header_btn ml-8"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="disable_order_type || task_list_modal==true"
                @click="group_item_click=true;showProjectGroupPopup();"
              >
                <v-icon size="28px">mdi-clipboard-edit-outline</v-icon>
                <span class="lable_class">Edit Job</span>
              </v-btn>
            </template>
            <span>{{projectWorkTooltip}}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length < 1 || open_doc_model_falg || open_log_model_falg || task_list_modal==true"
                @click="getProjectBalance('multi','')"
                class="ml-10 header_btn"
              >
                <v-icon size="28px">mdi-calculator-variant-outline</v-icon>
                <span class="lable_class">Calculate</span>
              </v-btn>
            </template>
            <span>Balance</span>
          </v-tooltip>
          <v-menu offset-y v-model="report_menu" :close-on-content-click="closeOnContentClick">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="header_btn ml-8"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length != 1 || open_doc_model_falg || open_log_model_falg || selectedRows[0].project_work.length == 0 || task_list_modal==true"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="28px" v-bind="attrs" v-on="on">mdi-printer</v-icon>
                    <span class="lable_class">Report</span>
                  </template>
                  <span>Select report to generate</span>
                </v-tooltip>
              </v-btn>
              <!-- <v-btn
                v-bind="attrs"
                v-on="on"
                class="text-capitalize ml-5"
                :disabled="selectedRows.length != 1 || open_doc_model_falg || open_log_model_falg"
                >
                Select Report to Generate 
                <v-icon
                  right
                  dark
                  size="28"
                  v-if="report_menu"
                >
                  mdi-menu-up
                </v-icon>
                <v-icon
                  right
                  dark
                  size="28"
                  v-else
                >
                  mdi-menu-down
                </v-icon>
              </v-btn>-->
            </template>
            <v-list dense style="font-size: 16px !important;">
              <v-list-item
                class
                v-if="selectedRows.length == 1"
                @click="report_header_name='Sales Income';generateSalesIncomeReport();"
              >
                <v-list-item-title>Sales Income report</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'remodeling' || selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'project_management')"
                @click="report_header_name='Order - G702';report_menu = false; g702_change_report=true;generateG702Report();"
              >
                <v-list-item-title>Order - G702</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'remodeling' || selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'project_management')"
                @click="report_header_name='Schedule of Value - G703';report_menu = false; g703_change_report=true; generateG703Report();"
              >
                <v-list-item-title>Schedule of Value - G703</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'remodeling' || selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'project_management')"
                @click="report_header_name='Contract';report_menu = false; generateContractReport();"
              >
                <v-list-item-title>Contract</v-list-item-title>
              </v-list-item>
              <v-list-item
                class
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'remodeling')"
                @click="report_header_name='Schedule of value Breakdown';is_with_cost=false;is_with_qty=false;is_with_order_amount=true;is_item_spent=false;project_data_flag=selectedRows[0].project_work == 'new_construction' ? '1' :'2';generateGroupItemPDF();"
              >
                <v-list-item-title>Cost Detail W/O Qty</v-list-item-title>
              </v-list-item>
              <v-list-item
                class
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'remodeling')"
                @click="report_header_name='Schedule of value - Detail';is_with_cost=false;is_with_qty=false;is_with_order_amount=false;is_item_spent=false;project_data_flag=selectedRows[0].project_work == 'new_construction' ? '1' :'2';generateGroupItemPDF();"
              >
                <v-list-item-title>Cost Detail - Itemised</v-list-item-title>
              </v-list-item>
              <v-list-item
                class
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'remodeling')"
                @click="report_header_name='Schedule of value - Detail';is_with_cost=false;is_with_qty=true;is_with_order_amount=true;is_item_spent=false;project_data_flag=selectedRows[0].project_work == 'new_construction' ? '1' :'2';generateGroupItemPDF();"
              >
                <v-list-item-title>Cost Detail W/Qty</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'remodeling')"
                @click="report_header_name='Cost Detail - Area wise';is_area_wise_without_cost=true;project_data_flag=selectedRows[0].project_work == 'new_construction' ? '1' :'2';showAreaPopup();"
              >
                <v-list-item-title>Cost Detail - Area wise</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && selectedRows[0].p_type=='fixed' && (selectedRows[0].project_work == 'remodeling' || selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'project_management')"
                @click="report_header_name='Pay App - G702';report_menu = false;g702_change_report=false; generateG702Report();"
              >
                <v-list-item-title>Pay App - G702</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && selectedRows[0].p_type=='fixed' && (selectedRows[0].project_work == 'remodeling' || selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'project_management')"
                @click="report_header_name='Pay App - G703';report_menu = false; g703_change_report=false; generateG703Report();"
              >
                <v-list-item-title>Pay App - G703</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && selectedRows[0].p_type=='cost_plus' && (selectedRows[0].project_work == 'remodeling' || selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'project_management')"
                @click="report_header_name='Invoice';report_menu = false; g703_change_report=false; generateG703Report('cost_plus');"
              >
                <v-list-item-title>Invoice (Cost Plus)</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && selectedRows[0].project_work != 'counter_tops' && selectedRows[0].project_work != 'retail_sales'"
                @click="report_header_name='Time Extension Change Order'; generateTEReport();"
              >
                <v-list-item-title>Time Extension Change order</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="selectedRows[0].change_order_list<=0 ? 'bg-gray' : ''"
                v-if="selectedRows.length == 1  && selectedRows[0].project_work != 'counter_tops' && selectedRows[0].project_work != 'retail_sales' && selectedRows[0].change_order_list != 0 && selectedRows[0].change_order_list != -1"
                @click="report_header_name='Change Order';report_menu = false;is_with_rate=true; generateChangeOrderReport();"
              >
                <v-list-item-title>Change Order</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="selectedRows[0].change_order_list<=0 ? 'bg-gray' : ''"
                v-if="selectedRows.length == 1  && selectedRows[0].project_work != 'counter_tops' && selectedRows[0].project_work != 'retail_sales' && selectedRows[0].change_order_list != 0 && selectedRows[0].change_order_list != -1"
                @click="report_header_name='Change Order';report_menu = false;is_with_rate=false; generateChangeOrderReport();"
              >
                <v-list-item-title>Change Order W/O Qty</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1 && selectedRows[0].invoices_count > 0  && (selectedRows[0].project_work == 'remodeling' || selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'project_management')"
                @click="report_header_name='Partial Lien Release';report_menu = false; generatePartialLienReleaseReport()"
              >
                <v-list-item-title>Partial Lien Release</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1 && selectedRows[0].invoices_count > 0 &&  selectedRows[0].project_work.length > 0 && (selectedRows[0].project_work == 'remodeling' || selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'project_management')"
                @click="report_header_name='Final Lien Release';report_menu = false; generateFinalLienReleaseReport()"
              >
                <v-list-item-title>Final Lien Release</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'counter_tops' || selectedRows[0].project_work == 'retail_sales')"
                @click="report_header_name='Sales Order';is_with_cost=true;generateSalesInvoiceReport(); report_menu = false;"
              >
                <v-list-item-title>Sales Order</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'retail_sales')"
                @click="report_header_name='Sales Order W/O Price';is_with_cost=false;generateSalesInvoiceReport(); report_menu = false;"
              >
                <v-list-item-title>Sales Order W/O Price</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && selectedRows[0].project_work == 'counter_tops'"
                @click="report_header_name='Cut List';generateCounterTopOrderReport(); report_menu = false;"
              >
                <v-list-item-title>Cut List</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedRows.length == 1  && selectedRows[0].project_work == 'counter_tops'"
                @click="report_header_name='Material';generateAcceptanceReport(); report_menu = false;"
              >
                <v-list-item-title>Material</v-list-item-title>
              </v-list-item>
              <v-list-item
                class="bg-light-gray"
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'remodeling')"
                @click="report_header_name='Cost Detail - Area wise';is_with_cost=true;is_with_qty=true;is_with_order_amount=true;is_item_spent=false;is_area_wise_without_cost=false;project_data_flag=selectedRows[0].project_work == 'new_construction' ? '1' :'2';showAreaPopup();"
              >
                <v-list-item-title>Cost Detail Area wise - W/Qty & Price</v-list-item-title>
              </v-list-item>

              <v-list-item
                class="bg-light-gray"
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'remodeling')"
                @click="report_header_name='Calendar Task ';generateCalendarTaskReport();"
              >
                <v-list-item-title>Calendar Task Detail</v-list-item-title>
              </v-list-item>
              <v-list-item
                class="bg-light-gray"
                v-if="selectedRows.length == 1  && (selectedRows[0].project_work == 'new_construction' || selectedRows[0].project_work == 'remodeling')"
                @click="report_header_name='Cost Detail - W/Qty & Price';is_with_cost=true;is_with_qty=true;is_with_order_amount=true;is_item_spent=false;project_data_flag=selectedRows[0].project_work == 'new_construction' ? '1' :'2';generateGroupItemPDF();"
              >
                <v-list-item-title>Cost Detail - W/Qty & Price</v-list-item-title>
              </v-list-item>
              <v-list-item
                class="bg-light-gray"
                v-if="selectedRows.length == 1"
                @click="report_header_name='Spending Analysis';is_with_cost=false;is_with_qty=false;is_with_order_amount=true;is_item_spent=true;project_data_flag=selectedRows[0].project_work == 'new_construction' ? '1' :'2';generateGroupItemPDF();"
              >
                <v-list-item-title>Spending Analysis</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item v-if="selectedRows.length == 1  && selectedRows[0].project_work != 'retail_sales'" @click="signOffReport(); report_menu = false;">
                <v-list-item-title>Sign Off</v-list-item-title>
              </v-list-item>-->
            </v-list>
          </v-menu>
        </v-col>

        <!-- <v-menu offset-y v-model="project_work_menu" v-if="selectedRows.length == 1">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon dark v-bind="attrs" v-on="on" :disabled="disable_order_type">
                
                    <v-tooltip bottom>
                
                        <template v-slot:activator="{ on, attrs }">
                
                                    <v-icon size="28px" v-bind="attrs" v-on="on"> mdi-file-plus-outline </v-icon>
            </template>
                              <span>Select order type to add</span>
                            </v-tooltip>
                          </v-btn>
                        </template>
                        <v-list dense="" style="font-size: 16px !important;">
                          <v-list-item v-if="!disableDesignWork && !selectedRows[0].is_design_work_exist" @click="change_order_id = null; addProjectData(3)">
                            <v-list-item-title>Design Work</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableCounterTopOrder && !selectedRows[0].is_counter_top_order_exist" @click="change_order_id = null; addCounterTop()">
                            <v-list-item-title>Counter Top Order</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableCabinetOrder && !selectedRows[0].is_cabinet_order_exist" @click="change_order_id = null; cabinetOrderDialog(1)">
                            <v-list-item-title>Cabinet Order</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableRemodeling && !selectedRows[0].is_remodeling_exist" @click="change_order_id = null; addProjectData(2)">
                            <v-list-item-title>Remodeling</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableNewConstruction && !selectedRows[0].is_new_construction_exist" @click="change_order_id = null; addProjectData(1)">
                            <v-list-item-title>New Construction</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableProjectManagement && !selectedRows[0].is_project_management_exist" @click="change_order_id = null; addProjectData(4)">
                            <v-list-item-title>Project Management</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableClosets && !selectedRows[0].is_closets_exist" @click="change_order_id = null; cabinetOrderDialog(2)">
                            <v-list-item-title>Closets</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableRetailSales && !selectedRows[0].is_retail_sales_exist" @click="change_order_id = null; addProjectData(5)">
                            <v-list-item-title>Retail Sales</v-list-item-title>
                          </v-list-item>
                        </v-list>
        </v-menu>-->
        <!-- <v-menu offset-y v-model="project_work_menu2" v-if="selectedRows.length == 1">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon dark v-bind="attrs" v-on="on" :disabled="disable_order_type_edit">
                
                    <v-tooltip bottom>
                
                        <template v-slot:activator="{ on, attrs }">
                
                                    <v-icon size="28px" v-bind="attrs" v-on="on"> mdi-clipboard-edit-outline </v-icon>
            </template>
                              <span>Select order type to edit</span>
                            </v-tooltip>
                          </v-btn>
                        </template>
                        <v-list dense="" style="font-size: 16px !important;">
                          <v-list-item v-if="!disableDesignWork && selectedRows[0].is_design_work_exist" @click="change_order_id = null; addProjectData(3)">
                            <v-list-item-title>Design Work</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableCounterTopOrder && selectedRows[0].is_counter_top_order_exist" @click="change_order_id = null; addCounterTop()">
                            <v-list-item-title>Counter Top Order</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableCabinetOrder && selectedRows[0].is_cabinet_order_exist" @click="change_order_id = null; cabinetOrderDialog(1)">
                            <v-list-item-title>Cabinet Order</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableRemodeling && selectedRows[0].is_remodeling_exist" @click="change_order_id = null; addProjectData(2)">
                            <v-list-item-title>Remodeling</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableNewConstruction && selectedRows[0].is_new_construction_exist" @click="change_order_id = null; addProjectData(1)">
                            <v-list-item-title>New Construction</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableProjectManagement && selectedRows[0].is_project_management_exist" @click="change_order_id = null; addProjectData(4)">
                            <v-list-item-title>Project Management</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableClosets && selectedRows[0].is_closets_exist" @click="change_order_id = null; cabinetOrderDialog(2)">
                            <v-list-item-title>Closets</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!disableRetailSales && selectedRows[0].is_retail_sales_exist" @click="change_order_id = null; addProjectData(5)">
                            <v-list-item-title>Retail Sales</v-list-item-title>
                          </v-list-item>
                        </v-list>
        </v-menu>-->

        <v-col class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Project
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff  !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <div class="fixed-top-bar2 d-flex align-center">
      <v-row>
        <v-col cols="12">
          <v-simple-table dense style="line-height: 0.0 !important;">
            <tbody>
              <tr style="background-color:#bdbdbd">
                <td width="37%" class="text-right"></td>
                <td width="9%" class="text-right">
                  <b>{{total_value != 0 ? '$' +(total_value).toFixed(2) : ''}}</b>
                </td>
                <td width="9%" class="text-right">
                  <b
                    :class="{
                    'error--text': total_balance <= 0,
                    'primary--text': total_balance > 0,
                    }"
                  >{{total_balance != 0 ? '$'+ parseFloat(getAmountFormat(total_balance)).toFixed(2) : ''}}</b>
                </td>
                <td width="9%" class="text-right">
                  <b
                    :class="{
                    'error--text': total_pending_invoice_amount <= 0,
                    'primary--text': total_pending_invoice_amount > 0,
                    }"
                  >{{total_pending_invoice_amount != 0 ? '$' + parseFloat(getAmountFormat(total_pending_invoice_amount)).toFixed(2) : ''}}</b>
                </td>
                <td width="9%" class="text-right">
                  <b>{{total_invoice_amt != 0 ? '$' + (parseFloat(getAmountFormat(total_invoice_amt))).toFixed(2) : ''}}</b>
                </td>
                <td width="9%" class="text-right">
                  <b
                    :class="{
                    'error--text': total_payment_due <= 0,
                    'primary--text': total_payment_due > 0,
                    }"
                  >{{total_payment_due != 0 ? '$' + parseFloat(getAmountFormat(total_payment_due)).toFixed(2) : ''}}</b>
                </td>
                <td width="7%" class="text-right"></td>
                <td width="9%" class="text-right">
                  <b>{{total_received_money != 0 ? '$' + parseFloat(getAmountFormat(total_received_money)).toFixed(2) : ''}}</b>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading" style="z-index:99999999">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background:none" flat>
      <v-card-text class="pa-0 mx-auto">
        <!-- <v-row dense style="width:100%" class="pa-0 ma-0">
          <v-col cols="2" style="max-width:4%;" class="pt-0">
            <v-row dense="">
              <v-col cols="6" v-for="(alphabet, index) in alphabets" :key="index" class="pa-0 pl-1">
                <v-btn @click="pagination.filters.alphabet = alphabet.value" icon :color="(pagination.filters.alphabet == alphabet.value)?'green':'dark'" x-small style="font-size: 0.80rem;">{{alphabet.text}}</v-btn>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" class="error" @click="pagination.filters.alphabet = ''" icon small>
          
          <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
          
          </v-btn>
          </template>
                  <span>Reset</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        <v-col class="pt-0 pr-0">-->
        <v-data-table
          :headers="headers"
          item-key="project_id"
          class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header"
          :search="search"
          :items="items.data"
          mobile-breakpoint="50"
          :show-expand="true"
          single-expand
          :expanded.sync="expanded"
          @item-expanded="expandRow"
          dense
          :items-per-page="pagination.itemsPerPage"
          hide-default-footer
          :options.sync="pagination"
          :page.sync="pagination.page"
        >
          <template v-slot:item.p_state="{item}">
            <span v-if="item.p_state > 0">{{ item.state.state_name}}</span>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0 grey lighten-2">
              <v-card max-width="900" class="mx-auto" flat>
                <v-simple-table dense class="grey lighten-2">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="font-weight-bold">Name</td>
                        <td>{{item.p_name}}</td>
                        <td class="font-weight-bold">Customer</td>
                        <td>{{(item.customer)?item.customer.full_name:''}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Type</td>
                        <td>{{item.project_type}}</td>
                        <td class="font-weight-bold">Order Type</td>
                        <td>{{item.display_order_type}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Zip</td>
                        <td>{{item.p_zip}}</td>
                        <td class="font-weight-bold">State</td>
                        <td>{{(item.state)?item.state.state_name:''}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">City</td>
                        <td>{{(item.city)?item.city.city_name:''}}</td>
                        <td class="font-weight-bold">Street Address</td>
                        <td>{{item.street_address}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Mobile</td>
                        <td>{{item.mobile}}</td>
                        <td class="font-weight-bold">Office</td>
                        <td>{{item.work_phone}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Fax</td>
                        <td>{{item.work_fax}}</td>
                        <td class="font-weight-bold">Bill To</td>
                        <td>{{item.bill_to}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Billing Email</td>
                        <td>{{(item.email_domain)?item.bill_to_email+'@'+item.email_domain.domain:''}}</td>
                        <td class="font-weight-bold">Billing Zip</td>
                        <td>{{item.bill_to_zip}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Billing State</td>
                        <td>{{(item.bill_to_state)?item.bill_to_state.state_name:''}}</td>
                        <td class="font-weight-bold">Billing City</td>
                        <td>{{(item.bill_to_city)?item.bill_to_city.city_name:''}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Billing Street Address</td>
                        <td>{{item.bill_to_street_address}}</td>
                        <td class="font-weight-bold">MMS Code</td>
                        <td>{{item.mms_code}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Text Alert</td>
                        <td>{{(item.text_alert)?'Yes':'No'}}</td>
                        <td class="font-weight-bold">Email Alert</td>
                        <td>{{(item.email_alert)?'Yes':'No'}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Assign To</td>
                        <td>{{(item.assign_to_details)?item.assign_to_details.full_name:''}}</td>
                        <td class="font-weight-bold">Access To</td>
                        <td>{{(item.access_to)?getAccessUsers(item.access_to):''}}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Create By</td>
                        <td>{{(item.user_details)?item.user_details.full_name:''}}</td>
                        <td class="font-weight-bold"></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </td>
          </template>
          <template v-slot:item="{ item }">
            <tr :class="row_backgroup_color(item)">
              <td width="3%">
                <v-icon
                  :disabled="open_doc_model_falg || open_log_model_falg"
                  @click="editRecord(item.project_id,false)"
                >mdi-clipboard-edit-outline</v-icon>
              </td>
              <td width="3%">
                <v-checkbox
                  @click="selectRecord(item.project_id)"
                  color="grey darken-1"
                  hide-details
                  v-model="item.selected"
                  :ripple="false"
                  class="custom-simple-box mt-0 pt-0"
                  dense
                ></v-checkbox>
              </td>
              <td width="7%">{{item.display_date}}</td>
              <td
                width="5%"
                class="text-center"
              >{{getProjectShortType(item)}}{{item.short_order_type}}</td>

              <td width="19%">{{item.p_name}}</td>

              <td width="9%" class="text-right">
                <span
                  v-if="item.project_balance_flag==true"
                  class="pr-20"
                >{{item.project_value != 0 ? '$' +(item.project_value) : ''}}</span>
              </td>
              <td width="9%" class="text-right">
                <span
                  v-if="item.project_balance_flag==true"
                  class="pr-20"
                  :class="{
                  'error--text': item.balance <= 0,
                  'primary--text': item.balance > 0,
                  }"
                >{{item.balance != 0 ? '$'+ parseFloat(getAmountFormat(item.balance)).toFixed(2) : ''}}</span>
              </td>
              <td width="9%" class="text-right">
                <span
                  v-if="item.project_balance_flag==true"
                  class="pr-20"
                  :class="{
                  'error--text': item.pending_invoice <= 0,
                  'primary--text': item.pending_invoice > 0,
                  }"
                >{{item.pending_invoice != 0 ? '$' + parseFloat(getAmountFormat(item.pending_invoice)).toFixed(2) : ''}}</span>
              </td>
              <td width="9%" class="text-right">
                <span
                  v-if="item.project_balance_flag==true"
                  class="pr-20"
                >{{item.invoice_amt != 0 ? '$' + (parseFloat(getAmountFormat(item.invoice_amt))).toFixed(2) : ''}}</span>
              </td>
              <td width="9%" class="text-right">
                <span v-if="item.project_balance_flag==true" class="pr-20">{{item.payment_due}}</span>
              </td>

              <td width="7%" class="pl-3">
                <v-icon
                  :disabled="open_doc_model_falg || open_log_model_falg"
                  @click="editRecord(item.project_id,true)"
                >mdi-eye-outline</v-icon>
                <v-icon
                  class="ml-2"
                  @click="getProjectBalance('single',item.project_id)"
                >mdi-calculator-variant-outline</v-icon>
              </td>
              <td width="9%" class="text-right">
                <span
                  v-if="item.project_balance_flag==true"
                  class="pr-20"
                >{{item.project_received_value != 0 ? '$' + parseFloat(getAmountFormat(item.project_received_value)).toFixed(2) : ''}}</span>
              </td>
              <td width="2%"></td>
            </tr>
          </template>
        </v-data-table>
        <div class="v-data-footer custom-pagination fix-footer-bar">
          <v-row dense>
            <v-col cols="4" class="d-flex align-center justify-end">
              <span>Total Record: {{items.total}}</span>
              <div class="v-data-footer__select pl-5">
                Rows per page:
                <v-select
                  v-model="pagination.itemsPerPage"
                  :items="pagination_settings.perPageList"
                  dense
                  hide-details
                ></v-select>
              </div>
            </v-col>
            <v-col cols="8" class="d-flex align-center justify-start">
              <v-pagination
                class="d-flex align-center justify-start"
                v-model="pagination.page"
                :length="items.last_page"
                total-visible="22"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
        <!-- </v-col>
        </v-row>-->
      </v-card-text>
    </v-card>
    <v-dialog v-model="accessory_item_dialog" persistent max-width="1000">
      <v-card :loading="accessory_item_list_loading">
        <v-row dense class="pa-0 ma-0">
          <v-col class="pa-0 ma-0 pl-1">
            <v-card-title>Accessory & Item List</v-card-title>
          </v-col>
          <v-col cols="1" class="pa-0 ma-0 text-right">
            <v-card-title>
              <v-btn
                fab
                color="error"
                x-small
                @click="accessory_item_dialog = false"
                class="custom-close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" class="pa-0 ma-0">
              <v-simple-table dense class="fix-table-layout">
                <thead style="background: #455a64;">
                  <tr>
                    <th class="text-center white--text" width="5%"></th>
                    <th class="text-center white--text" width="11%">A/I</th>
                    <th class="text-center white--text" width="29%">Name</th>
                    <th class="text-center white--text" width="29%">Vendor</th>
                    <th class="text-center white--text" width="7%">Qty</th>
                    <th class="text-center white--text" width="9%">Price</th>
                    <th class="text-center white--text" width="10%">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(acc_item, index) in accessory_item_list" :key="index" class="mt-3">
                    <td class="text-center">
                      <v-icon @click="removeAccessoryItem(acc_item,index)">mdi-close-circle</v-icon>
                    </td>
                    <td
                      class="text-center"
                    >{{(acc_item.item_accessory_flag == 1)?'Accessory':'Item'}}</td>
                    <td
                      class="text-center"
                    >{{(acc_item.item_accessory_flag == 1)?acc_item.accessory.name:acc_item.item.item_name}}</td>
                    <td class="text-center">{{(acc_item.vendor)?acc_item.vendor.v_name:''}}</td>
                    <td class="text-center">{{acc_item.qty}}</td>
                    <td class="text-center">{{acc_item.price}}</td>
                    <td class="text-center">{{(acc_item.qty * acc_item.price).toFixed(2)}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="discount_dialog" persistent max-width="400px">
      <v-card :loading="discount_dialog_loading">
        <v-card-title>
          <span class="headline">Discount</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="7">
                <v-select
                  :items="discount_types"
                  label="Type"
                  v-model="discount_data.discount_type"
                  hide-details
                  dense
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Discount"
                  v-model="discount_data.discount"
                  hide-details
                  type="number"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-icon color="error" @click="removeDiscount()">mdi-close-circle</v-icon>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="discount_dialog = false;">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="change_order_id || is_enable_change_order"
            color="primary"
            @click="saveDiscount()"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected projects?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteProjects()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_change_order_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected change order?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_change_order_dialog = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="delete_change_order_dialog = false; deleteChangeOrder()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_project_data_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_project_data_dialog = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="delete_project_data_dialog = false; deleteProjectData()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="remove_acc_item_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="remove_acc_item_dialog = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="remove_acc_item_dialog = false; removeAccItem()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="change_price_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Change Price</v-card-title>
        <v-card-text>Do you want to change this price in master record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="dark darken-1"
            text
            @click="change_price_dialog = false; add_project_data[active_index].change_price_in_master = true; saveProjectData(active_index);"
          >Yes</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="change_price_dialog = false; add_project_data[active_index].change_price_in_master = false; saveProjectData(active_index);"
          >No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="change_group_price_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Change Price</v-card-title>
        <v-card-text>Do you want to change this price in master record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="dark darken-1"
            text
            @click="change_group_price_dialog = false; update_invoice_group_data.change_price_in_master = true; saveGroupProjectData();"
          >Yes</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="change_group_price_dialog = false; update_invoice_group_data.change_price_in_master = false; saveGroupProjectData();"
          >No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="vendor_change_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Change Vendor</v-card-title>
        <v-card-text>Do you want to change price in order?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="dark darken-1"
            text
            @click="vendor_change_dialog = false; changeVendorPrice(item_vendor_index,'YES');"
          >Yes</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="vendor_change_dialog = false;  changeVendorPrice(item_vendor_index,'NO');"
          >No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="vendor_change_group_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Change Vendor</v-card-title>
        <v-card-text>Do you want to change price in order?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="dark darken-1"
            text
            @click="vendor_change_group_dialog = false;changeVendorPriceGroup(); "
          >Yes</v-btn>
          <v-btn color="red darken-1" text @click="vendor_change_group_dialog = false;">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="change_stone_price_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Change Price</v-card-title>
        <v-card-text>Do you want to change this price in master record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="dark darken-1"
            text
            @click="change_stone_price_dialog = false; stone_data[active_stone_index].change_price_in_master = true; saveProjectStone(active_stone_index);"
          >Yes</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="change_stone_price_dialog = false; stone_data[active_stone_index].change_price_in_master = false; saveProjectStone(active_stone_index);"
          >No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="remove_item_job_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="remove_item_job_dialog = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="remove_item_job_dialog = false; removeItemJob()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="item_group_dialog" persistent max-width="300px">
      <v-card :loading="item_group_loading">
        <v-card-title>
          <span class="headline">Group Item/Job</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-text-field
                label="Description"
                v-model="item_group_data.description"
                :error-messages="item_group_error.description"
                :hide-details="!item_group_error.description"
              ></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="item_group_dialog = false;item_group_data = {};item_group_error = {}"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addItemGroup">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_project_stone_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_project_stone_dialog = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="delete_project_stone_dialog = false; deleteProjectStone()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_project_cabinet_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_project_cabinet_dialog = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="delete_project_cabinet_dialog = false; deleteProjectCabinet()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_project_countor_top_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="dark darken-1"
            text
            @click="delete_project_countor_top_dialog = false"
          >Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="delete_project_countor_top_dialog = false; deleteProjectCountorTop()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_project_cabinet_order_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="dark darken-1"
            text
            @click="delete_project_cabinet_order_dialog = false"
          >Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="delete_project_cabinet_order_dialog = false; deleteProjectCabinetOrder()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_assign_group_item" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Group is assign to Transaction.Are you sure you want to delete this record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_assign_group_item = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="delete_assign_group_item = false;remove_assign_transaction_group=true; removeItemFromGroup(remove_project_data_id)"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="1366px" v-model="add_project_data_model" persistent>
      <v-card :loading="add_project_data_loading">
        <v-card-text>
          <div>
            <v-row dense class="pa-0 ma-0">
              <v-col cols="4" class="pa-0 ma-0">
                <v-card-title v-if="project_data_flag == '1'">New Construction- {{orderTitle}}</v-card-title>
                <v-card-title v-if="project_data_flag == '2'">Remodeling - {{orderTitle}}</v-card-title>
                <v-card-title v-if="project_data_flag == '3'">Design Work - {{orderTitle}}</v-card-title>
                <v-card-title v-if="project_data_flag == '4'">Project Management - {{orderTitle}}</v-card-title>
                <v-card-title v-if="project_data_flag == '5'">General Invoice - {{orderTitle}}</v-card-title>
              </v-col>
              <!-- <v-col  cols="1" class="d-flex align-center" style="min-width: 1%;"> -->
              <!-- <v-autocomplete
                v-if="change_orders.length > 0"
                label="Change Orders"
                clearable=""
                v-model="change_order_id"
                :items="change_orders"
                item-text="full_change_id"
                item-value="change_order_id"
                dense=""
                hide-details=""
                outlined=""
                @change="getChangeLogs()"
                >
              </v-autocomplete>-->
              <!-- </v-col> -->
              <v-col
                v-if="delete_change_order_flag"
                cols="1"
                class="d-flex align-center"
                style="min-width: 12%;"
              >
                <v-btn color="error" @click="delete_change_order_dialog = true;">Delete</v-btn>
              </v-col>
              <v-col cols="7">
                <v-card-title>
                  <span>
                    <v-tooltip bottom :disabled="editModeRecord || selected_item_job.length > 0">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="header_btn"
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="addNewProjectData('yes')"
                          :disabled="editModeRecord || selected_item_job.length > 0"
                        >
                          <v-icon size="28px">mdi-file-plus-outline</v-icon>
                          <span class="lable_class">Add</span>
                        </v-btn>
                      </template>
                      <span>Add</span>
                    </v-tooltip>
                    <v-tooltip bottom :disabled="selected_item_job.length != 1 || editModeRecord">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="ml-4 header_btn"
                          icon
                          v-bind="attrs"
                          @click="add_project_data_loading = true; add_project_data[selected_item_job_index].edit_mode = true; add_project_data_loading = false"
                          v-on="on"
                          :disabled="selected_item_job.length != 1 || editModeRecord"
                        >
                          <v-icon size="28px">mdi-clipboard-edit-outline</v-icon>
                          <span class="lable_class">Edit</span>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip bottom :disabled="selected_item_job.length == 0 || editModeRecord">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="ml-4 header_btn"
                          icon
                          v-bind="attrs"
                          @click="update_area_dialog = true"
                          v-on="on"
                          :disabled="selected_item_job.length == 0 || editModeRecord"
                        >
                          <v-icon size="28px">mdi-pencil-box-multiple-outline</v-icon>
                          <span class="lable_class">Update</span>
                        </v-btn>
                      </template>
                      <span>Update Area</span>
                    </v-tooltip>
                    <v-tooltip bottom :disabled="selected_item_job.length == 0  || editModeRecord">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          class="ml-5 header_btn"
                          @click="addNewProjectData('no')"
                          :disabled="selected_item_job.length == 0 || editModeRecord"
                        >
                          <v-icon size="28px">mdi-delete-outline</v-icon>
                          <span class="lable_class ml-5">Delete</span>
                        </v-btn>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom :disabled="editModeRecord || selected_item_job.length != 1 || getCurrentPrice(selected_item_job[0],selected_item_job_index) == selected_item_job[0].rate">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn class="ml-4 header_btn" icon v-bind="attrs" v-on="on" @click="updatePriceAsCurrent(selected_item_job[0],getCurrentPrice(selected_item_job[0],selected_item_job_index),selected_item_job_index)" :disabled="editModeRecord || selected_item_job.length != 1 || getCurrentPrice(selected_item_job[0],selected_item_job_index) == selected_item_job[0].rate">
                          
                              <v-icon size="28px"> mdi-content-duplicate </v-icon>
                          
                              <span class="lable_class mt-10">Px/Update</span>
                          
                          </v-btn>
                      </template>
                                            <span>Change price to current (${{(selected_item_job.length == 1)?getCurrentPrice(selected_item_job[0],selected_item_job_index):''}})</span>
                    </v-tooltip>-->
                    <v-tooltip bottom :disabled="selected_item_job.length == 0 || editModeRecord">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          class="ml-7 header_btn"
                          @click="updatePriceAsCurrent()"
                          :disabled="selected_item_job.length == 0 || editModeRecord"
                        >
                          <v-icon size="30">mdi-content-duplicate</v-icon>
                          <span class="lable_class ml-7">Px/Update</span>
                        </v-btn>
                      </template>
                      <span>{{(selected_item_job.length == 1)? 'Change Price to Current $' + getCurrentPrice(selected_item_job[0],selected_item_job_index):'Change Price to Current'}}</span>
                    </v-tooltip>
                    <v-menu
                      bottom
                      :close-on-content-click="false"
                      content-class="elevation-0"
                      v-model="filter_menu2"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" class="ml-10 header_btn" size="22px">
                          <span class="lable_class">Filter</span>
                          <v-badge
                            :content="filtersCount2"
                            :value="filtersCount2"
                            color="error"
                            overlap
                            size="30"
                          >
                            <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                          </v-badge>
                        </v-btn>
                      </template>
                      <v-card tile max-width="500" class="mb-5 mr-5">
                        <v-list class="filter-section-border">
                          <v-list-item class="mt-0">
                            <v-autocomplete
                              dense
                              flat
                              :items="project_data_items"
                              outlined
                              label="Item"
                              hide-details
                              class="body-2"
                              placeholder="All"
                              v-model="project_data_filter.item_id"
                              clearable
                            ></v-autocomplete>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  class="error ml-2"
                                  @click="resetProjectDataFilter()"
                                  icon
                                  small
                                >
                                  <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Reset</span>
                            </v-tooltip>
                          </v-list-item>
                          <v-list-item class="mt-1">
                            <v-autocomplete
                              dense
                              flat
                              :items="project_data_vendors"
                              outlined
                              label="Vendor"
                              hide-details
                              class="body-2"
                              placeholder="All"
                              clearable
                              v-model="project_data_filter.vendor_id"
                            ></v-autocomplete>
                          </v-list-item>
                          <v-list-item class="mt-1">
                            <v-autocomplete
                              dense
                              flat
                              :items="project_data_areas"
                              outlined
                              label="Area"
                              hide-details
                              class="body-2"
                              placeholder="All"
                              clearable
                              v-model="project_data_filter.area_id"
                            ></v-autocomplete>
                          </v-list-item>
                        </v-list>
                        <v-card-title class="pa-0">
                          <v-btn
                            fab
                            color="error"
                            x-small
                            absolute
                            @click="filter_menu2 = false;"
                            class="custom-close-btn"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>
                      </v-card>
                    </v-menu>
                  </span>
                  <span class="ml-10">
                    <v-tooltip bottom :disabled="!editModeRecord">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="header_btn"
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="checkChangePrice(selected_item_job_index)"
                          :disabled="!editModeRecord"
                        >
                          <v-icon size="28px">mdi-content-save-outline</v-icon>
                          <span class="lable_class">Save</span>
                        </v-btn>
                      </template>
                      <span>Save</span>
                    </v-tooltip>
                    <v-tooltip bottom :disabled="!editModeRecord">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="ml-5 header_btn"
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="resetProjectData(selected_item_job_index)"
                          :disabled="!editModeRecord"
                        >
                          <v-icon size="28px">mdi-reload</v-icon>
                          <span class="lable_class">Reset</span>
                        </v-btn>
                      </template>
                      <span>Reset</span>
                    </v-tooltip>
                  </span>
                  <span class="ml-10">
                    <v-tooltip bottom :disabled="selected_item_job.length == 0 || editModeRecord">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="header_btn"
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="openInvoiceGroupDialog()"
                          :disabled="selected_item_job.length == 0 || editModeRecord"
                        >
                          <v-icon size="28px">mdi-group</v-icon>
                          <span class="lable_class">Group</span>
                        </v-btn>
                      </template>
                      <span>Group Selected Item(s)</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="ml-7 header_btn"
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="panel = []; group_item_dialog = true; itemGroupList();"
                        >
                          <v-icon size="28px">mdi-format-list-bulleted</v-icon>
                          <span class="lable_class">Group List</span>
                        </v-btn>
                      </template>
                      <span>Group Item(s)</span>
                    </v-tooltip>
                  </span>
                  <span class="ml-15">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="header_btn"
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="generateItemPDF()"
                        >
                          <v-icon size="28px">mdi-printer</v-icon>
                          <span class="lable_class">Print</span>
                        </v-btn>
                      </template>
                      <span>Print as PDF</span>
                    </v-tooltip>
                  </span>
                </v-card-title>
              </v-col>
              <v-col class="d-flex justify-end">
                <v-card-title>
                  <v-btn icon>
                    <v-icon size="28px" class="drag-icon">mdi-drag-variant</v-icon>
                  </v-btn>
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" @click="change_order_flag = true;" :disabled="disableChangeOrder">
                        
                            <v-icon size="28px">mdi-square-edit-outline</v-icon>
                        
                        </v-btn>
                    </template>
                                        <span>Change Order</span>
                  </v-tooltip>-->
                  <v-btn
                    fab
                    color="error"
                    x-small
                    @click="add_project_data_model = false;addProjectOrderValueLog(selectedRows[0].project_id,'end');"
                    class="custom-close-btn"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
              </v-col>
            </v-row>
            <v-row dense class="grey lighten-1 mb-1">
              <v-col cols="5" class="pa-0 ma-0">
                <v-row dense>
                  <v-col
                    cols="2"
                    class="pl-3"
                  >{{(selectedRows[0])?selectedRows[0].display_order_type:''}}</v-col>
                  <v-col cols="2">{{(selectedRows[0])?selectedRows[0].display_date:''}}</v-col>
                  <v-col
                    cols="4"
                  >{{(selectedRows[0] && selectedRows[0].customer)?selectedRows[0].customer.full_name:''}}</v-col>
                  <v-col cols="4">{{(selectedRows[0])?selectedRows[0].p_name:''}}</v-col>
                </v-row>
              </v-col>
              <v-col cols="7" class="text-right pa-0 ma-0">
                <v-row dense>
                  <v-col cols="3" class="text-left">
                    Invoiced :
                    <b>{{itemFormatWithDollar(project_invoice_amt)}}</b>
                  </v-col>
                  <v-col cols="3" class="text-left">
                    <span v-if="selected_item_job.length > 0">
                      Total :
                      <b>${{getTotalOfSelectedItems}}</b>
                    </span>
                  </v-col>
                  <v-col cols="3" class="text-left">
                    Pay.Due :
                    <b
                      style="cursor:pointer;"
                      @click="redirectToTransactionPayDue()"
                      :class="row_qty_rate_color(project_payment_due)"
                    >{{itemFormatWithDollar(project_payment_due)}}</b>
                  </v-col>
                  <v-col cols="3" class="text-left">
                    Order Value :
                    <b
                      :class="row_qty_rate_color(project_order_value)"
                    >{{itemFormatWithDollar(project_order_value)}}</b>
                  </v-col>
                </v-row>
              </v-col>
              <!-- <v-col cols="12">
                <span><b>Date:</b> {{(selectedRows[0])?selectedRows[0].display_date:''}}</span>
                <span class="ml-3"><b>{{(selectedRows[0])?selectedRows[0].display_order_type:''}}</b></span>
                <span class="ml-3"><b>Customer:</b> {{(selectedRows[0] && selectedRows[0].customer)?selectedRows[0].customer.full_name:''}}</span>
                <span class="ml-3"><b>Project:</b> {{(selectedRows[0])?selectedRows[0].p_name:''}}</span>
                <span class="ml-3"><b>Value:</b> </span>
                <span class="ml-6"><b>Invoiced:</b> </span>
                <span class="ml-6"><b>Pay. Due:</b> </span>
                <span class="ml-6"><b>Complated Dt:</b> {{(selectedRows[0])?selectedRows[0].estimated_completed_date:''}}</span>
              </v-col>-->
            </v-row>
            <v-row dense class="primary" style="padding-right: 10px;">
              <v-col cols="1" style="max-width: 2.5%">
                <template>
                  <v-simple-checkbox
                    v-model="select_all_checkbox"
                    @input="changeSelectAll()"
                    color="white"
                    v-if="!editModeRecord"
                    :ripple="false"
                    class="select-all-checkbox custom-simple-box"
                  ></v-simple-checkbox>
                </template>
              </v-col>
              <v-col
                cols="2"
                style="min-width: 25.9%; cursor:pointer;"
                @click="sortList('item_job_name')"
              >
                <span class="white--text">Item</span>
              </v-col>
              <v-col cols="2" style="max-width: 13%; cursor:pointer;" @click="sortList('V.v_code')">
                <span class="white--text">Vendor</span>
              </v-col>
              <v-col cols="2" style="max-width: 14%; cursor:pointer;" @click="sortList('A.name')">
                <span class="white--text">Area</span>
              </v-col>
              <v-col cols="1" style="max-width:5%" class="text-center">
                <span class="white--text">Des</span>
              </v-col>
              <v-col cols="1" style="max-width:6%;">
                <span class="white--text">Qty</span>
              </v-col>
              <v-col cols="1" style="max-width:8%">
                <span class="white--text">UOM</span>
              </v-col>
              <v-col cols="1" style="max-width:8%;" class="text-right">
                <span class="white--text">U/Px</span>
              </v-col>
              <v-col cols="1" style="min-width:8.8%;" class="text-right">
                <span class="white--text">Cost</span>
              </v-col>
              <v-col cols="1" style="min-width:8.8%;" class="text-right">
                <span class="white--text">Order Amt</span>
              </v-col>
            </v-row>
          </div>
          <div class="set-max-height-items" id="scroll_to_top">
            <v-form>
              <v-row dense v-for="(row_data, index) in add_project_data" :key="index">
                <v-col cols="1" style="max-width: 2.5%">
                  <v-simple-checkbox
                    v-model="row_data.selected"
                    :ripple="false"
                    class="custom-simple-box"
                    style="margin-top: 3px;"
                    :disabled="row_data.new_entry || editModeRecord"
                  ></v-simple-checkbox>
                </v-col>
                <v-col cols="1" style="min-width: 25.9%;">
                  <v-autocomplete
                    dense
                    v-model="row_data.item_job_id"
                    :items="item_list"
                    item-text="item_name"
                    item-value="item_id"
                    hide-details
                    @change="getItemDetails(index)"
                    :readonly="!row_data.edit_mode"
                    :error-messages="row_data.form_error.item_job_id"
                    :append-icon="(row_data.edit_mode)?(row_data.item_job_id)?'mdi-pencil':'mdi-plus-circle':''"
                    @click:append="(row_data.item_job_id)?editItem(index,row_data.item_job_id,false,row_data.vendor_id,'item',''):addItem(index,'')"
                  ></v-autocomplete>
                  <!-- <v-autocomplete
                    v-else
                    dense
                    v-model="row_data.item_job_id"
                    :items="job_list"
                    item-text="job_name"
                    item-value="job_id"
                    hide-details
                    @change="getJobDetails(index)"
                    :readonly="!row_data.edit_mode"
                    :error-messages="row_data.form_error.item_job_id"
                    :append-icon="(row_data.edit_mode)?(row_data.item_job_id)?'mdi-pencil':'mdi-plus-circle':''"
                    @click:append="(row_data.item_job_id)?editJob(index,row_data.item_job_id,false):addJob(index)"
                    >
                  </v-autocomplete>-->
                </v-col>
                <v-col cols="2" style="max-width: 13%">
                  <v-autocomplete
                    dense
                    hide-details
                    v-model="row_data.vendor_id"
                    :items="row_data.item_vendor_list"
                    item-text="vendor.v_name"
                    item-value="vendor_id"
                    @change="item_vendor_index=index,showVendorPopupInEdit(row_data.new_entry);"
                    :readonly="!row_data.edit_mode"
                    :error-messages="row_data.form_error.vendor_id"
                    :menu-props="{closeOnContentClick:true}"
                    :append-icon="row_data.edit_mode && row_data.item_job_id ? 'mdi-plus-circle' : ''"
                    @click:append="addVendorInItem(index,'project_data',row_data)"
                  >
                    <template v-slot:selection="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">{{ item.vendor.v_code }}</span>
                        </template>
                        <span>{{ item.vendor.v_name }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                  <!-- <v-autocomplete
                    v-else
                    dense
                    v-model="row_data.vendor_id"
                    :items="row_data.item_vendor_list"
                    item-text="v_name"
                    item-value="vendor_id"
                    hide-details
                    :readonly="!row_data.edit_mode"
                    :error-messages="row_data.form_error.vendor_id"
                    >
                    <template v-slot:selection="{ item }">
                    <v-tooltip bottom>
                    
                    <template v-slot:activator="{ on, attrs }">
                    
                              <span v-bind="attrs" v-on="on">{{ item.v_code }}</span>
                    </template>
                        <span>{{ item.v_name }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>-->
                </v-col>
                <v-col cols="2" style="max-width: 14%">
                  <v-autocomplete
                    dense
                    hide-details
                    v-model="row_data.area_id"
                    :items="getAreaByForm(project_data_flag)"
                    item-text="name"
                    item-value="area_id"
                    :readonly="!row_data.edit_mode"
                    :error-messages="row_data.form_error.area_id"
                    :menu-props="{closeOnContentClick:true}"
                    :search-input.sync="row_data.area_search"
                  >
                    <template v-slot:no-data v-if="row_data.area_search">
                      <div class="d-flex align-center">
                        <span
                          class="pl-2"
                          style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                        >No Area Found!</span>
                        <span
                          @click="addArea(project_data_flag,index)"
                          class="mdi mdi-plus-circle pl-1 pr-2"
                          style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                        ></span>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="1" style="max-width:5%">
                  <!-- <v-text-field
                    dense
                    hide-details
                    v-model="row_data.description"
                    :readonly="!row_data.edit_mode"
                    >
                  </v-text-field>-->
                  <div v-if="!row_data.edit_mode" class="text-center">
                    <v-tooltip left max-width="400" v-if="row_data.description">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-note-text-outline</v-icon>
                      </template>
                      <span>{{row_data.description}}</span>
                    </v-tooltip>
                  </div>
                  <div v-else class="text-center">
                    <v-menu
                      bottom
                      :close-on-content-click="false"
                      content-class="elevation-0"
                      v-model="description_box"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-note-text-outline</v-icon>
                      </template>
                      <v-card tile max-width="500" class="mb-5 mr-5">
                        <v-list class="filter-section-border pa-3">
                          <v-row dense>
                            <v-col cols="12">
                              <v-textarea
                                dense
                                hide-details
                                v-model="row_data.description"
                                outlined
                                rows="3"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-list>
                        <v-card-title class="pa-0">
                          <v-btn
                            fab
                            color="error"
                            x-small
                            absolute
                            @click="description_box = false"
                            class="custom-close-btn"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>
                      </v-card>
                    </v-menu>
                  </div>
                </v-col>
                <v-col cols="1" style="max-width:6%;">
                  <v-text-field
                    dense
                    hide-details
                    v-model="row_data.qty"
                    :readonly="!row_data.edit_mode"
                    :error-messages="row_data.form_error.qty"
                  ></v-text-field>
                </v-col>
                <v-col cols="1" style="max-width:8%">
                  <v-autocomplete
                    v-model="row_data.uom_id"
                    dense
                    :items="uom_list"
                    hide-details
                    :readonly="!row_data.edit_mode"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="1" style="max-width:8%;">
                  <v-tooltip bottom v-if="row_data.new_entry">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        hide-details
                        v-model="row_data.rate"
                        :readonly="!row_data.price_override"
                        :background-color="(!row_data.price_override)?'green lighten-5':''"
                        reverse
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <span>{{getOriginUpx(row_data)}}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        hide-details
                        v-model="row_data.rate"
                        :readonly="!row_data.price_override || !row_data.edit_mode|| row_data.price_override!='1'"
                        :background-color="(!row_data.price_override || !row_data.edit_mode || row_data.price_override!='1')?'green lighten-5':''"
                        reverse
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <span>{{getOriginUpx(row_data)}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="1" style="min-width:8.8%;">
                  <v-text-field
                    dense
                    hide-details
                    readonly
                    :value="getProjectDataAmt(row_data)"
                    background-color="green lighten-5"
                    reverse
                  ></v-text-field>
                </v-col>
                <v-col cols="1" style="min-width:8.8%;">
                  <v-text-field
                    dense
                    hide-details
                    readonly
                    :value="orderAmount(row_data)"
                    background-color="green lighten-5"
                    reverse
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <div>
            <v-row dense class="blue lighten-4 mt-1" style="font-size: 17px;">
              <v-col cols="5">
                <span class="pl-2">
                  <b>{{(selectedRows[0])?selectedRows[0].multiplier:''}}{{selectedRows[0] && selectedRows[0].p_price && selectedRows[0].multiplier ? ' / ' : ''}}{{(selectedRows[0])? selectedRows[0].p_price ? selectedRows[0].p_price: '':''}}</b>
                </span>
              </v-col>
              <v-col cols="3">
                <span class="pl-2">
                  Rec.Pay :
                  <b
                    style="cursor:pointer;"
                    @click="redirectToTransactionPayDue()"
                  >{{(project_received_value)? itemFormatWithDollar(parseFloat(project_received_value).toFixed(2)):'0.00'}}</b>
                </span>
              </v-col>
              <v-col cols="3" class="text-right">
                <span class="pr-2">
                  Total Ungrouped Amt:
                  <b>${{getProjectOrderAmount2}}</b>
                </span>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
      <AddItem />
      <EditItem />
      <!-- <AddJob />
      <EditJob />-->
    </v-dialog>
    <v-dialog max-width="1366px" v-model="cabinet_order_model" persistent>
      <v-card :loading="cabinet_order_loading">
        <v-row dense class="pa-0 ma-0">
          <v-col cols="2" class="pa-0 ma-0">
            <v-card-title>{{(cabinet_order_flag == 2)?'Closets':'Cabinet Order'}}</v-card-title>
          </v-col>
          <v-col cols="2" class="d-flex align-center" style="max-width: 12%;">
            <v-autocomplete
              v-if="change_orders.length > 0"
              label="Change Orders"
              clearable
              v-model="change_order_id"
              :items="change_orders"
              item-text="full_change_id"
              item-value="change_order_id"
              dense
              hide-details
              outlined
              @change="getChangeLogs()"
            ></v-autocomplete>
          </v-col>
          <v-col
            v-if="delete_change_order_flag"
            cols="1"
            class="d-flex align-center"
            style="min-width: 12%;"
          >
            <v-btn color="error" @click="delete_change_order_dialog = true;">Delete</v-btn>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-card-title>
              <v-menu
                bottom
                :close-on-content-click="false"
                content-class="elevation-0"
                v-model="cabinet_order_setting_flag"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mr-2" color="dark" icon v-bind="attrs" v-on="on">
                    <v-icon size="28px">mdi-cog-outline</v-icon>
                  </v-btn>
                </template>
                <v-card tile max-width="150" class="mb-5 mr-5">
                  <v-list class="filter-section-border">
                    <v-row dense class="pl-3 pr-3 pt-1">
                      <v-col cols="12">
                        <v-text-field
                          dense
                          flat
                          outlined
                          label="Assembly"
                          hide-details
                          class="body-2"
                          placeholder=" "
                          type="number"
                          v-model="cabinet_order_setting.assembly"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          flat
                          outlined
                          label="Delivery Charge"
                          hide-details
                          class="body-2"
                          placeholder=" "
                          type="number"
                          v-model="cabinet_order_setting.delivery_charge"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          dense
                          flat
                          outlined
                          label="Install"
                          hide-details
                          class="body-2"
                          placeholder=" "
                          type="number"
                          v-model="cabinet_order_setting.install"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          small
                          :disabled="change_order_id || is_enable_change_order"
                          @click="updateCabinetOrderSetting()"
                          block
                          color="primary"
                          class="text-capitalize"
                        >Update</v-btn>
                      </v-col>
                    </v-row>
                  </v-list>
                  <v-card-title class="pa-0">
                    <v-btn
                      fab
                      color="error"
                      x-small
                      absolute
                      @click="cabinet_order_setting_flag = false"
                      class="custom-close-btn"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                </v-card>
              </v-menu>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="change_order_flag = true;"
                    :disabled="disableChangeOrder"
                  >
                    <v-icon size="28px">mdi-square-edit-outline</v-icon>
                  </v-btn>
                </template>
                <span>Change Order</span>
              </v-tooltip>
              <v-btn
                fab
                color="error"
                x-small
                @click="cabinet_order_model = false"
                class="custom-close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-col>
        </v-row>
        <v-card-text>
          <v-form>
            <v-row dense class="grey lighten-1 mb-1">
              <v-col cols="7" class="pa-0 ma-0">
                <v-row dense>
                  <v-col
                    cols="2"
                    class="pl-3"
                  >{{(selectedRows[0])?selectedRows[0].display_order_type:''}}</v-col>
                  <v-col cols="2">{{(selectedRows[0])?selectedRows[0].display_date:''}}</v-col>
                  <v-col
                    cols="4"
                  >{{(selectedRows[0] && selectedRows[0].customer)?selectedRows[0].customer.full_name:''}}</v-col>
                  <v-col cols="4">{{(selectedRows[0])?selectedRows[0].p_name:''}}</v-col>
                </v-row>
              </v-col>
              <v-col cols="5" class="text-right pa-0 ma-0">
                <v-row dense>
                  <v-col cols="4" class="text-left"></v-col>
                  <v-col cols="4" class="text-left">Invoiced:</v-col>
                  <v-col cols="4" class="text-left">Payment Due:</v-col>
                </v-row>
              </v-col>
              <!-- <v-col cols="12">
                <span><b>Date:</b> {{(selectedRows[0])?selectedRows[0].display_date:''}}</span>
                <span class="ml-3"><b>{{(selectedRows[0])?selectedRows[0].display_order_type:''}}</b></span>
                <span class="ml-3"><b>Customer:</b> {{(selectedRows[0] && selectedRows[0].customer)?selectedRows[0].customer.full_name:''}}</span>
                <span class="ml-3"><b>Project:</b> {{(selectedRows[0])?selectedRows[0].p_name:''}}</span>
                <span class="ml-3"><b>Value:</b> </span>
                <span class="ml-6"><b>Invoiced:</b> </span>
                <span class="ml-6"><b>Pay. Due:</b> </span>
                <span class="ml-6"><b>Complated Dt:</b> {{(selectedRows[0])?selectedRows[0].estimated_completed_date:''}}</span>
              </v-col>-->
            </v-row>
            <v-row dense class="primary mt-2">
              <v-col class="d-flex align-center justify-center">
                <span class="white--text">Cabinet Selection</span>
              </v-col>
              <v-col
                cols="2"
                style="max-width: 12%;"
                class="d-flex align-center justify-end white--text"
              ></v-col>
              <v-col cols="1" style="max-width: 5%;" class="text-right">
                <v-icon
                  style="font-size: 26px;"
                  class="pr-1"
                  @click="addRemoveCabinetSelection('yes'); cabinet_selection_expand = true"
                  :disabled="editModeCabinetSelection || change_order_id || is_enable_change_order"
                  color="white"
                >mdi-plus-circle</v-icon>
                <v-icon
                  v-if="!cabinet_selection_expand"
                  @click="cabinet_selection_expand = !cabinet_selection_expand"
                  color="white"
                >mdi-chevron-down</v-icon>
                <v-icon
                  v-else
                  @click="cabinet_selection_expand = !cabinet_selection_expand"
                  color="white"
                >mdi-chevron-up</v-icon>
              </v-col>
            </v-row>
            <v-row
              dense
              v-for="(cabinet, index) in cabinet_selection"
              :key="index"
              class="mt-3"
              v-show="cabinet_selection_expand"
            >
              <v-col cols="1" style="max-width: 2.4%">
                <v-icon
                  :disabled="change_order_id || is_enable_change_order"
                  @click="addRemoveCabinetSelection('no',index)"
                >mdi-close-circle</v-icon>
              </v-col>
              <v-col cols="1" style="max-width: 2.4%">
                <v-radio-group
                  v-model="cabinet.default_cabinet"
                  row
                  hide-details
                  style="margin-top: -3px;"
                  dense
                  :disabled="cabinet.new_entry"
                  @change="changeDefaultCabinet(index);"
                >
                  <v-radio value="true" class="ma-0 pa-0"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="1" style="min-width: 10%;">
                <v-autocomplete
                  label="Wall Name"
                  dense
                  hide-details
                  v-model="cabinet.area_id"
                  :items="getAreaByForm(project_data_flag)"
                  item-text="name"
                  item-value="area_id"
                  :error-messages="cabinet.form_error.area_id"
                  placeholder=" "
                  :readonly="!cabinet.edit_mode"
                  :search-input.sync="cabinet.wall_name_search"
                  :menu-props="{closeOnContentClick:true}"
                >
                  <template v-slot:no-data>
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                      >No Wall Name Found!</span>
                      <span
                        @click="addArea(project_data_flag,index)"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                      ></span>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="1" style="max-width: 4.5%;">
                <v-text-field
                  label="Wall W."
                  dense
                  hide-details
                  v-model="cabinet.wall_length"
                  :error-messages="cabinet.form_error.wall_length"
                  placeholder=" "
                  :readonly="!cabinet.edit_mode"
                ></v-text-field>
              </v-col>
              <v-col cols="1" style="max-width: 4.5%;">
                <v-text-field
                  label="Wall H."
                  dense
                  hide-details
                  v-model="cabinet.wall_height"
                  :error-messages="cabinet.form_error.wall_height"
                  placeholder=" "
                  :readonly="!cabinet.edit_mode"
                ></v-text-field>
              </v-col>
              <v-col cols="1" style="min-width: 10%;">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="cabinet.cabinet_type_id"
                  :items="cabinet_type_list"
                  item-text="name"
                  item-value="cabinet_type_id"
                  :error-messages="cabinet.form_error.cabinet_type_id"
                  label="Type"
                  @change="getCabinetSelection(index,'width')"
                  placeholder=" "
                  :readonly="!cabinet.edit_mode"
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" style="max-width: 6%;">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="cabinet.width"
                  :items="cabinet.cabinet_width_list"
                  @change="getCabinetSelection(index,'depth')"
                  :error-messages="cabinet.form_error.width"
                  :readonly="!cabinet.cabinet_type_id || !cabinet.edit_mode"
                  label="W"
                  placeholder=" "
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" style="max-width: 6%;">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="cabinet.depth"
                  :items="cabinet.cabinet_depth_list"
                  @change="getCabinetSelection(index,'height')"
                  :error-messages="cabinet.form_error.depth"
                  :readonly="!cabinet.cabinet_type_id || !cabinet.width || !cabinet.edit_mode"
                  label="D"
                  placeholder=" "
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" style="max-width: 6%;">
                <v-autocomplete
                  label="H"
                  dense
                  :items="cabinet.cabinet_height_list"
                  hide-details
                  v-model="cabinet.cabinet_height"
                  @change="getCabinetSelection(index,'vendor')"
                  :error-messages="cabinet.form_error.cabinet_height"
                  :readonly="!cabinet.cabinet_type_id || !cabinet.width || !cabinet.depth || !cabinet.edit_mode"
                  placeholder=" "
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" style="max-width: 5%;" class="green-background-input">
                <v-text-field
                  dense
                  hide-details
                  label="Balance"
                  placeholder=" "
                  readonly
                  :value="(cabinet.cabinet_selection_id)?getBalance(cabinet):''"
                ></v-text-field>
              </v-col>
              <v-col cols="1" style="max-width: 8%;">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="cabinet.vendor_id"
                  :items="cabinet.cabinet_vendor_list"
                  @change="getCabinetSelection(index,'line')"
                  :error-messages="cabinet.form_error.vendor_id"
                  :readonly="!cabinet.cabinet_type_id || !cabinet.cabinet_height || !cabinet.depth || !cabinet.width || !cabinet.edit_mode"
                  label="Vendor"
                  placeholder=" "
                >
                  <template v-slot:selection="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{ item.v_code }}</span>
                      </template>
                      <span>{{ item.v_name }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="1" style="min-width: 10%;">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="cabinet.cabinet_line_id"
                  :items="cabinet.cabinet_line_list"
                  :error-messages="cabinet.form_error.cabinet_line_id"
                  :readonly="!cabinet.cabinet_type_id || !cabinet.cabinet_height || !cabinet.depth || !cabinet.width || !cabinet.vendor_id || !cabinet.edit_mode"
                  @change="getCabinetSelection(index,'color')"
                  label="Cabinet Line"
                  placeholder=" "
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" style="min-width: 10%;">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="cabinet.cabinet_color_id"
                  :items="cabinet.cabinet_color_list"
                  :error-messages="cabinet.form_error.cabinet_color_id"
                  :readonly="!cabinet.cabinet_type_id || !cabinet.cabinet_height || !cabinet.depth || !cabinet.width || !cabinet.vendor_id || !cabinet.cabinet_line_id || !cabinet.edit_mode"
                  label="Color"
                  placeholder=" "
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" style="min-width: 10%;">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="cabinet.cabinet_style_id"
                  :items="cabinet_style_list"
                  item-text="name"
                  item-value="cabinet_style_id"
                  :error-messages="cabinet.form_error.cabinet_style_id"
                  label="Cabinet Style"
                  placeholder=" "
                  :readonly="!cabinet.edit_mode"
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" style="max-width: 5%" class="text-right">
                <v-icon v-if="cabinet.edit_mode" @click="saveProjectCabinet(index)">mdi-content-save</v-icon>
                <v-icon
                  v-if="!cabinet.edit_mode"
                  @click="cabinet_order_loading = true; cabinet.edit_mode = true; cabinet_order_loading = false"
                  :disabled="editModeCabinetSelection || change_order_id || is_enable_change_order"
                >mdi-border-color</v-icon>
                <v-icon
                  v-if="cabinet.edit_mode && !cabinet.new_entry"
                  @click="resetProjectCabinet(index)"
                >mdi-reload</v-icon>
              </v-col>
            </v-row>
            <v-row dense class="primary mt-2">
              <v-col class="d-flex align-center justify-center">
                <span
                  class="white--text"
                >{{(cabinet_order_flag == 2)?'Closets Entry':'Cabinet Order Entry'}}</span>
              </v-col>
              <v-col
                cols="2"
                style="max-width: 12%;"
                class="d-flex align-center justify-end white--text"
              ></v-col>
              <v-col v-if="!view_cabinet_order_screen" cols="1" style="max-width: 5%;">
                <v-icon
                  @click="view_cabinet_order_screen = true"
                  :disabled="totalCabinetSelection == 0 || change_order_id || is_enable_change_order"
                  style="padding-left: 6px; font-size: 26px;"
                  color="white"
                >mdi-plus-circle</v-icon>
              </v-col>
              <v-col v-else cols="1" style="max-width: 5%;" class="text-right">
                <v-icon
                  @click="view_cabinet_order_screen = false; resetCabinetOrderData();"
                  color="white"
                >mdi-close</v-icon>
              </v-col>
            </v-row>
            <v-row dense class="mt-3" v-if="view_cabinet_order_screen">
              <v-col cols="1" class="green-background-input" style="min-width: 11%;">
                <!-- <v-autocomplete
                  label="Wall Name"
                  dense
                  hide-details
                  v-model="cabinet_order_data.area_id"
                  :items="selected_cabinet"
                  :error-messages="cabinet_order_error.area_id"
                  placeholder=" "
                  @change="getSelectedCabinetType()"
                  >
                </v-autocomplete>-->
                <v-text-field
                  label="Wall Name"
                  dense
                  hide-details
                  v-model="cabinet_order_data.area_name"
                  :error-messages="cabinet_order_error.area_name"
                  placeholder=" "
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="1" style="min-width: 11%;" class="ml-1 green-background-input">
                <!-- <v-autocomplete
                  label="Cabinet Type"
                  dense
                  hide-details
                  v-model="cabinet_order_data.cabinet_type_id"
                  :items="cabinet_order_type_list"
                  :error-messages="cabinet_order_error.cabinet_type_id"
                  placeholder=" "
                  @change="changeCabinetType()"
                  >
                </v-autocomplete>-->
                <v-text-field
                  label="Cabinet Type"
                  dense
                  hide-details
                  v-model="cabinet_order_data.cabinet_type_name"
                  :error-messages="cabinet_order_error.cabinet_type_name"
                  placeholder=" "
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="1" style="max-width: 7%;" class="ml-1">
                <v-autocomplete
                  label="W"
                  dense
                  hide-details
                  :items="cabinet_order_data.cabinet_width_list"
                  v-model="cabinet_order_data.w"
                  :error-messages="cabinet_order_error.w"
                  placeholder=" "
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" style="max-width: 7%;" class="ml-1">
                <v-text-field
                  label="M-W"
                  dense
                  hide-details
                  v-model="cabinet_order_data.mw"
                  :error-messages="cabinet_order_error.mw"
                  placeholder=" "
                  :disabled="!cabinet_order_data.modify_flag"
                ></v-text-field>
              </v-col>
              <v-col class="ml-1">
                <v-text-field
                  label="Special Note"
                  dense
                  hide-details
                  v-model="cabinet_order_data.special_note"
                  :error-messages="cabinet_order_error.special_note"
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="ml-1" style="max-width: 23.1%; margin-top: -8px;">
                <v-btn
                  :disabled="!cabinet_order_data.accessory"
                  @click="add_accessory_flag = true; add_item_accessory_flag = 1; resetAccessoryItemData();"
                  style="font-weight: normal;"
                  color="grey"
                  class="text-capitalize rounded-5"
                >
                  <v-icon left>mdi-plus</v-icon>Accessory
                </v-btn>
                <v-btn
                  style="font-weight: normal;"
                  @click="add_accessory_flag = true; add_item_accessory_flag = 2; resetAccessoryItemData();"
                  color="grey"
                  class="text-capitalize rounded-5 ml-2"
                >
                  <v-icon left>mdi-plus</v-icon>Item
                </v-btn>
                <v-btn
                  @click="accessoryItemList()"
                  style="font-weight: normal;"
                  color="primary"
                  class="text-capitalize rounded-0 ml-2"
                >List</v-btn>
              </v-col>
            </v-row>
            <v-row dense v-if="view_cabinet_order_screen">
              <v-col cols="3" class="mt-2 green-background-input" style="max-width: 22.3%;">
                <v-text-field
                  label="Item"
                  dense
                  v-model="cabinet_order_data.item_name"
                  hide-details
                  :error-messages="cabinet_order_error.item_name"
                  placeholder=" "
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-1 green-background-input mt-2" style="max-width: 7%;">
                <v-text-field
                  label="D"
                  dense
                  hide-details
                  v-model="cabinet_order_data.d"
                  :error-messages="cabinet_order_error.d"
                  placeholder=" "
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-1 mt-3" style="max-width: 7%;">
                <v-text-field
                  label="M-D"
                  dense
                  hide-details
                  v-model="cabinet_order_data.md"
                  :error-messages="cabinet_order_error.md"
                  placeholder=" "
                  :disabled="!cabinet_order_data.modify_flag"
                ></v-text-field>
              </v-col>
              <v-col
                cols="6"
                v-if="add_accessory_flag && add_item_accessory_flag == 1"
                class="pt-0 mt-1 ml-2"
              >
                <v-row dense class="pt-0 mt-0" style="border: 1px solid #808080a1;">
                  <v-col>
                    <v-autocomplete
                      class="mt-3"
                      label="Accessory"
                      dense
                      v-model="cabinet_accessory_item_data.accessory_item_id"
                      :items="accessory_list"
                      item-text="name"
                      item-value="cabinet_id"
                      @change="changeAccessory()"
                      hide-details
                      placeholder=" "
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="2" class="ml-1" style="max-width: 15%">
                    <v-autocomplete
                      class="mt-3"
                      label="Qty"
                      dense
                      :items="order_qty_list"
                      v-model="cabinet_accessory_item_data.qty"
                      hide-details
                      placeholder=" "
                      @change="changeAccessoryItemQty()"
                      v-if="!cabinet_accessory_item_data.custom_qty_flag"
                    ></v-autocomplete>
                    <v-text-field
                      class="mt-3"
                      label="Qty"
                      dense
                      v-model="cabinet_accessory_item_data.qty"
                      hide-details
                      placeholder=" "
                      @click:append="cabinet_accessory_item_data.qty = null; cabinet_accessory_item_data.custom_qty_flag = false;"
                      append-icon="mdi-form-select"
                      v-else
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="2"
                    class="ml-1 green-background-input"
                    style="padding-top: 7px !important; margin-top: 4px !important; padding-bottom: 0px !important; margin-bottom: 2px !important; max-width: 15%;"
                  >
                    <v-text-field
                      label="Price"
                      dense
                      v-model="cabinet_accessory_item_data.price"
                      hide-details
                      placeholder=" "
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="ml-1" style="max-width: 10%;">
                    <v-btn
                      @click="addAccessoryItem();"
                      :disabled="!cabinet_accessory_item_data.accessory_item_id || !cabinet_accessory_item_data.qty"
                      block
                      style="font-weight: normal;"
                      color="grey"
                      class="text-capitalize rounded-5"
                    >Add</v-btn>
                  </v-col>
                  <v-col cols="1" style="max-width: 6.5%;">
                    <v-icon
                      @click="add_accessory_flag = false; resetAccessoryItemData();"
                      style="cursor:pointer;"
                    >mdi-close-circle mdi-36px</v-icon>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-if="add_accessory_flag && add_item_accessory_flag == 2"
                class="pt-0 mt-1 ml-2"
              >
                <v-row dense class="pt-0 mt-0" style="border: 1px solid #808080a1;">
                  <v-col>
                    <v-autocomplete
                      class="mt-3"
                      label="Item"
                      dense
                      v-model="cabinet_accessory_item_data.accessory_item_id"
                      :items="item_list"
                      item-text="item_name"
                      item-value="item_id"
                      @change="getItemDetails3()"
                      hide-details
                      placeholder=" "
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="3" style="min-width: 30%" class="ml-1">
                    <v-autocomplete
                      class="mt-3"
                      label="Vendor"
                      dense
                      hide-details
                      v-model="cabinet_accessory_item_data.vendor_id"
                      :items="cabinet_accessory_item_data.item_vendor_list"
                      item-text="vendor.v_name"
                      item-value="vendor_id"
                      @change="changeVendor5()"
                      placeholder=" "
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="1" style="min-width: 12%;" class="ml-1">
                    <v-autocomplete
                      class="mt-3"
                      label="Qty"
                      dense
                      :items="order_qty_list"
                      v-model="cabinet_accessory_item_data.qty"
                      hide-details
                      placeholder=" "
                      @change="changeAccessoryItemQty()"
                      v-if="!cabinet_accessory_item_data.custom_qty_flag"
                    ></v-autocomplete>
                    <v-text-field
                      class="mt-3"
                      label="Qty"
                      dense
                      v-model="cabinet_accessory_item_data.qty"
                      hide-details
                      placeholder=" "
                      @click:append="cabinet_accessory_item_data.qty = null; cabinet_accessory_item_data.custom_qty_flag = false;"
                      append-icon="mdi-form-select"
                      v-else
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="1"
                    class="ml-1 green-background-input"
                    style="padding-top: 7px !important; margin-top: 4px !important; padding-bottom: 0px !important; margin-bottom: 2px !important; min-width: 11%;"
                  >
                    <v-text-field
                      label="Price"
                      dense
                      v-model="cabinet_accessory_item_data.price"
                      hide-details
                      placeholder=" "
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1" class="ml-1">
                    <v-btn
                      @click="addAccessoryItem();"
                      :disabled="!cabinet_accessory_item_data.accessory_item_id || !cabinet_accessory_item_data.qty || !cabinet_accessory_item_data.vendor_id"
                      block
                      style="font-weight: normal;"
                      color="grey"
                      class="text-capitalize rounded-5"
                    >Add</v-btn>
                  </v-col>
                  <v-col cols="1" style="max-width: 5%;">
                    <v-icon
                      @click="add_accessory_flag = false; resetAccessoryItemData();"
                      style="cursor:pointer;"
                    >mdi-close-circle mdi-36px</v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row dense v-if="view_cabinet_order_screen">
              <v-col
                cols="1"
                v-if="!cabinet_order_data.custom_order_qty"
                :class="(add_accessory_flag)?'margin-top-6':'mt-3'"
              >
                <v-autocomplete
                  label="Order Qty"
                  dense
                  hide-details
                  :items="order_qty_list"
                  v-model="cabinet_order_data.order_qty"
                  :error-messages="cabinet_order_error.order_qty"
                  @change="changeOrderQty()"
                  placeholder=" "
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" v-else :class="(add_accessory_flag)?'margin-top-6':'mt-3'">
                <v-text-field
                  label="Order Qty"
                  dense
                  hide-details
                  v-model="cabinet_order_data.order_qty"
                  :error-messages="cabinet_order_error.order_qty"
                  placeholder=" "
                  @click:append="cabinet_order_data.order_qty = null; cabinet_order_data.custom_order_qty = false;"
                  append-icon="mdi-form-select"
                ></v-text-field>
              </v-col>
              <v-col
                cols="2"
                :class="(add_accessory_flag)?'margin-top--2':'mt-1'"
                class="ml-1"
                style="max-width: 13.7%;"
              >
                <v-btn
                  :disabled="!cabinet_order_data.modify"
                  style="font-weight: normal; padding: unset;"
                  block
                  v-if="!cabinet_order_data.modify_flag"
                  @click="cabinet_order_data.modify_flag = !cabinet_order_data.modify_flag; changeModify();"
                  color="grey"
                  class="text-capitalize rounded-0"
                >Modify</v-btn>
                <v-btn
                  :disabled="!cabinet_order_data.modify"
                  style="font-weight: normal; padding: unset;"
                  block
                  v-else
                  @click="cabinet_order_data.modify_flag = !cabinet_order_data.modify_flag; changeModify()"
                  color="blue-grey darken-2"
                  class="text-capitalize rounded-0 white--text"
                >Modify</v-btn>
              </v-col>
              <v-col
                cols="1"
                class="ml-1 green-background-input"
                :class="(add_accessory_flag)?'margin-top-2':'mt-2'"
                style="max-width: 7%;"
              >
                <v-text-field
                  label="H"
                  dense
                  hide-details
                  v-model="cabinet_order_data.h"
                  :error-messages="cabinet_order_error.h"
                  placeholder=" "
                  readonly
                ></v-text-field>
              </v-col>
              <v-col
                cols="1"
                class="ml-1"
                :class="(add_accessory_flag)?'margin-top-6':'mt-3'"
                style="max-width: 7%;"
              >
                <v-text-field
                  label="M-H"
                  dense
                  hide-details
                  v-model="cabinet_order_data.mh"
                  :error-messages="cabinet_order_error.mh"
                  placeholder=" "
                  :disabled="!cabinet_order_data.modify_flag"
                ></v-text-field>
              </v-col>
              <v-col
                cols="1"
                class="ml-1 green-background-input"
                :class="(add_accessory_flag)?'margin-top-2':'mt-2'"
                style="max-width: 7%;"
              >
                <v-text-field
                  label="Price"
                  dense
                  hide-details
                  v-model="cabinet_order_data.price"
                  :error-messages="cabinet_order_error.price"
                  placeholder=" "
                  readonly
                ></v-text-field>
              </v-col>
              <v-col
                cols="3"
                :class="(add_accessory_flag)?'margin-top--2':'mt-1'"
                style="margin-left: 6px;"
              >
                <v-card outlined>
                  <v-row dense>
                    <v-col cols="4" class="d-flex align-center justify-center grey">Finished End</v-col>
                    <v-col cols="8">
                      <v-radio-group
                        v-model="cabinet_order_data.finished_end"
                        row
                        dense
                        hide-details
                        class="pa-0 ma-0 mt-1"
                        :error-messages="cabinet_order_error.finished_end"
                      >
                        <v-radio label="Left" value="1" class="pa-0 ma-0 radio-margin"></v-radio>
                        <v-radio label="Right" value="2" class="pa-0 ma-0 pl-1 radio-margin"></v-radio>
                        <v-radio label="Both" value="3" class="pa-0 ma-0 pl-1 radio-margin"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col
                cols="2"
                :class="(add_accessory_flag)?'margin-top--2':'mt-1'"
                class="ml-1"
                style="max-width: 15.3%;"
              >
                <v-card outlined>
                  <v-row dense>
                    <v-col cols="3" class="d-flex align-center justify-center grey">Hing</v-col>
                    <v-col cols="9">
                      <v-radio-group
                        v-model="cabinet_order_data.hing"
                        row
                        dense
                        hide-details
                        class="pa-0 ma-0 mt-1"
                        :error-messages="cabinet_order_error.hing"
                      >
                        <v-radio label="Left" value="1" class="pa-0 ma-0 radio-margin"></v-radio>
                        <v-radio label="Right" value="2" class="pa-0 ma-0 pl-1 radio-margin"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row dense v-if="view_cabinet_order_screen" class="mt-3">
              <v-col cols="1" class="d-flex justify-end">
                <v-switch
                  class="pt-0 ma-0"
                  dense
                  v-model="cabinet_order_data.assembly"
                  label="Assembly"
                  color="success"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="2" style="max-width: 13.8%;" class="d-flex justify-end">
                <v-switch
                  class="pt-0 ma-0"
                  dense
                  v-model="cabinet_order_data.delivery_charge"
                  label="Delivery Charge"
                  color="success"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="3" class="d-flex justify-end ml-1">
                <v-autocomplete
                  label="Install"
                  dense
                  hide-details
                  :items="vendor_list"
                  item-text="v_name"
                  item-value="vendor_id"
                  v-model="cabinet_order_data.install"
                  clearable
                  placeholder=" "
                ></v-autocomplete>
              </v-col>
              <v-col cols="2" style="margin-top: -8px;" class="ml-1">
                <v-btn
                  :disabled="change_order_id || is_enable_change_order"
                  v-if="!edit_cabinet_order_flag"
                  @click="saveCabinetOrder()"
                  style="font-weight: normal;"
                  color="primary"
                  class="text-capitalize rounded-0"
                >Add</v-btn>
                <v-btn
                  :disabled="change_order_id || is_enable_change_order"
                  v-else
                  @click="updateProjectCabinetOrder()"
                  style="font-weight: normal;"
                  color="primary"
                  class="text-capitalize rounded-0"
                >Save</v-btn>
                <v-btn
                  v-if="!edit_cabinet_order_flag"
                  style="font-weight: normal;"
                  @click="resetCabinetOrderData()"
                  color="error"
                  class="text-capitalize rounded-0 ml-2"
                >Reset</v-btn>
                <v-btn
                  v-else
                  style="font-weight: normal;"
                  @click="editCabinetOrder(edit_product_cab_o_id)"
                  color="error"
                  class="text-capitalize rounded-0 ml-2"
                >Reset</v-btn>
              </v-col>
            </v-row>
            <v-row dense class="primary mt-2">
              <v-col class="d-flex align-center justify-center">
                <span
                  class="white--text"
                >{{(cabinet_order_flag == 2)?'Closets List':'Cabinet Order List'}}</span>
              </v-col>
              <v-col
                cols="2"
                style="max-width: 12%;"
                class="d-flex align-center justify-end white--text"
              >Total: ${{totalCabinetOrderAmount}}</v-col>
              <v-col cols="1" style="max-width: 5%;" class="text-right">
                <v-icon
                  v-if="!cabinet_order_list_expand"
                  @click="cabinet_order_list_expand = !cabinet_order_list_expand"
                  color="white"
                >mdi-chevron-down</v-icon>
                <v-icon
                  v-else
                  @click="cabinet_order_list_expand = !cabinet_order_list_expand"
                  color="white"
                >mdi-chevron-up</v-icon>
              </v-col>
            </v-row>
            <v-row dense v-show="cabinet_order_list_expand">
              <v-col cols="12" class="pa-0 ma-0">
                <v-simple-table dense class="fix-table-layout">
                  <thead style="background: #455a64;">
                    <tr>
                      <th class="text-center white--text" width="4%"></th>
                      <th class="text-center white--text" width="16%">Wall Name</th>
                      <th class="white--text" width="16%">Cabinet Type</th>
                      <th class="text-center white--text" width="7%">W</th>
                      <th class="text-center white--text" width="7%">H</th>
                      <th class="text-center white--text" width="7%">D</th>
                      <th class="text-center white--text" width="8%">Finished End</th>
                      <th class="text-center white--text" width="7%">Hing</th>
                      <th class="text-center white--text" width="7%">Order Qty</th>
                      <th class="text-right white--text" width="7%">Price</th>
                      <th class="text-right white--text" width="8%">Amount</th>
                      <th class="text-center white--text" width="6%"></th>
                    </tr>
                  </thead>
                  <tbody v-for="(cabinet_row, index) in cabinet_order_list" :key="index">
                    <tr>
                      <td class="custom-border-table text-center">
                        <v-icon
                          :disabled="change_order_id || is_enable_change_order"
                          @click="removeCabinetOrder(cabinet_row.product_cab_o_id)"
                        >mdi-close-circle</v-icon>
                      </td>
                      <td
                        class="custom-border-table text-center"
                      >{{(cabinet_row.area)?cabinet_row.area.name:''}}</td>
                      <td
                        class="custom-border-table"
                      >{{(cabinet_row.cabinet_type)?cabinet_row.cabinet_type.name:''}}</td>
                      <td
                        class="custom-border-table text-center"
                      >{{(cabinet_row.modify_flag)?cabinet_row.mw:cabinet_row.w}}</td>
                      <td
                        class="custom-border-table text-center"
                      >{{(cabinet_row.modify_flag)?cabinet_row.mh:cabinet_row.h}}</td>
                      <td
                        class="custom-border-table text-center"
                      >{{(cabinet_row.modify_flag)?cabinet_row.md:cabinet_row.d}}</td>
                      <td
                        class="custom-border-table text-center"
                      >{{getFinishedEnd(cabinet_row.finished_end)}}</td>
                      <td class="custom-border-table text-center">{{getHing(cabinet_row.hing)}}</td>
                      <td class="custom-border-table text-center">{{cabinet_row.order_qty}}</td>
                      <td class="custom-border-table text-right">{{cabinet_row.price}}</td>
                      <td class="custom-border-table text-right">
                        <v-tooltip left max-width="400" v-if="cabinet_row.special_note">
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                            >{{getCabinetOrderDiscountAmt(getCabinetOrderAmount(cabinet_row))}}</span>
                          </template>
                          <span>{{getCabinetOrderAmount(cabinet_row)}}</span>
                        </v-tooltip>
                      </td>
                      <td class="custom-border-table text-right pr-1">
                        <v-tooltip left max-width="400" v-if="cabinet_row.special_note">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">mdi-note-text-outline</v-icon>
                          </template>
                          <span>{{cabinet_row.special_note}}</span>
                        </v-tooltip>
                        <v-icon
                          :disabled="change_order_id || is_enable_change_order"
                          @click="editCabinetOrder(cabinet_row.product_cab_o_id)"
                        >mdi-border-color</v-icon>
                      </td>
                    </tr>
                    <tr
                      class="green-background-row"
                      v-for="(acc_item_row, index2) in cabinet_row.accessory_items"
                      :key="index2"
                    >
                      <td class="custom-border-table text-center">
                        <v-icon
                          :disabled="change_order_id || is_enable_change_order"
                          @click="removeAccessoryItem(acc_item_row,'list')"
                        >mdi-close-circle</v-icon>
                      </td>
                      <td
                        class="custom-border-table text-center"
                      >{{(acc_item_row.item_accessory_flag == 1)?'Accessory':'Item'}}</td>
                      <td
                        class="custom-border-table"
                        colspan="2"
                      >{{(acc_item_row.item_accessory_flag == 1)?acc_item_row.accessory.name:acc_item_row.item.item_name}}</td>
                      <td
                        class="custom-border-table"
                        colspan="4"
                      >{{(acc_item_row.item_accessory_flag == 2)?acc_item_row.vendor.v_name:''}}</td>
                      <td class="custom-border-table text-center">{{acc_item_row.qty}}</td>
                      <td class="custom-border-table text-right">${{acc_item_row.price}}</td>
                      <td
                        class="custom-border-table text-right"
                      >${{(acc_item_row.qty * acc_item_row.price).toFixed(2)}}</td>
                      <td class="custom-border-table text-right pr-1"></td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row dense class="blue lighten-4 mt-1" style="font-size: 17px;">
              <v-col cols="2" class="pl-3" style="max-width: 10%;">
                Multiplier:
                <b>{{(selectedRows[0])?selectedRows[0].multiplier:''}}</b>
              </v-col>
              <v-col cols="1">
                <v-icon @click="openDiscountDialog()">mdi-sale</v-icon>
                <span class="pl-1" @click="openDiscountDialog()" style="cursor:pointer;">Discount</span>
              </v-col>
              <v-col cols="2" style="max-width: 16%;">
                Order Amount:
                <b>${{totalCabinetOrderAmount}}</b>
              </v-col>
              <v-col cols="2" style="max-width: 17%;">
                Discount Amount:
                <b>${{getCabinetOrderDiscount}}</b>
              </v-col>
              <v-col cols="2" style="max-width: 16%;">
                Final Amount:
                <b>${{getCabinetOrderFinelAmount}}</b>
              </v-col>
              <v-col cols="1" style="min-width: 11%;">
                Assembly:
                <b>{{totalAssembly}}</b>
              </v-col>
              <v-col cols="1" style="min-width: 13.5%;">
                Delivery Charge:
                <b>{{totalDeliveryCharge}}</b>
              </v-col>
              <v-col cols="1" style="min-width: 8.5%;">
                Install:
                <b>{{totalInstall}}</b>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog max-width="1366px" v-model="add_counter_top_model" persistent>
      <v-card :loading="add_counter_top_loading">
        <v-row dense class="pa-0 ma-0">
          <v-col cols="2" class="pa-0 ma-0">
            <v-card-title>Counter Top Order</v-card-title>
          </v-col>
          <v-col cols="1" class="d-flex align-center" style="min-width: 12%;">
            <v-autocomplete
              v-if="change_orders.length > 0"
              label="Change Orders"
              clearable
              v-model="change_order_id"
              :items="change_orders"
              item-text="full_change_id"
              item-value="change_order_id"
              dense
              hide-details
              outlined
              @change="getChangeLogs()"
            ></v-autocomplete>
          </v-col>
          <v-col
            v-if="delete_change_order_flag"
            cols="1"
            class="d-flex align-center"
            style="min-width: 12%;"
          >
            <v-btn color="error" @click="delete_change_order_dialog = true;">Delete</v-btn>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-card-title>
              <v-btn icon>
                <v-icon size="28px" class="drag-icon">mdi-drag-variant</v-icon>
              </v-btn>
              <v-btn
                fab
                color="error"
                x-small
                @click="add_counter_top_model = false;addProjectOrderValueLog(selectedRows[0].project_id,'end');"
                class="custom-close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-col>
        </v-row>
        <v-card-text>
          <v-form>
            <v-row dense class="grey lighten-1 mb-1">
              <v-col cols="7" class="pa-0 ma-0">
                <v-row dense>
                  <v-col
                    cols="2"
                    class="pl-3"
                  >{{(selectedRows[0])?selectedRows[0].display_order_type:''}}</v-col>
                  <v-col cols="2">{{(selectedRows[0])?selectedRows[0].display_date:''}}</v-col>
                  <v-col
                    cols="4"
                  >{{(selectedRows[0] && selectedRows[0].customer)?selectedRows[0].customer.full_name:''}}</v-col>
                  <v-col cols="4">{{(selectedRows[0])?selectedRows[0].p_name:''}}</v-col>
                </v-row>
              </v-col>
              <v-col cols="5" class="text-right pa-0 ma-0">
                <v-row dense>
                  <v-col cols="4" class="text-left"></v-col>
                  <v-col cols="4" class="text-left">Invoiced:</v-col>
                  <v-col cols="4" class="text-left">Payment Due:</v-col>
                </v-row>
              </v-col>
              <!-- <v-col cols="12">
                <span><b>Date:</b> {{(selectedRows[0])?selectedRows[0].display_date:''}}</span>
                <span class="ml-3"><b>{{(selectedRows[0])?selectedRows[0].display_order_type:''}}</b></span>
                <span class="ml-3"><b>Customer:</b> {{(selectedRows[0] && selectedRows[0].customer)?selectedRows[0].customer.full_name:''}}</span>
                <span class="ml-3"><b>Project:</b> {{(selectedRows[0])?selectedRows[0].p_name:''}}</span>
                <span class="ml-3"><b>Value:</b> </span>
                <span class="ml-6"><b>Invoiced:</b> </span>
                <span class="ml-6"><b>Pay. Due:</b> </span>
                <span class="ml-6"><b>Complated Dt:</b> {{(selectedRows[0])?selectedRows[0].estimated_completed_date:''}}</span>
              </v-col>-->
            </v-row>
            <!-- <v-row dense="" class="primary">
              <v-col cols="2" class="d-flex align-center justify-center">
                <span class="white--text">Stone Group</span>
              </v-col>
              <v-col cols="3" class="d-flex align-center justify-center">
                <span class="white--text">Stone</span>
              </v-col>
              <v-col class="d-flex align-center justify-center">
                <span class="white--text">Vendor</span>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-center">
                <span class="white--text">Price</span>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-center">
                <span class="white--text">Stock / Qty</span>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-center">
                <span class="white--text">Sale Qty</span>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-center" style="max-width: 3%">
                <v-icon @click="addRemoveStone('yes')" color="white">mdi-plus-circle</v-icon>
              </v-col>
            </v-row>-->
            <v-row dense class="primary mt-2">
              <v-col class="d-flex align-center justify-center">
                <span class="white--text">Stone Selection</span>
              </v-col>
              <v-col
                cols="2"
                style="max-width: 12%;"
                class="d-flex align-center justify-end white--text"
              ></v-col>
              <v-col cols="1" style="max-width: 5%;" class="text-right">
                <v-icon
                  style="font-size: 26px;"
                  class="pr-1"
                  @click="addRemoveStone('yes'); stone_selection_expand = true"
                  :disabled="editModeRecord2 || change_order_id || is_enable_change_order"
                  color="white"
                >mdi-plus-circle</v-icon>
                <v-icon
                  v-if="!stone_selection_expand"
                  @click="stone_selection_expand = !stone_selection_expand"
                  color="white"
                >mdi-chevron-down</v-icon>
                <v-icon
                  v-else
                  @click="stone_selection_expand = !stone_selection_expand"
                  color="white"
                >mdi-chevron-up</v-icon>
              </v-col>
            </v-row>
            <v-row
              dense
              v-for="(stone, index) in stone_data"
              :key="index"
              class="mt-3"
              v-show="stone_selection_expand"
            >
              <v-col cols="1" style="max-width: 3%">
                <v-icon
                  :disabled="change_order_id || is_enable_change_order"
                  v-if="useStoneInCounter(stone.stone_id,stone.new_entry)"
                  @click="addRemoveStone('no',index)"
                >mdi-close-circle</v-icon>
              </v-col>
              <!-- <v-col>
                <v-autocomplete 
                  v-model="stone.group_id"
                  dense
                  :items="stone_group_list"
                  hide-details
                  @change="getStone(index)"
                  label="Stone Group" 
                  :error-messages="stone.form_error.group_id"
                  placeholder=" "
                  :readonly="!stone.edit_mode"
                >
                </v-autocomplete>
              </v-col>-->
              <v-col cols style="max-width: 35%;" class="ml-2">
                <v-autocomplete
                  dense
                  v-model="stone.stone_id"
                  :items="group_stone_list"
                  item-text="item_name"
                  item-value="item_id"
                  hide-details
                  @change="getStoneDetails(index);"
                  :error-messages="stone.form_error.stone_id"
                  label="Stone"
                  placeholder=" "
                  :readonly="!stone.edit_mode"
                  :append-icon="(stone.edit_mode)?(stone.stone_id)?'mdi-pencil':'mdi-plus-circle':''"
                  @click:append="(stone.stone_id)?editItem(index,stone.stone_id,false,stone.vendor_id,'item','stone'):addItem(index,'stone')"
                >
                  <template v-slot:selection="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{ item.item_name }}</span>
                      </template>
                      <span>{{ item.item_name }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:no-data>
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="
                        font-size: 0.8125rem;
                        font-weight: 500;
                        line-height: 1rem;
                        "
                      >No Stone Found!</span>
                      <span
                        @click="addStone"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="
                        font-size: 1.5rem;
                        cursor: pointer;
                        color: #6e9a35 !important;
                        "
                      ></span>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="3" style="max-width: 30%;" class="ml-2">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="stone.vendor_id"
                  :items="stone.stone_vendor_list"
                  :error-messages="stone.form_error.vendor_id"
                  item-text="vendor.v_name"
                  item-value="vendor_id"
                  @change="changeVendor2(index)"
                  label="Vendor"
                  placeholder=" "
                  :readonly="!stone.edit_mode"
                  :menu-props="{closeOnContentClick:true}"
                  :append-icon="stone.edit_mode && stone.stone_id ? 'mdi-plus-circle' : ''"
                  @click:append="addVendorInItem(index,'stone',stone)"
                >
                  <template v-slot:selection="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{ item.vendor.v_code }}</span>
                      </template>
                      <span>{{ item.vendor.v_name }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:no-data v-if="stone.stone_id">
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                      >No Vendor Found!</span>
                      <span
                        @click="addVendorInItem(index,'stone')"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                      ></span>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                cols="1"
                v-if="stone.new_entry"
                class="ml-2"
                :class="(!stone.price_override)?'green-background-input':''"
              >
                <v-text-field
                  dense
                  hide-details
                  v-model="stone.standard_price"
                  :readonly="!stone.price_override"
                  label="Unit Price"
                  @input="changeSalesPrice(index)"
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col
                cols="1"
                v-else
                class="ml-2"
                :class="(stone.edit_mode && stone.price_override)?'':'green-background-input'"
              >
                <v-text-field
                  dense
                  hide-details
                  v-model="stone.standard_price"
                  :readonly="!stone.edit_mode && stone.price_override"
                  label="Unit Price"
                  @input="changeSalesPrice(index)"
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col cols="1" style="max-width: 7%;" class="green-background-input ml-2">
                <v-text-field
                  dense
                  hide-details
                  readonly
                  label="Qty Sq.Ft"
                  placeholder=" "
                  :value="calculateSaleQty(stone.stone_id)"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="green-background-input ml-2">
                <v-text-field
                  dense
                  hide-details
                  v-model="stone.price"
                  readonly
                  label="Dis. Price"
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="green-background-input ml-2">
                <v-text-field
                  dense
                  hide-details
                  :value="(calculateSaleQty(stone.stone_id) * stone.price).toFixed(2)"
                  readonly
                  label="Amount"
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="1" style="max-width: 7%;" class="green-background-input ml-2">
                <v-text-field
                  dense
                  hide-details
                  readonly=""
                  :value="calculateInStock(stone.stone_id)"
                  placeholder=""
                  label="Stock / Qty"
                >
                </v-text-field>
              </v-col>-->
              <v-col cols="1" style="max-width: 4.5%">
                <v-icon
                  v-if="!stone.edit_mode"
                  @click="stoneEditMode(stone,index);"
                  :disabled="editModeRecord2 || change_order_id || is_enable_change_order"
                >mdi-border-color</v-icon>
                <v-tooltip
                  left
                  v-if="!stone.edit_mode && !stone.new_entry && getStonePrice(index) != stone.standard_price"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      @click="updateStonePriceAsCurrent(index)"
                      :disabled="change_order_id || is_enable_change_order"
                    >mdi-content-duplicate</v-icon>
                  </template>
                  <span>Change price to current (${{getStonePrice(index)}})</span>
                </v-tooltip>
                <v-icon v-if="stone.edit_mode" @click="checkStonePrice(index)">mdi-content-save</v-icon>
                <v-icon
                  v-if="stone.edit_mode && !stone.new_entry"
                  @click="resetProjectStone(index)"
                >mdi-reload</v-icon>
              </v-col>
            </v-row>
            <v-row dense class="primary mt-2">
              <v-col class="d-flex align-center justify-center">
                <span class="white--text">Counter Top Entry</span>
              </v-col>
              <v-col
                cols="2"
                style="max-width: 12%;"
                class="d-flex align-center justify-end white--text"
              ></v-col>
              <v-col
                v-if="!view_counter_top_screen"
                cols="1"
                class="text-right"
                style="max-width: 5%; padding-right: 32px;"
              >
                <v-icon
                  style="font-size: 26px;"
                  @click="view_counter_top_screen = true"
                  :disabled="totalStone == 0 || change_order_id || is_enable_change_order"
                  color="white"
                >mdi-plus-circle</v-icon>
              </v-col>
              <v-col v-else cols="1" style="max-width: 5%;" class="text-right">
                <v-icon
                  @click="edit_countor_top_entry = false; closeCounterTopEntry()"
                  color="white"
                >mdi-close</v-icon>
              </v-col>
            </v-row>
            <v-row dense class="mt-3" v-if="view_counter_top_screen">
              <v-col cols="2">
                <v-autocomplete
                  v-model="countertop_order_data.area_id"
                  label="Counter Area"
                  dense
                  :items="getAreaByForm(project_data_flag)"
                  :error-messages="countertop_order_error.area_id"
                  hide-details
                  item-text="name"
                  item-value="area_id"
                  placeholder=" "
                  :search-input.sync="counter_area_search"
                  :menu-props="{closeOnContentClick:true}"
                >
                  <template v-slot:no-data>
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                      >No Counter Area Found!</span>
                      <span
                        @click="addArea(project_data_flag)"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                      ></span>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="2" class="ml-2">
                <v-autocomplete
                  v-model="countertop_order_data.stone_id"
                  label="Stone Option"
                  :error-messages="countertop_order_error.stone_id"
                  dense
                  :items="selected_stone"
                  hide-details
                  placeholder=" "
                  @change="changeCounterTopStone()"
                ></v-autocomplete>
              </v-col>
              <v-col cols="3" class="ml-2">
                <v-text-field
                  v-model="countertop_order_data.description"
                  label="Special Note"
                  dense
                  hide-details
                  placeholder=" "
                  :readonly="qtyLine"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-2 green-background-input">
                <v-text-field
                  label="Counter Cost"
                  dense
                  hide-details
                  placeholder=" "
                  readonly
                  :value="calculateCounterCost"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense class="mt-3" v-if="view_counter_top_screen">
              <v-col cols="1" style="max-width: 7%;">
                <v-text-field
                  v-model="countertop_order_data.qty"
                  label="Qty"
                  :error-messages="countertop_order_error.qty"
                  dense
                  hide-details
                  placeholder=" "
                  :readonly="qtyLine"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-2" style="max-width: 7%;">
                <v-text-field
                  v-model="countertop_order_data.length"
                  :error-messages="countertop_order_error.length"
                  label="L"
                  dense
                  hide-details
                  placeholder=" "
                  :readonly="qtyLine"
                ></v-text-field>
              </v-col>
              <v-col
                cols="1"
                class="ml-2"
                style="max-width: 7%;"
                v-if="countertop_order_data.dimension != 'custom'"
              >
                <v-autocomplete
                  v-model="countertop_order_data.dimension"
                  :error-messages="countertop_order_error.dimension"
                  label="D"
                  dense
                  :items="dimension_list"
                  hide-details
                  placeholder=" "
                  :readonly="qtyLine"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="1"
                style="max-width: 7%;"
                class="ml-2"
                v-if="countertop_order_data.dimension == 'custom'"
              >
                <v-text-field
                  v-model="countertop_order_data.custom_dimension"
                  :error-messages="countertop_order_error.custom_dimension"
                  dense
                  hide-details
                  :readonly="qtyLine"
                  label="D"
                  placeholder=" "
                  @click:append="countertop_order_data.dimension = null; countertop_order_data.custom_dimension = null;"
                  append-icon="mdi-form-select"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="pt-0 mt-0 ml-2" style="max-width: 7.5%;">
                <v-btn
                  :disabled="disableBtn"
                  style="font-weight: normal; padding: unset;"
                  block
                  v-if="!countertop_order_data.left_splash"
                  @click="countertop_order_data.left_splash = !countertop_order_data.left_splash; toggleBtn()"
                  color="grey"
                  class="text-capitalize rounded-0"
                >
                  No - Left
                  <br />Splash
                </v-btn>
                <v-btn
                  :disabled="disableBtn"
                  style="font-weight: normal; padding: unset;"
                  block
                  v-else
                  @click="countertop_order_data.left_splash = !countertop_order_data.left_splash; toggleBtn()"
                  color="blue-grey darken-2"
                  class="text-capitalize rounded-0 white--text"
                >
                  Left
                  <br />Splash
                </v-btn>
              </v-col>
              <v-col cols="1" class="pt-0 mt-0 ml-2" style="max-width: 7.5%;">
                <v-btn
                  :disabled="disableBtn"
                  style="font-weight: normal; padding: unset;"
                  block
                  v-if="!countertop_order_data.back_splash"
                  @click="countertop_order_data.back_splash = !countertop_order_data.back_splash; toggleBtn()"
                  color="grey"
                  class="text-capitalize rounded-0"
                >
                  No - Back
                  <br />Splash
                </v-btn>
                <v-btn
                  :disabled="disableBtn"
                  style="font-weight: normal; padding: unset;"
                  block
                  v-else
                  @click="countertop_order_data.back_splash = !countertop_order_data.back_splash; toggleBtn()"
                  color="blue-grey darken-2"
                  class="text-capitalize rounded-0 white--text"
                >
                  Back
                  <br />Splash
                </v-btn>
              </v-col>
              <v-col cols="1" class="pt-0 mt-0 ml-2" style="max-width: 7.5%;">
                <v-btn
                  :disabled="disableBtn"
                  style="font-weight: normal; padding: unset;"
                  block
                  v-if="!countertop_order_data.right_splash"
                  @click="countertop_order_data.right_splash = !countertop_order_data.right_splash; toggleBtn()"
                  color="grey"
                  class="text-capitalize rounded-0"
                >
                  No - Right
                  <br />Splash
                </v-btn>
                <v-btn
                  :disabled="disableBtn"
                  style="font-weight: normal; padding: unset;"
                  block
                  v-else
                  @click="countertop_order_data.right_splash = !countertop_order_data.right_splash; toggleBtn()"
                  color="blue-grey darken-2"
                  class="text-capitalize rounded-0 white--text"
                >
                  Right
                  <br />Splash
                </v-btn>
              </v-col>
              <v-col
                cols="2"
                style="max-width: 10%"
                class="ml-2"
                v-if="countertop_order_data.splace_height != 'custom'"
              >
                <v-autocomplete
                  v-model="countertop_order_data.splace_height"
                  :error-messages="countertop_order_error.splace_height"
                  label="Splash Height (In Inch)"
                  dense
                  :items="splash_height_list"
                  hide-details
                  placeholder="Select"
                  clearable
                  :readonly="splashHeight"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="2"
                style="max-width: 12%"
                class="ml-2"
                v-if="countertop_order_data.splace_height == 'custom'"
              >
                <v-text-field
                  v-model="countertop_order_data.custom_splace_height"
                  :error-messages="countertop_order_error.custom_splace_height"
                  dense
                  hide-details
                  :readonly="splashHeight"
                  label="Splash Height (In Inch)"
                  placeholder=" "
                  @click:append="countertop_order_data.splace_height = null; countertop_order_data.custom_splace_height = null;"
                  append-icon="mdi-form-select"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-2 green-background-input">
                <v-text-field
                  label="Sq. Ft"
                  dense
                  hide-details
                  readonly
                  :value="total_sq_ft"
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-2 green-background-input">
                <v-text-field
                  label="Price"
                  dense
                  hide-details
                  readonly
                  v-model="countertop_order_data.price"
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-2 green-background-input">
                <v-text-field
                  label="Total"
                  dense
                  hide-details
                  readonly
                  :value="total_amount"
                  placeholder=" "
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense class="mt-3" v-if="view_counter_top_screen">
              <!-- <v-col cols="2">
                <v-autocomplete 
                  v-model="countertop_order_data.group_id"
                  label="Sink Group"
                  dense
                  :items="sink_group_list"
                  hide-details
                  item-text="ig_tiitle"
                  item-value="ig_id"
                  @change="getSink()"
                  placeholder=" "
                  :readonly="sinkLine"
                >
                </v-autocomplete>
              </v-col>-->
              <v-col cols="1" style="max-width:2% !important">
                <v-icon
                  @click="deleteSinkCutJob(countertop_order_data.counter_top_sink_id,countertop_order_data.project_counter_top_entry_id,'sink')"
                >mdi-close-circle</v-icon>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  v-model="countertop_order_data.sink_id"
                  label="Sink"
                  dense
                  :items="sink_list"
                  hide-details
                  item-text="item_name"
                  item-value="item_id"
                  @change="changeSink()"
                  placeholder=" "
                  class="ml-2"
                  :append-icon="(countertop_order_data.sink_id)?'mdi-pencil':'mdi-plus-circle'"
                  @click:append="(countertop_order_data.sink_id)?editItem(0,countertop_order_data.sink_id,false,countertop_order_data.vendor_id,'item','counter_top'):addItem(0,'counter_top')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  v-model="countertop_order_data.vendor_id"
                  label="Vendor"
                  dense
                  :items="sink_vendor_list"
                  hide-details
                  item-text="vendor.v_name"
                  item-value="vendor_id"
                  @change="changeVendor3()"
                  placeholder=" "
                  class="ml-2"
                  @click:append="addVendorInItem(0,'counter_top_stone','')"
                  :append-icon="countertop_order_data.sink_id ? 'mdi-plus-circle' : ''"
                ></v-autocomplete>
              </v-col>
              <v-col cols="1">
                <v-text-field
                  v-model="countertop_order_data.sink_qty"
                  label="Qty"
                  dense
                  hide-details
                  placeholder=" "
                  class="ml-2"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-2 green-background-input">
                <v-text-field
                  v-model="countertop_order_data.sink_price"
                  label="Sink Price"
                  dense
                  hide-details
                  readonly
                  placeholder=" "
                  class
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-2 green-background-input">
                <v-text-field
                  label="Sink Cost"
                  class
                  dense
                  hide-details
                  readonly
                  :value="calculatSinkCost"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="1" class="ml-2 green-background-input">
                <v-text-field 
                  label="Cut Out Cost"
                  dense=""
                  hide-details
                  placeholder=" "
                  class=""
                  :value="calculateCutOutPrice"
                >
                </v-text-field>
              </v-col>-->
            </v-row>
            <v-row dense class="mt-3" v-if="view_counter_top_screen">
              <v-col cols="1" style="max-width:2% !important">
                <v-icon
                  @click="deleteSinkCutJob(countertop_order_data.counter_top_cut_job_id,countertop_order_data.project_counter_top_entry_id,'job_cut')"
                >mdi-close-circle</v-icon>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  v-model="countertop_order_data.cut_job_id"
                  label="Job"
                  dense
                  :items="cut_job_list"
                  hide-details
                  item-text="item_name"
                  item-value="item_id"
                  @change="changeCutJob()"
                  placeholder=" "
                  class="ml-2"
                  :append-icon="(countertop_order_data.cut_job_id)?'mdi-pencil':'mdi-plus-circle'"
                  @click:append="(countertop_order_data.cut_job_id)?editItem(0,countertop_order_data.cut_job_id,false,countertop_order_data.cut_job_vendor_id,'item','counter_top'):addItem(0,'counter_top')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  v-model="countertop_order_data.cut_job_vendor_id"
                  label="Vendor"
                  dense
                  :items="cut_job_vendor_list"
                  hide-details
                  item-text="vendor.v_name"
                  item-value="vendor_id"
                  @change="changeVendorCutJob()"
                  placeholder=" "
                  class="ml-2"
                  @click:append="addVendorInItem(0,'counter_top_cut_job','')"
                  :append-icon="countertop_order_data.cut_job_id ? 'mdi-plus-circle' : ''"
                ></v-autocomplete>
              </v-col>
              <v-col cols="1">
                <v-text-field
                  v-model="countertop_order_data.cut_job_qty"
                  label="Job Qty"
                  dense
                  hide-details
                  placeholder=" "
                  class="ml-2"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-2 green-background-input">
                <v-text-field
                  v-model="countertop_order_data.cut_job_price"
                  label="Job Price"
                  dense
                  hide-details
                  readonly
                  placeholder=" "
                  class
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="ml-2 green-background-input">
                <v-text-field
                  label="Job Cost"
                  class
                  dense
                  hide-details
                  readonly
                  :value="calculatCutJobCost"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row dense="" class="mt-2" v-if="view_counter_top_screen">
              <v-col cols="5" class="pt-0 mt-0">
                <v-row dense="" class="pt-0 mt-0" style="border: 1px solid #808080a1;">
                  <v-col class="pa-1" cols="7" style="min-width: 65%">
                    <v-select
                      dense
                      :items="edge_profile_list"
                      v-model="countertop_order_data.edge_profile"
                      :error-messages="countertop_order_error.edge_profile"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.edge_profile)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.edge_profile)?'white':'black'"
                      placeholder="No - Edge Profile"
                      class="rounded-0 custome-input-height"
                      clearable=""
                      @click:clear="countertop_order_data.edge_profile_price = null; countertop_order_data.edge_profile_qty = null"
                      :class="{
                        'input-white-text': countertop_order_data.edge_profile,
                        'disable-btn': cutOutLine,
                        'input-custom-border': countertop_order_error.edge_profile,
                      }"
                      :disabled="cutOutLine"
                      @change="changeEdgeProfile()"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="2" style="max-width: 15%" class="pl-0">
                    <v-select
                      dense
                      :items="qty_list"
                      v-model="countertop_order_data.edge_profile_qty"
                      :error-messages="countertop_order_error.edge_profile_qty"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.edge_profile_qty)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.edge_profile_qty)?'white':'black'"
                      placeholder="Qty"
                      class="rounded-0 custome-input-height"
                      :class="{
                        'input-white-text': countertop_order_data.edge_profile_qty,
                        'disable-btn': cutOutLine,
                        'input-custom-border': countertop_order_error.edge_profile,
                      }"
                      :readonly="!countertop_order_data.edge_profile"
                      :disabled="cutOutLine"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="3" style="max-width: 20%" class="pl-0">
                    <v-text-field
                      dense
                      v-model="countertop_order_data.edge_profile_price"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.edge_profile_price)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.edge_profile_price)?'white':'black'"
                      placeholder="Price"
                      class="rounded-0 custome-input-height"
                      :class="{
                        'input-white-text': countertop_order_data.edge_profile_price,
                        'disable-btn': cutOutLine,
                      }"
                      readonly=""
                      :disabled="cutOutLine"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="5" class="pt-0 mt-0">
                <v-row dense="" class="pt-0 mt-0 ml-2" style="border: 1px solid #808080a1;">
                  <v-col class="pa-1" cols="7" style="min-width: 65%">
                    <v-select
                      dense
                      :items="elec_cut_out_list"
                      v-model="countertop_order_data.elec_cut_out_job_id"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.elec_cut_out_job_id)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.elec_cut_out_job_id)?'white':'black'"
                      placeholder="No - Elec. Cut Out"
                      class="rounded-0 custome-input-height"
                      clearable=""
                      @click:clear="countertop_order_data.elec_cut_out_price = null; countertop_order_data.elec_cut_out_qty = null"
                      :class="{
                        'input-white-text': countertop_order_data.elec_cut_out_job_id,
                        'disable-btn': cutOutLine,
                      }"
                      :disabled="cutOutLine"
                      @change="changeEleCutOut()"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="2" style="max-width: 15%" class="pl-0">
                    <v-select
                      dense
                      :items="qty_list"
                      v-model="countertop_order_data.elec_cut_out_qty"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.elec_cut_out_qty)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.elec_cut_out_qty)?'white':'black'"
                      placeholder="Qty"
                      class="rounded-0 custome-input-height"
                      :class="{
                        'input-white-text': countertop_order_data.elec_cut_out_qty,
                        'disable-btn': cutOutLine,
                      }"
                      :readonly="!countertop_order_data.elec_cut_out_job_id"
                      :disabled="cutOutLine"
                    >
                    </v-select>
                  </v-col>
                   <v-col cols="3" style="max-width: 20%" class="pl-0">
                    <v-text-field
                      dense
                      v-model="countertop_order_data.elec_cut_out_price"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.elec_cut_out_price)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.elec_cut_out_price)?'white':'black'"
                      placeholder="Price"
                      class="rounded-0 custome-input-height"
                      :class="{
                        'input-white-text': countertop_order_data.elec_cut_out_price,
                        'disable-btn': cutOutLine,
                      }"
                      readonly=""
                      :disabled="cutOutLine"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>-->
            <v-row dense class="mt-2" v-if="view_counter_top_screen">
              <!-- <v-col cols="5" class="pt-0 mt-0">
                <v-row dense="" class="pt-0 mt-0" style="border: 1px solid #808080a1;">
                  <v-col class="pa-1" cols="7" style="min-width: 65%">
                    <v-select
                      dense
                      :items="cooktop_cut_out_list"
                      v-model="countertop_order_data.cooktop_cut_out_job_id"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.cooktop_cut_out_job_id)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.cooktop_cut_out_job_id)?'white':'black'"
                      placeholder="No - Cooktop Cut Out"
                      class="rounded-0 custome-input-height"
                      clearable=""
                      @click:clear="countertop_order_data.cooktop_cut_out_price = null; countertop_order_data.cooktop_cut_out_qty = null"
                      :class="{
                        'input-white-text': countertop_order_data.cooktop_cut_out_job_id,
                        'disable-btn': cutOutLine,
                      }"
                      :disabled="cutOutLine"
                      @change="changeCookTopCutOut()"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="2" style="max-width: 15%" class="pl-0">
                    <v-select
                      dense
                      :items="qty_list"
                      v-model="countertop_order_data.cooktop_cut_out_qty"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.cooktop_cut_out_qty)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.cooktop_cut_out_qty)?'white':'black'"
                      placeholder="Qty"
                      class="rounded-0 custome-input-height"
                      :class="{
                        'input-white-text': countertop_order_data.cooktop_cut_out_qty,
                        'disable-btn': cutOutLine,
                      }"
                      :readonly="!countertop_order_data.cooktop_cut_out_job_id"
                      :disabled="cutOutLine"
                    >
                    </v-select>
                  </v-col>
                   <v-col cols="3" style="max-width: 20%" class="pl-0">
                    <v-text-field
                      dense
                      v-model="countertop_order_data.cooktop_cut_out_price"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.cooktop_cut_out_price)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.cooktop_cut_out_price)?'white':'black'"
                      placeholder="Price"
                      class="rounded-0 custome-input-height"
                      :class="{
                        'input-white-text': countertop_order_data.cooktop_cut_out_price,
                        'disable-btn': cutOutLine,
                      }"
                      readonly=""
                      :disabled="cutOutLine"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                </v-col>
                <v-col cols="5" class="pt-0 mt-0">
                <v-row dense="" class="pt-0 mt-0 ml-2" style="border: 1px solid #808080a1;">
                  <v-col class="pa-1" cols="7" style="min-width: 65%">
                    <v-select
                      dense
                      :items="sink_cut_out_list"
                      v-model="countertop_order_data.sink_cut_out_job_id"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.sink_cut_out_job_id)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.sink_cut_out_job_id)?'white':'black'"
                      placeholder="No - Sink Cut Out"
                      class="rounded-0 custome-input-height"
                      clearable=""
                      @click:clear="countertop_order_data.sink_cut_out_price = null; countertop_order_data.sink_cut_out_qty = null"
                      :class="{
                        'input-white-text': countertop_order_data.sink_cut_out_job_id,
                        'disable-btn': cutOutLine,
                      }"
                      :disabled="cutOutLine"
                      @change="changeSinkCutOut()"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="2" style="max-width: 15%;" class="pl-0">
                    <v-select
                      dense
                      :items="qty_list"
                      v-model="countertop_order_data.sink_cut_out_qty"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.sink_cut_out_qty)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.sink_cut_out_qty)?'white':'black'"
                      placeholder="Qty"
                      class="rounded-0 custome-input-height"
                      :class="{
                        'input-white-text': countertop_order_data.sink_cut_out_qty,
                        'disable-btn': cutOutLine,
                      }"
                      :readonly="!countertop_order_data.sink_cut_out_job_id"
                      :disabled="cutOutLine"
                    >
                    </v-select>
                  </v-col>
                   <v-col cols="3" style="max-width: 20%" class="pl-0">
                    <v-text-field
                      dense
                      v-model="countertop_order_data.sink_cut_out_price"
                      hide-details
                      filled
                      :background-color="(countertop_order_data.sink_cut_out_price)?'blue-grey darken-2':'grey'"
                      :color="(countertop_order_data.sink_cut_out_price)?'white':'black'"
                      placeholder="Price"
                      class="rounded-0 custome-input-height"
                      :class="{
                        'input-white-text': countertop_order_data.sink_cut_out_price,
                        'disable-btn': cutOutLine,
                      }"
                      readonly=""
                      :disabled="cutOutLine"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>-->
              <v-col cols="12" class="text-right">
                <v-btn
                  :disabled="change_order_id || is_enable_change_order"
                  v-if="!edit_countor_top_entry"
                  @click="saveProjectCountorTop();"
                  style="font-weight: normal; padding: unset; height: 39.8px;"
                  color="primary"
                  class="text-capitalize rounded-0"
                >Add</v-btn>
                <v-btn
                  :disabled="change_order_id || is_enable_change_order"
                  v-else
                  @click="updateProjectCountorTop();"
                  style="font-weight: normal; padding: unset; height: 39.8px;"
                  color="primary"
                  class="text-capitalize rounded-0"
                >Save</v-btn>
                <v-btn
                  v-if="!edit_countor_top_entry"
                  @click="resetCounterTopEntry();"
                  style="font-weight: normal; padding: unset; height: 39.8px;"
                  color="error"
                  class="text-capitalize rounded-0 ml-2"
                >Reset</v-btn>
                <v-btn
                  v-else
                  @click="editCounterTop(edit_counter_top_id);"
                  style="font-weight: normal; padding: unset; height: 39.8px;"
                  color="error"
                  class="text-capitalize rounded-0 ml-2"
                >Reset</v-btn>
              </v-col>
            </v-row>
            <v-row dense class="primary mt-2">
              <v-col class="d-flex align-center justify-center">
                <span class="white--text">Counter Top List</span>
              </v-col>
              <v-col
                cols="2"
                style="max-width: 12%;"
                class="d-flex align-center justify-end white--text"
              >Total: ${{totalCounterCost.toFixed(2)}}</v-col>
              <v-col cols="1" style="max-width: 5%;" class="text-right">
                <v-icon
                  v-if="!counter_list_expand"
                  @click="counter_list_expand = !counter_list_expand"
                  color="white"
                >mdi-chevron-down</v-icon>
                <v-icon
                  v-else
                  @click="counter_list_expand = !counter_list_expand"
                  color="white"
                >mdi-chevron-up</v-icon>
              </v-col>
            </v-row>
            <v-row dense v-show="counter_list_expand">
              <v-col cols="12" class="pa-0 ma-0">
                <v-simple-table dense class="fix-table-layout padding_0_table">
                  <thead style="background: #455a64;">
                    <tr>
                      <th class="text-center white--text" width="4%"></th>
                      <th class="text-center white--text" width="12%">Counter Area</th>
                      <th class="text-center white--text" width="12%">Stone</th>
                      <th class="text-center white--text" width="4%">Qty</th>
                      <th class="text-center white--text" width="8%">L</th>
                      <th class="text-center white--text" width="5%">D</th>
                      <th class="text-center white--text" width="6%">L.Sp</th>
                      <th class="text-center white--text" width="8%">B.Sp</th>
                      <th class="text-center white--text" width="6%">R.Sp</th>
                      <th class="text-center white--text" width="6%">H.Sp</th>
                      <th class="text-center white--text" width="8%">Sq. Ft</th>
                      <th class="text-right white--text" width="7%">Rate</th>
                      <th class="text-right white--text" width="8%">Amount</th>
                      <th class="text-center white--text" width="6%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(countertop, index) in countertop_list"
                      :key="index"
                      class="mt-3"
                      :class="{
                      'orange-background-row': countertop.sink_item,
                      }"
                    >
                      <td class="text-center d-flex">
                        <v-simple-checkbox
                          @input="getAddedSinkItem($event, countertop.project_counter_top_entry_id)"
                          v-model="countertop.selected"
                          :ripple="false"
                          class="custom-simple-box"
                        ></v-simple-checkbox>
                        <v-icon
                          :disabled="change_order_id || is_enable_change_order"
                          @click="change_stock_item_id=countertop.stone_id;removeCounterTop(countertop.project_counter_top_entry_id);"
                        >mdi-close-circle</v-icon>
                      </td>
                      <td class="text-center">{{(countertop.area)?countertop.area.name:''}}</td>
                      <td class="text-center">{{(countertop.stone)?countertop.stone.item_name:''}}</td>
                      <td class="text-center">{{countertop.qty}}</td>
                      <td class="text-center">{{countertop.length}}</td>
                      <td
                        class="text-center"
                      >{{(countertop.dimension == 'custom')?countertop.custom_dimension:countertop.dimension}}</td>
                      <td
                        class="text-center"
                      >{{(countertop.left_splash)?(countertop.dimension == 'custom')?countertop.custom_dimension:countertop.dimension:''}}</td>
                      <td class="text-center">{{(countertop.back_splash)?countertop.length:''}}</td>
                      <td
                        class="text-center"
                      >{{(countertop.right_splash)?(countertop.dimension == 'custom')?countertop.custom_dimension:countertop.dimension:''}}</td>
                      <td
                        class="text-center"
                      >{{(countertop.splace_height == 'custom')?countertop.custom_splace_height:countertop.splace_height}}</td>
                      <td class="text-center">{{getSqFt(countertop)}}</td>
                      <td class="text-right">${{countertop.price}}</td>
                      <td class="text-right">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                            >${{(getCounterCostDiscoutedAmt(getCounterCost(countertop))).toFixed(2)}}</span>
                          </template>
                          <span>${{getCounterCost(countertop)}}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-right pr-1">
                        <v-tooltip left max-width="400" v-if="countertop.description">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">mdi-note-text-outline</v-icon>
                          </template>
                          <span>{{countertop.description}}</span>
                        </v-tooltip>
                        <v-icon
                          :disabled="change_order_id || is_enable_change_order"
                          @click="editCounterTop(countertop.project_counter_top_entry_id)"
                        >mdi-border-color</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row dense class="primary mt-2">
              <v-col class="d-flex align-center justify-center">
                <span class="white--text">Item List</span>
              </v-col>
              <v-col
                cols="2"
                style="max-width: 12%;"
                class="d-flex align-center justify-end white--text"
              >Total: ${{totalItemJobCost}}</v-col>
              <v-col cols="1" style="max-width: 5%;" class="text-right">
                <v-icon
                  style="font-size: 26px;"
                  :disabled="disableAddEditItemJobIcon || change_order_id || is_enable_change_order"
                  class="pr-1"
                  @click="openAddNewItemJob()"
                  color="white"
                >mdi-plus-circle</v-icon>
                <v-icon
                  v-if="!item_job_list_expand"
                  @click="item_job_list_expand = !item_job_list_expand"
                  color="white"
                >mdi-chevron-down</v-icon>
                <v-icon
                  v-else
                  @click="item_job_list_expand = !item_job_list_expand"
                  color="white"
                >mdi-chevron-up</v-icon>
              </v-col>
            </v-row>
            <v-row dense v-show="item_job_list_expand">
              <v-col cols="12" class="pa-0 ma-0">
                <v-simple-table dense class="fix-table-layout">
                  <thead style="background: #455a64;">
                    <tr>
                      <th class="text-center white--text" width="4%"></th>
                      <th class="text-center white--text" width="15%">Type</th>
                      <th class="white--text" width="15%">Item</th>
                      <th class="white--text" width="28%">Job To</th>
                      <th class="white--text" width="11%">Qty</th>
                      <th class="text-right white--text" width="9%">Rate</th>
                      <th class="text-right white--text" width="10%">Amount</th>
                      <th class="text-center white--text" width="7%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item_job_row, index) in item_job_list"
                      :key="index"
                      :class="{
                      'edit_row_height': item_job_row.edit_mode,
                      'green-background-row': item_job_row.counter_top_id > 0,
                      'orange-background-row': item_job_row.sink_item,
                      }"
                    >
                      <td class="text-center d-flex">
                        <v-simple-checkbox
                          @input="getAssignCounterTopItem($event, item_job_row.counter_top_id,item_job_row.all_counter_top_id)"
                          v-model="item_job_row.selected"
                          :ripple="false"
                          v-if="item_job_row.counter_top_id"
                          class="custom-simple-box"
                        ></v-simple-checkbox>
                        <v-icon
                          :disabled="change_order_id || is_enable_change_order"
                          v-if="!item_job_row.counter_top_id"
                          @click="remove_item_job_id = item_job_row.counter_top_item_job_id;change_stock_item_id=item_job_row.item_job_id, remove_item_job_dialog = true;"
                        >mdi-close-circle</v-icon>
                      </td>
                      <td class="text-center">
                        <span v-if="item_job_row.edit_mode">
                          <v-select
                            :items="item_type_list"
                            v-model="item_job_data.item_job"
                            hide-details
                            dense
                            @change="getCounterTopItemList(item_job_data.item_job)"
                          ></v-select>
                        </span>
                        <span
                          v-else
                        >{{(item_job_row.item_job=='1' ? 'Stone' : item_job_row.item_job == '2' ? 'Job' : 'Item' )}}</span>
                      </td>
                      <td>
                        <span v-if="item_job_row.edit_mode">
                          <v-autocomplete
                            dense
                            v-model="item_job_data.item_job_id"
                            :items="counter_top_item_list"
                            item-text="item_name"
                            item-value="item_id"
                            @change="getItemJobDetails(index);"
                            hide-details
                            :error-messages="item_job_error.item_job_id"
                            :append-icon="(item_job_row.edit_mode)?(item_job_row.item_job_id)?'mdi-pencil':'mdi-plus-circle':''"
                            @click:append="(item_job_data.item_job_id)?editItem(index,item_job_data.item_job_id,false,item_job_data.vendor_id,'item','item'):addItem(index,'item')"
                          ></v-autocomplete>
                        </span>
                        <span v-else>{{getItemJobName(item_job_row)}}</span>
                      </td>
                      <td>
                        <span v-if="item_job_row.edit_mode">
                          <v-autocomplete
                            dense
                            hide-details
                            v-model="item_job_data.vendor_id"
                            :items="item_vendor_list"
                            item-text="vendor.v_name"
                            item-value="vendor_id"
                            @change="changeVendor4()"
                            :error-messages="item_job_error.vendor_id"
                            :menu-props="{closeOnContentClick:true}"
                            @click:append="addVendorInItem(index,'counter_top_item',item_job_row)"
                            :append-icon="item_job_row.edit_mode && item_job_data.vendor_id ? 'mdi-plus-circle' : ''"
                          >
                            <template v-slot:no-data v-if="item_job_data.item_job_id">
                              <div class="d-flex align-center">
                                <span
                                  class="pl-2"
                                  style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                                >No Vendor Found!</span>
                                <span
                                  @click="addVendorInItem('no','item',item_job_row)"
                                  class="mdi mdi-plus-circle pl-1 pr-2"
                                  style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                                ></span>
                              </div>
                            </template>
                          </v-autocomplete>
                        </span>
                        <span v-else>{{(item_job_row.vendor)?item_job_row.vendor.v_name:''}}</span>
                      </td>
                      <td>
                        <span v-if="item_job_row.edit_mode">
                          <v-text-field
                            dense
                            hide-details
                            v-model="item_job_data.qty"
                            :error-messages="item_job_error.qty"
                          ></v-text-field>
                        </span>
                        <span v-else>{{item_job_row.qty}}</span>
                      </td>
                      <td class="text-right">
                        <span v-if="item_job_row.edit_mode">
                          <v-text-field
                            dense
                            hide-details
                            v-model="item_job_data.rate"
                            :readonly="!item_job_data.price_override"
                            reverse
                            :class="(!item_job_data.price_override)?'green-background-input':''"
                          ></v-text-field>
                        </span>
                        <span v-else>${{item_job_row.rate}}</span>
                      </td>
                      <td class="text-right">
                        <span v-if="item_job_row.edit_mode">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                <v-text-field
                                  dense
                                  hide-details
                                  readonly
                                  background-color="green lighten-5"
                                  reverse
                                  :value="getCounterCostDiscoutedAmt(item_job_row.qty * item_job_row.rate)"
                                ></v-text-field>
                              </span>
                            </template>
                            <span>${{(item_job_row.qty * item_job_row.rate).toFixed(2)}}</span>
                          </v-tooltip>
                        </span>
                        <span v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                              >${{(getCounterCostDiscoutedAmt(item_job_row.qty * item_job_row.rate)).toFixed(2)}}</span>
                            </template>
                            <span>${{(item_job_row.qty * item_job_row.rate).toFixed(2)}}</span>
                          </v-tooltip>
                        </span>
                      </td>
                      <td class="pl-7">
                        <v-icon
                          :disabled="disableAddEditItemJobIcon || change_order_id || is_enable_change_order"
                          v-if="!item_job_row.counter_top_id && !item_job_row.edit_mode"
                          @click="itemJobEditMode(item_job_row,index);getCounterTopItemList(item_job_row.item_job);getAllTypeItem();"
                        >mdi-border-color</v-icon>
                        <v-tooltip
                          left
                          v-if="!item_job_row.counter_top_id && !item_job_row.edit_mode && getCurrentPriceOfItemjob(item_job_row) != item_job_row.rate"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              @click="updatePriceAsCurrentItemJob(item_job_row,index)"
                              :disabled="change_order_id || is_enable_change_order"
                            >mdi-content-duplicate</v-icon>
                          </template>
                          <span>Change price to current (${{getCurrentPriceOfItemjob(item_job_row)}})</span>
                        </v-tooltip>
                        <v-icon
                          v-if="!item_job_row.counter_top_id && item_job_row.edit_mode"
                          @click="updateItemJob(index);"
                        >mdi-content-save</v-icon>
                        <v-icon
                          v-if="!item_job_row.counter_top_id && item_job_row.edit_mode"
                          @click="resetItemJob(index)"
                        >mdi-reload</v-icon>
                      </td>
                    </tr>
                    <tr v-if="add_new_item_job" class="edit_row_height">
                      <td class="text-center">
                        <v-icon @click="closeJobItemEntry()">mdi-close-circle</v-icon>
                      </td>
                      <td class="text-center">
                        <span>
                          <v-select
                            :items="item_type_list"
                            v-model="item_job_data.item_job"
                            hide-details
                            dense
                            @change="getCounterTopItemList(item_job_data.item_job)"
                          ></v-select>
                        </span>
                      </td>
                      <td>
                        <v-autocomplete
                          dense
                          v-model="item_job_data.item_job_id"
                          :items="counter_top_item_list"
                          item-text="item_name"
                          item-value="item_id"
                          hide-details
                          @change="getItemDetails2()"
                          :error-messages="item_job_error.item_job_id"
                          :append-icon="(item_job_data.item_job_id)?'mdi-pencil':'mdi-plus-circle'"
                          @click:append="(item_job_data.item_job_id)?editItem(item_job_list.length,item_job_data.item_job_id,false,item_job_data.vendor_id,'item','item'):addItem(item_job_list.length,'item')"
                        ></v-autocomplete>
                      </td>
                      <td>
                        <v-autocomplete
                          dense
                          hide-details
                          v-model="item_job_data.vendor_id"
                          :items="item_vendor_list"
                          item-text="vendor.v_name"
                          item-value="vendor_id"
                          @change="changeVendor4()"
                          :error-messages="item_job_error.vendor_id"
                          :menu-props="{closeOnContentClick:true}"
                          :append-icon="item_job_data.vendor_id ? 'mdi-plus-circle' : ''"
                          @click:append="addVendorInItem(item_job_list.length,'counter_top_item',item_job_data)"
                        >
                          <template v-slot:no-data v-if="item_job_data.item_job_id">
                            <div class="d-flex align-center">
                              <span
                                class="pl-2"
                                style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                              >No Vendor Found!</span>
                              <span
                                @click="addVendorInItem('no','item')"
                                class="mdi mdi-plus-circle pl-1 pr-2"
                                style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                              ></span>
                            </div>
                          </template>
                        </v-autocomplete>
                      </td>
                      <td>
                        <v-text-field
                          dense
                          hide-details
                          v-model="item_job_data.qty"
                          :error-messages="item_job_error.qty"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          dense
                          hide-details
                          v-model="item_job_data.rate"
                          :readonly="!item_job_data.price_override"
                          :background-color="(!item_job_data.price_override)?'green lighten-5':''"
                          reverse
                        ></v-text-field>
                      </td>
                      <td>
                        <!-- <v-text-field
                          dense
                          hide-details
                          readonly=""
                          :value="(item_job_data.qty * item_job_data.rate > 0)?item_job_data.qty * item_job_data.rate:''"
                          background-color="green lighten-5"
                          reverse
                          >
                        </v-text-field>-->
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              hide-details
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :value="(item_job_data.qty * item_job_data.rate > 0)?(getCounterCostDiscoutedAmt(item_job_data.qty * item_job_data.rate)).toFixed(2):''"
                              background-color="green lighten-5"
                              reverse
                            ></v-text-field>
                          </template>
                          <span>${{(item_job_data.qty * item_job_data.rate).toFixed(2)}}</span>
                        </v-tooltip>
                      </td>
                      <td class="pl-7">
                        <v-icon @click="checkPriceItemJob();">mdi-content-save</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row dense class="blue lighten-4 mt-1" style="font-size: 17px;">
              <v-col cols="2" class="pl-3" style="max-width: 11%;">
                Multiplier:
                <b>{{(selectedRows[0])?selectedRows[0].multiplier:''}}</b>
              </v-col>
              <v-col cols="1">
                <v-icon @click="openDiscountDialog()">mdi-sale</v-icon>
                <span class="pl-1" @click="openDiscountDialog()" style="cursor:pointer;">Discount</span>
              </v-col>
              <v-col cols="3" style="max-width: 18%">
                Order Amount:
                <b>${{totalCounterTopAmount}}</b>
              </v-col>
              <v-col cols="3" style="max-width: 18%">
                Discount Amount:
                <b>${{getProjectDiscount}}</b>
              </v-col>
              <v-col cols="3" style="max-width: 18%">
                Final Amount:
                <b>${{getProjectOrderAmount}}</b>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
      <AddItem />
      <EditItem />
      <!-- <AddJob />
      <EditJob />-->
    </v-dialog>
    <v-dialog v-model="change_item_job_price_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Change Price</v-card-title>
        <v-card-text>Do you want to change this price in master record?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="dark darken-1"
            text
            @click="change_item_job_price_dialog = false; item_job_data.change_price_in_master = true; saveItemJob();"
          >Yes</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="change_item_job_price_dialog = false; item_job_data.change_price_in_master = false; saveItemJob();"
          >No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="add_new_vendor_dialog" persistent max-width="1000">
      <v-card :loading="add_new_vendor_loading">
        <v-card-title>
          <span class="headline">Add vendor in {{get_selected_item_name}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="4">
                <v-autocomplete
                  dense
                  v-model="vendor_data.vendor_id"
                  :items="vendor_list"
                  item-text="v_name"
                  item-value="vendor_id"
                  :error-messages="vendor_data_error.vendor_id"
                  :hide-details="!vendor_data_error.vendor_id"
                  label="Vendor"
                  placeholder=" "
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" style="min-width:12%">
                <v-text-field
                  dense
                  v-model="vendor_data.invoice_price"
                  hide-details
                  reverse
                  label="Px. Inv"
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col cols="1" style="min-width:12%">
                <v-text-field
                  dense
                  v-model="vendor_data.deliver_price"
                  hide-details
                  reverse
                  @input="calculateSalesPrice()"
                  label="Px. Del"
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col cols="1" style="min-width:12%" class="green-background-input ml-1">
                <v-text-field
                  dense
                  v-model="vendor_data.sales_price"
                  hide-details
                  readonly
                  reverse
                  label="Px. Sal"
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="d-flex align-center justify-center">
                <v-switch
                  label="Px. Override"
                  v-model="vendor_data.price_override"
                  color="success"
                  hide-details
                  dense
                  class="pa-0 ma-0 mt-1"
                ></v-switch>
              </v-col>
              <v-col cols="1" style="min-width:12%">
                <v-text-field
                  v-if="vendor_data.price_override"
                  dense
                  v-model="vendor_data.override_price"
                  hide-details
                  reverse
                  label="Price"
                  placeholder=" "
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="add_new_vendor_dialog = false;">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="checkValueForAddVendor" @click="addItemVendor()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="invoice_group_modal" persistent max-width="300px">
      <v-card :loading="invoice_group_loading">
        <v-card-title>
          <span class="headline">Group Selected Item(s)</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-autocomplete
                dense
                label="Invoice Group*"
                :items="invoice_group_list"
                item-value="invoice_group_id"
                item-text="name"
                v-model="invoice_group_data.invoice_group_id"
                :error-messages="invoice_group_error.invoice_group_id"
                :hide-details="!invoice_group_error.invoice_group_id"
                :menu-props="{closeOnContentClick:true}"
                :search-input.sync="invoice_group_search"
              >
                <template v-slot:no-data v-if="invoice_group_search">
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No Group Found!</span>
                    <span
                      @click="addInvoiceGroup()"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="invoice_group_modal = false;invoice_group_data = {};invoice_group_error = {}"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="groupItems()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="update_invoice_group_modal" persistent max-width="1360px">
      <v-card :loading="update_group_item_loading">
        <v-card-title>
          <span class="headline">Update Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="3" style="min-width: 11%;">
                <v-autocomplete
                  dense
                  label="Invoice Group"
                  :items="invoice_group_list"
                  item-value="invoice_group_id"
                  item-text="name"
                  :disabled="update_invoice_group_data.change_order!=next_change_order_id "
                  v-model="update_invoice_group_data.invoice_group_id"
                  :error-messages="update_invoice_group_error.invoice_group_id"
                  :hide-details="!update_invoice_group_error.invoice_group_id"
                  :menu-props="{closeOnContentClick:true}"
                  :search-input.sync="invoice_group_search"
                >
                  <template v-slot:no-data v-if="invoice_group_search">
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                      >No Group Found!</span>
                      <span
                        @click="addInvoiceGroup()"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                      ></span>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="3" style="min-width: 20%;">
                <v-autocomplete
                  label="Item"
                  dense
                  v-model="update_invoice_group_data.item_job_id"
                  :items="item_list"
                  item-text="item_name"
                  item-value="item_id"
                  hide-details
                  :disabled="update_invoice_group_data.change_order!=next_change_order_id || update_invoice_group_data.item_spent != 0"
                  @change="getGroupItemDetails()"
                  :error-messages="update_invoice_group_error.item_job_id"
                  append-icon="mdi-pencil"
                  @click:append="editItem('',update_invoice_group_data.item_job_id,false,update_invoice_group_data.vendor_id,'group_item')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="3" style="max-width: 20%">
                <v-autocomplete
                  label="Vendor"
                  dense
                  hide-details
                  v-model="update_invoice_group_data.vendor_id"
                  :items="update_invoice_group_data.item_vendor_list"
                  item-text="vendor.v_name"
                  item-value="vendor_id"
                  :disabled="update_invoice_group_data.change_order!=next_change_order_id"
                  @change="changeGroupVendor('from_group')"
                  :error-messages="update_invoice_group_error.vendor_id"
                  :menu-props="{closeOnContentClick:true}"
                  :append-icon="update_invoice_group_data.item_job_id ? 'mdi-plus-circle' : ''"
                  @click:append="addVendorInItem('','group_item',update_invoice_group_data)"
                >
                  <template v-slot:selection="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{ item.vendor.v_code }}</span>
                      </template>
                      <span>{{ item.vendor.v_name }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="3" style="max-width: 20%">
                <v-autocomplete
                  label="Area"
                  dense
                  hide-details
                  v-model="update_invoice_group_data.area_id"
                  :items="getAreaByForm(project_data_flag)"
                  item-text="name"
                  item-value="area_id"
                  :error-messages="update_invoice_group_error.area_id"
                  :menu-props="{closeOnContentClick:true}"
                  :search-input.sync="update_invoice_group_data.area_search"
                >
                  <template v-slot:no-data v-if="update_invoice_group_data.area_search">
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                      >No Area Found!</span>
                      <span
                        @click="addArea(project_data_flag,9)"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                      ></span>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="1" style="max-width:5%">
                <div class="text-center">
                  <v-menu
                    bottom
                    :close-on-content-click="false"
                    content-class="elevation-0"
                    v-model="group_description_box"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">mdi-note-text-outline</v-icon>
                    </template>
                    <v-card tile min-width="450" max-width="450" class="mb-5 mr-5">
                      <v-list class="filter-section-border pa-3">
                        <v-row dense>
                          <v-col cols="12">
                            <v-textarea
                              dense
                              hide-details
                              v-model="update_invoice_group_data.description"
                              outlined
                              rows="3"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-list>
                      <v-card-title class="pa-0">
                        <v-btn
                          fab
                          color="error"
                          x-small
                          absolute
                          @click="group_description_box = false"
                          class="custom-close-btn"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                    </v-card>
                  </v-menu>
                </div>
              </v-col>
              <v-col cols="1" class="mt-5" style="max-width:6%;">
                <v-text-field
                  label="Qty"
                  dense
                  hide-details
                  v-model="update_invoice_group_data.qty"
                  :error-messages="update_invoice_group_error.qty"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="mt-5" style="max-width:8%">
                <v-autocomplete
                  v-model="update_invoice_group_data.uom_id"
                  dense
                  :items="uom_list"
                  hide-details
                  label="UOM"
                ></v-autocomplete>
              </v-col>
              <v-col cols="1" class="mt-5" style="max-width:8%;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      hide-details
                      v-model="update_invoice_group_data.rate"
                      :readonly="!update_invoice_group_data.price_override"
                      :background-color="(!update_invoice_group_data.price_override)?'green lighten-5':''"
                      reverse
                      label="U/Px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <span>{{getOriginUpx(update_invoice_group_data)}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="1" class="mt-5" style="min-width:8.8%;">
                <v-text-field
                  dense
                  hide-details
                  readonly
                  :value="getProjectDataAmt(update_invoice_group_data)"
                  background-color="green lighten-5"
                  reverse
                  label="Amount"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="mt-5" style="min-width:8.8%;">
                <v-text-field
                  dense
                  hide-details
                  readonly
                  :value="orderAmount(update_invoice_group_data)"
                  background-color="green lighten-5"
                  reverse
                  label="Order Amt"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row dense>
              <v-autocomplete
                dense
                label="Invoice Group*"
                :items="invoice_group_list"
                item-value="invoice_group_id"
                item-text="name"
                v-model="update_invoice_group_data.invoice_group_id"
                :error-messages="update_invoice_group_error.invoice_group_id"
                :hide-details="!update_invoice_group_error.invoice_group_id"
                :menu-props="{closeOnContentClick:true}"
                :search-input.sync="invoice_group_search"
              >
              <template v-slot:no-data v-if="invoice_group_search">
              <div class="d-flex align-center">
              
              <span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Group Found!</span> <span @click="addInvoiceGroup()" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
              </template>
              </v-autocomplete>
            </v-row>-->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col cols="1">
            <v-btn
              color="error"
              @click="update_invoice_group_modal = false;update_invoice_group_data = {};update_invoice_group_error = {}; itemGroupList();"
            >Close</v-btn>
          </v-col>
          <v-col cols="9" class="text-center">
            <b>
              Spent Amount :
              <span
                :class="row_qty_rate_color(update_invoice_group_data.item_spent)"
              >{{ update_invoice_group_data.item_spent ? itemFormatWithDollar(update_invoice_group_data.item_spent) : '$0.00'}}</span>
            </b>
          </v-col>
          <v-col cols="1">
            <v-btn
              color="error"
              @click="update_invoice_group_data={},update_invoice_group_error = {};openUpdateInvoiceGroupDialog(save_invoice_group_data)"
            >Reset</v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn
              color="primary"
              :loading="update_group_item_loading"
              @click="checkGroupChangePrice()"
              :disabled="parseFloat(getProjectDataAmt(update_invoice_group_data)) < parseFloat(itemFormatForSent((update_invoice_group_data.item_spent ? update_invoice_group_data.item_spent : 0.00)))"
            >Save</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="update_invoice_group_description_modal" persistent max-width="500px">
      <v-card :loading="update_group_item_loading">
        <v-card-title>
          <span class="headline">Update Description</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-textarea dense hide-details v-model="desc_modal_description" outlined rows="3"></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="update_invoice_group_description_modal = false; itemGroupList();"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="update_group_item_loading" @click="addDescription()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="group_item_dialog" persistent max-width="1300px">
      <v-card :loading="group_item_loading">
        <v-card-text>
          <div>
            <v-row dense class="pa-0 ma-0">
              <v-col cols="5" text-right>
                <v-card-title>G703 Detail - {{orderTitle}}</v-card-title>
              </v-col>
              <v-col cols="2" class="d-flex justify-center align-center">
                <v-menu offset-y :close-on-content-click="closeOnContentClick">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class icon dark v-bind="attrs" v-on="on">
                      <span class="lable_class" style="color:#757575">PDF</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            size="28px"
                            v-bind="attrs"
                            v-on="on"
                            style="color:#757575"
                          >mdi-printer</v-icon>
                        </template>
                        <span>PDF</span>
                      </v-tooltip>
                    </v-btn>
                  </template>
                  <v-list dense style="font-size: 16px !important;">
                    <v-list-item
                      @click="report_header_name='Cost Detail - W/Qty & Price';is_with_cost=true;is_with_qty=true;is_item_spent=false;generateGroupItemPDF();"
                    >
                      <v-list-item-title>Cost Detail - W/Qty & Price</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="report_header_name='Cost Detail - Itemized';is_with_cost=false;is_with_qty=true;is_item_spent=false;generateGroupItemPDF();"
                    >
                      <v-list-item-title>Cost Detail - Itemized</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="report_header_name='Cost Detail W/O Qty';is_with_cost=false;is_with_qty=false;is_item_spent=false;generateGroupItemPDF();"
                    >
                      <v-list-item-title>Cost Detail W/O Qty</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="report_header_name='Spending Analysis';is_with_cost=false;is_with_qty=false;is_item_spent=true;generateGroupItemPDF();"
                    >
                      <v-list-item-title>Spending Analysis</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click="is_with_cost=true;generateGroupItemPDF();">
                      
                          <v-icon size="28px"> mdi-printer </v-icon>
                      
                      </v-btn>
                  </template>
                                    <span>Print as PDF With Cost</span>
                                  </v-tooltip>
                                  <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click="is_with_cost=false;generateGroupItemPDF();">
                      
                          <v-icon size="28px"> mdi-printer </v-icon>
                      
                      </v-btn>
                  </template>
                                    <span>Print as PDF Without Cost</span>
                </v-tooltip>-->
              </v-col>
              <v-col cols="5" class="d-flex justify-end">
                <v-col class="text-right mt-2">
                  <v-btn @click="all" small class="grey">Expande All</v-btn>
                  <v-btn @click="none" small class="grey ml-2">Collapse All</v-btn>
                </v-col>
                <v-card-title>
                  <v-btn
                    fab
                    color="error"
                    x-small
                    @click="group_item_dialog = false"
                    class="custom-close-btn"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
              </v-col>
            </v-row>
            <v-row dense class="grey lighten-1 mb-1">
              <v-col cols="5" class="pa-0 ma-0">
                <v-row dense>
                  <v-col
                    cols="2"
                    class="pl-3"
                  >{{(selectedRows[0])?selectedRows[0].display_order_type:''}}</v-col>
                  <v-col cols="2">{{(selectedRows[0])?selectedRows[0].display_date:''}}</v-col>
                  <v-col
                    cols="4"
                  >{{(selectedRows[0] && selectedRows[0].customer)?selectedRows[0].customer.full_name:''}}</v-col>
                  <v-col cols="4">{{(selectedRows[0])?selectedRows[0].p_name:''}}</v-col>
                </v-row>
              </v-col>
              <v-col cols="7" class="text-right pa-0 ma-0">
                <v-row dense>
                  <!-- <v-col cols="2" class="text-left">
                    Multi: <b>{{(selectedRows[0])?selectedRows[0].multiplier:''}}</b>
                    </v-col>
                    <v-col cols="2" class="text-left">
                    O&P %: <b>{{(selectedRows[0])?selectedRows[0].p_price:''}}</b>
                  </v-col>-->
                  <v-col cols="3" class="text-left">
                    Invoiced :
                    <b>{{itemFormatWithDollar(project_invoice_amt)}}</b>
                  </v-col>
                  <v-col cols="3" class="text-left">
                    <span v-if="selected_item_job.length > 0">
                      Total :
                      <b>${{getTotalOfSelectedItems}}</b>
                    </span>
                  </v-col>
                  <v-col cols="3" class="text-left">
                    Pay.Due :
                    <b
                      style="cursor:pointer;"
                      @click="redirectToTransactionPayDue()"
                      :class="row_qty_rate_color(project_payment_due)"
                    >{{itemFormatWithDollar(project_payment_due)}}</b>
                  </v-col>
                  <v-col cols="3" class="text-left">
                    Order Value :
                    <b
                      :class="row_qty_rate_color(project_order_value)"
                    >{{itemFormatWithDollar(project_order_value)}}</b>
                  </v-col>
                </v-row>
              </v-col>
              <!-- <v-col cols="12">
                <span><b>Date:</b> {{(selectedRows[0])?selectedRows[0].display_date:''}}</span>
                <span class="ml-3"><b>{{(selectedRows[0])?selectedRows[0].display_order_type:''}}</b></span>
                <span class="ml-3"><b>Customer:</b> {{(selectedRows[0] && selectedRows[0].customer)?selectedRows[0].customer.full_name:''}}</span>
                <span class="ml-3"><b>Project:</b> {{(selectedRows[0])?selectedRows[0].p_name:''}}</span>
                <span class="ml-3"><b>Value:</b> </span>
                <span class="ml-6"><b>Invoiced:</b> </span>
                <span class="ml-6"><b>Pay. Due:</b> </span>
                <span class="ml-6"><b>Complated Dt:</b> {{(selectedRows[0])?selectedRows[0].estimated_completed_date:''}}</span>
              </v-col>-->
            </v-row>
          </div>
          <v-col cols="12" style="padding:5px 40px;">
            <v-simple-table dense class="fix-table-layout">
              <tbody>
                <tr style="background: #455a64;">
                  <td class="white--text" width="4%"></td>
                  <td class="white--text" width="20%">Item</td>
                  <td class="white--text" width="11%">Vendor</td>
                  <td class="white--text" width="11%">Area</td>
                  <td class="white--text" width="5%">Des</td>
                  <td class="white--text" width="7%">Qty</td>
                  <td class="white--text" width="7%">UOM</td>
                  <td class="white--text text-right" width="11%">U/Px</td>
                  <td class="white--text text-right" width="11%">Cost</td>
                  <td class="white--text text-right" width="11%">Order Amt</td>
                  <td class="white--text" width="5%"></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <div class="set-max-height-items">
            <v-row dense>
              <v-col cols="12">
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel v-for="(row, index) in group_item_list" :key="index">
                    <v-expansion-panel-header>
                      <v-row dense class="pa-1 ma-0" :class="row_backgroup_color_group(row)">
                        <v-col cols="5" style="font-size: 16px;">
                          <v-icon
                            @click="removeItemFromGroup(row.invoice_group_id,'multi',row.change_order)"
                            v-if="(row.has_child_count== 0 &&  (row.total_spent_amount == 0  &&  row.total_invoiced_amount == 0))"
                            color="#a61f38"
                          >mdi-delete-circle</v-icon>
                          {{row.group_name}}
                        </v-col>
                        <v-col cols="2" class="text-right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                v-if="row.total_spent_amount!=0.00"
                                @click="redirectToTransaction(row.invoice_group_id,'transaction',row.change_order,null)"
                              >
                                Spent :
                                <b
                                  :class="row_qty_rate_color(row.total_spent_amount)"
                                >{{ row.total_spent_amount ? itemFormatWithDollar(parseFloat(row.total_spent_amount).toFixed(2)) : '0.00'}}</b>
                              </span>
                            </template>
                            <span>Balance: {{(row.total_balance_amount ? itemFormatWithDollar(parseFloat(row.total_balance_amount).toFixed(2)) : '$0.00' )}}</span>
                          </v-tooltip>
                        </v-col>
                        <v-col cols="2" class="text-right">
                          <!-- <span
                            v-if="row.total_invoiced_amount!=0.00"
                            :class="row_qty_rate_color(row.total_invoiced_amount)"
                            @click="redirectToTransaction(row.invoice_group_id,'invoice',null,null)"
                          >-->
                          <span
                            v-if="row.total_invoiced_amount!=0.00"
                            :class="row_qty_rate_color(row.total_invoiced_amount)"
                            @click="getInvoicedTransactionList(row.invoice_group_id,row.change_order, row.group_name)"
                          >
                            Invoiced :
                            <b>${{itemFormat((row.total_invoiced_amount).toFixed(2))}}</b>
                          </span>
                        </v-col>
                        <v-col cols="3" class="text-right">
                          <v-row dense>
                            <v-col
                              cols="6"
                              class="pr-2"
                              :class="row_qty_rate_color(row.total_cost_amount)"
                            >
                              <span>
                                <b>{{row.total_cost_amount ? itemFormatWithDollar((row.total_cost_amount).toFixed(2)) :''}}</b>
                              </span>
                            </v-col>
                            <v-col
                              cols="6"
                              class="text-center"
                              :class="row_qty_rate_color(row.total_group_amount)"
                            >
                              <span>
                                <b>{{row.total_group_amount ? itemFormatWithDollar((row.total_group_amount).toFixed(2)) : ''}}</b>
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table dense class="fix-table-layout">
                        <tbody>
                          <tr
                            v-for="(item, index2) in row.items"
                            :key="index2"
                            class="mt-3"
                            :class="row_backgroup_color_item(item)"
                          >
                            <td width="4%">
                              <v-icon
                                v-if="item.child_count == 0 && item.transaction_assign_value == 0"
                                @click="removeItemFromGroup(item.project_data_id,'single',row.change_order)"
                                color="#a61f38"
                              >mdi-delete-circle</v-icon>
                            </td>
                            <td
                              width="20%"
                            >{{(item.item_job == '2')?(item.job)?item.job.job_name:'':(item.item)?item.item.item_name:''}}</td>
                            <td width="11%">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <span
                                    v-bind="attrs"
                                    v-on="on"
                                  >{{ (item.vendor)?item.vendor.v_code:'' }}</span>
                                </template>
                                <span>{{ (item.vendor)?item.vendor.v_name +' - $'+itemFormat(item.group_total)+ ' / $' + itemFormat(item.all_total): '$'+itemFormat(item.group_total)+ '/ $' + itemFormat(item.all_total) }}</span>
                              </v-tooltip>
                            </td>
                            <td width="11%">{{(item.area)?item.area.name:''}}</td>
                            <td v-if="item.description" width="5%">
                              <v-tooltip left max-width="400">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    style="color:#6e9a35"
                                    @click="update_invoice_group_description_modal=true;desc_modal_id=item.project_data_id;desc_modal_description=item.description"
                                  >mdi-note-text-outline</v-icon>
                                </template>
                                <span>{{item.description}}</span>
                              </v-tooltip>
                            </td>
                            <td v-else width="5%">
                              <v-tooltip left max-width="400">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="update_invoice_group_description_modal=true;desc_modal_id=item.project_data_id;desc_modal_description=item.description"
                                  >mdi-note-text-outline</v-icon>
                                </template>
                              </v-tooltip>
                            </td>
                            <td width="7%">
                              <span :class="row_qty_rate_color(item.qty)">{{itemFormat(item.qty)}}</span>
                            </td>
                            <td width="7%">{{(item.uom)?item.uom.ioum_title:''}}</td>
                            <td class="text-right" width="11%">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                    <span
                                      :class="row_qty_rate_color(item.rate)"
                                    >{{itemFormatWithDollar(item.rate)}}</span>
                                  </span>
                                </template>
                                <span
                                  :class="row_qty_rate_color(getOriginUpx(item))"
                                >{{itemFormatWithDollar(getOriginUpx(item))}}</span>
                              </v-tooltip>
                            </td>
                            <td class="text-right" width="11%">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                    <span
                                      :style="{
                                          cursor: 'pointer',
                                          textDecoration: 'underline',
                                          color: parseFloat(item.item_balance) > 0 ? 'blue' : 'inherit'
                                        }"
                                      @click="redirectToTransaction(row.invoice_group_id,'transaction',row.change_order,item.project_data_id)"
                                      :class="row_qty_rate_color(getProjectDataAmt(item))"
                                    >{{itemFormatWithDollar(getProjectDataAmt(item))}}</span>
                                  </span>
                                </template>
                                <span>Net Cost : {{(item.item_cost ? itemFormatWithDollar(parseFloat(item.item_cost).toFixed(2)) : '$0.00' )}}</span> /
                                <span>Spent: {{(item.item_spent ? itemFormatWithDollar(parseFloat(item.item_spent).toFixed(2)) : '$0.00' )}}</span> /
                                <span>Balance: {{((item.item_balance && item.item_cost > 0) ? itemFormatWithDollar(parseFloat(item.item_balance).toFixed(2)) : '$0.00' )}}</span>
                              </v-tooltip>
                            </td>
                            <td class="text-right" width="11%">
                              <span
                                :class="row_qty_rate_color(orderAmount(item))"
                              >{{itemFormatWithDollar(orderAmount(item))}}</span>
                            </td>
                            <td width="5%">
                              <v-icon
                                v-if="item.child_count == 0  && item.parent_id == 0"
                                @click="openUpdateInvoiceGroupDialog(item)"
                              >mdi-border-color</v-icon>
                              <!-- <v-icon  
                              @click="update_invoice_group_description_modal=true;desc_modal_id=item.project_data_id;desc_modal_description=item.description">mdi-border-color</v-icon>-->
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </div>
          <div>
            <v-row dense class="blue lighten-4 mt-1" style="font-size: 17px; height: 30px;">
              <v-col cols="4" class="d-flex">
                <v-col cols="4" style="padding:0px">
                  <span
                    class
                  >{{(selectedRows[0])?selectedRows[0].multiplier:''}}{{selectedRows[0] && selectedRows[0].p_price && selectedRows[0].multiplier ? ' / ' : ''}}{{(selectedRows[0])? selectedRows[0].p_price ? selectedRows[0].p_price: '':''}}</span>
                </v-col>
                <v-col cols="8" class="text-right" style="padding:0px">
                  Ungrouped Spent :
                  <b
                    :class="row_qty_rate_color(group_total_amt.total_ungroup_spent_amt)"
                  >{{(group_total_amt.total_ungroup_spent_amt)? itemFormatWithDollar(parseFloat(group_total_amt.total_ungroup_spent_amt).toFixed(2)):'0.00'}}</b>
                </v-col>
              </v-col>
              <v-col cols="2" class="text-right">
                Spent :
                <b
                  :class="row_qty_rate_color(group_total_amt.total_spent_amt)"
                >{{(group_total_amt.total_spent_amt)? itemFormatWithDollar(parseFloat(group_total_amt.total_spent_amt).toFixed(2)):'0.00'}}</b>
              </v-col>
              <v-col cols="2" class="text-right">
                Rec.Pay :
                <b
                  style="cursor:pointer;"
                  @click="redirectToTransactionPayDue()"
                >{{(project_received_value)? itemFormatWithDollar(parseFloat(project_received_value).toFixed(2)):'0.00'}}</b>
              </v-col>
              <v-col cols="2" class="text-right pr-5">
                <b
                  :class="row_qty_rate_color(group_total_amt.total_cost_amt)"
                >{{(group_total_amt.total_cost_amt)? itemFormatWithDollar(parseFloat(group_total_amt.total_cost_amt).toFixed(2)):'0.00'}}</b>
              </v-col>
              <v-col cols="2" class="text-left pr-5" style="padding-left:30px;">
                <b
                  :class="row_qty_rate_color(group_total_amt.total_amt)"
                >{{(group_total_amt.total_amt)? itemFormatWithDollar(parseFloat(group_total_amt.total_amt).toFixed(2)):'0.00'}}</b>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="update_area_dialog" persistent max-width="310px">
      <v-card :loading="update_area_loading">
        <v-card-title>
          <span class="headline">Update Area</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-autocomplete
                dense
                hide-details
                v-model="update_multiple_item.area_id"
                :items="getAreaByForm(project_data_flag)"
                item-text="name"
                item-value="area_id"
                :error-messages="update_multiple_item_error.area_id"
                :menu-props="{closeOnContentClick:true}"
                :search-input.sync="area_search"
              >
                <template v-slot:no-data v-if="area_search">
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No Area Found!</span>
                    <span
                      @click="addArea2(project_data_flag)"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="update_area_dialog = false;update_multiple_item = {};update_multiple_item_error = {}"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateItemsArea()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_area_dialog" persistent max-width="500px">
      <v-card
        :loading="update_area_loading"
        style="max-height: 500px; display: flex; flex-direction: column;"
      >
        <v-card-title>
          <span class="headline">Select Area</span>
        </v-card-title>

        <!-- Scrollable Content -->
        <v-card-text style="overflow-y: auto; flex: 1;min-height:350px;">
          <v-container>
            <v-row dense>
              <!-- Select All Checkbox -->
              <v-col cols="12">
                <v-checkbox
                  v-model="selectAllAreas"
                  label="Select All"
                  hide-details
                  @change="toggleSelectAll"
                />
              </v-col>

              <!-- Autocomplete -->
              <v-col cols="12">
                <v-autocomplete
                  dense
                  multiple
                  hide-details
                  v-model="selected_area_for_report"
                  :items="area_list_for_report"
                  item-text="name"
                  item-value="area_id"
                  :menu-props="{closeOnContentClick:true}"
                  :search-input.sync="area_search"
                >
                  <template v-slot:no-data v-if="area_search">
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                      >No Area Found!</span>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="error"
            @click="show_area_dialog = false; selected_area_for_report = '';"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="selectAllAreas='';generateGroupItemAreaPDF()"
          >Generate Report</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="transaction_list_dialogue" width="800px">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" text-right>
              <v-card-title class="d-inline">{{transaction_group_name}}</v-card-title>
              <v-btn icon class="ml-4 header_btn float-right d-flex"></v-btn>
            </v-col>
          </v-row>
          <v-data-table
            :headers="transaction_list_header"
            class="elevation-1 rounded-0 my-transaction-table"
            :items="transaction_list"
            :items-per-page="-1"
            dense
            fix-header
            hide-default-footer
            disable-pagination
            style="max-height:500px !important;overflow:auto"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td width="14%" class="text-left">
                  <span :title="item.bank_id ? item.bank.bank_name : ''">
                    {{
                    item.bank_id ? item.bank.bank_code : ""
                    }}
                  </span>
                </td>
                <td width="14%" class="text-left">{{ getFormatedDate(item.trans_date) }}</td>
                <td width="14%" class="text-right">
                  <div>
                    <span
                      :class="{
                            'error--text': item.rev_amount < 0,
                            'primary--text': item.rev_amount > 0,
                          }"
                    >${{ getAmountFormat(item.rev_amount) }}</span>
                  </div>
                </td>
                <td
                  width="14%"
                  class="text-center"
                >{{ (item.generated_invoice && item.generated_invoice.invoice_number ? item.generated_invoice.invoice_number:'') }}</td>

                <td width="14%" class="text-right">
                  <div v-if="item.generated_invoice">
                    <span
                      :class="{
                    'error--text': item.invoice_amt < 0,
                    'primary--text': item.invoice_amt >  0,
                  }"
                    >${{ getAmountFormat(item.invoice_amt) }}</span>
                  </div>
                  <div v-if="!item.generated_invoice && item.generated_inv_id">
                    <span class="error--text">${{ getInvoiceAmt(item) }}</span>
                  </div>
                </td>

                <td class="text-left" width="14%">
                  <v-tooltip bottom v-if="item.expence">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                      >{{ (item.expance_details)?item.expance_details.bank_code:'' }}</span>
                    </template>
                    <span>{{ (item.expance_details)?item.expance_details.bank_name:'' }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ (item.vendor)?item.vendor.v_code:'' }}</span>
                    </template>
                    <span>{{ (item.vendor)?item.vendor.v_name:'' }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr>
                <td colspan="2">
                  <b>Total</b>
                </td>
                <td
                  class="text-right"
                  :class="{
                              'error--text': transaction_list_total < 0,
                              'primary--text': transaction_list_total > 0,
                            }"
                >
                  <b>${{getAmountFormat(transaction_list_total)}}</b>
                </td>
                <td></td>
                <td
                  class="text-right"
                  :class="{
                              'error--text': transaction_list_inv_total < 0,
                              'primary--text': transaction_list_inv_total > 0,
                            }"
                >
                  <b>${{getAmountFormat(transaction_list_inv_total)}}</b>
                </td>
                <td></td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <Add :project_type="this.$route.params.project_type" />
    <Edit />
    <Upload />
    <DocList />
    <TaskList :vendor_list="task_vendor_list" :user_list="users" :project_list="task_project_list" />
    <LogList />
    <SalesInvoiceReport
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :sales_invoice_report="sales_invoice_report"
      :is_with_cost="this.is_with_cost"
      @updateValue="sales_invoice_report = false"
    />
    <CounterTopSalesInvoiceReport
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :counter_top_sales_invoice_report="counter_top_sales_invoice_report"
      @updateValue="counter_top_sales_invoice_report = false"
    />
    <CounterTopOrderReport
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :counter_top_order_report="counter_top_order_report"
      @updateValue="counter_top_order_report = false"
    />
    <AcceptanceReport
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :acceptance_report="acceptance_report"
      @updateValue="acceptance_report = false"
    />
    <SignOffReport
      :sign_off_for="sign_off_for"
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :sign_off_report="sign_off_report"
      @updateValue="sign_off_report = false"
    />
    <G702Report
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :g702_report="g702_report"
      :g702_change_report="g702_change_report"
      @updateValue="g702_report = false"
    />
    <G703Report
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :g703_report="g703_report"
      :g703_change_report="g703_change_report"
      @updateValue="g703_report = false"
    />
    <G703CostPlusReport
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :g703_cost_plus_report="g703_cost_plus_report"
      :g703_cost_plus_change_report="g703_cost_plus_change_report"
      @updateValue="g703_cost_plus_report = false"
    />
    <ChangeOrderReport
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :change_order_report="change_order_report"
      @updateValue="change_order_report = false"
      :is_with_rate="this.is_with_rate"
    />
    <ContractReport
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :contract_report="contract_report"
      @updateValue="contract_report = false"
    />
    <PartialLienReleaseReport
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :partial_lien_release_report="partial_lien_release_report"
      @updateValue="partial_lien_release_report = false"
    />
    <FinalLienReleaseReport
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :final_lien_release_report="final_lien_release_report"
      @updateValue="final_lien_release_report = false"
    />
    <TEReport
      :project_details="(selectedRows[0])?selectedRows[0]:{}"
      :report_header_name="report_header_name"
      :TE_report="TE_report"
      @updateValue="TE_report = false"
    />
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import Add from "./Add";
import Edit from "./Edit";
import AddItem from "../items/Add";
import EditItem from "../items/Edit";
// import AddJob from "../jobs/Add";
// import EditJob from "../jobs/Edit";
import Upload from "../document/Upload";
import DocList from "../document/List";
import TaskList from "../task/TaskList";
import SalesInvoiceReport from "../projects/SalesInvoiceReport";
import CounterTopSalesInvoiceReport from "../projects/CounterTopSalesInvoiceReport";
import G702Report from "../projects/G702Report";
import G703Report from "../projects/G703Report";
import G703CostPlusReport from "../projects/G703CostPlusReport";
import ChangeOrderReport from "../projects/ChangeOrderReport";
import TEReport from "../projects/TEReport";
import ContractReport from "../projects/ContractReport";
import PartialLienReleaseReport from "../projects/PartialLienReleaseReport";
import FinalLienReleaseReport from "../projects/FinalLienReleaseReport";
import CounterTopOrderReport from "../projects/CounterTopOrderReport";
import AcceptanceReport from "../projects/AcceptanceReport";
import SignOffReport from "../projects/SignOffReport";
import LogList from "../log/List";
import {
  parseParams,
  getUpxDiscount,
  getMultiplierDiscount,
  getOverhandAndProfitAmt,
  logout
} from "../../plugins/helper";
import { mapMutations, mapState } from "vuex";
// import { set } from 'vue/types/umd';

function intialData() {
  return {
    group_total_amt: {},
    is_with_cost: false,
    is_with_qty: false,
    is_item_spent: false,
    is_with_order_amount: true,
    is_area_wise_without_cost: false,
    selected_area_for_report: "",
    area_list_for_report: [],
    filter_menu2: false,
    project_invoice_amt: 0,
    project_payment_due: 0,
    project_order_value: 0,
    project_received_value: 0,
    active_flag: "",
    from_add_edit_item: "",
    g702_report: false,
    update_group_item_loading: false,
    update_multiple_item: {},
    update_multiple_item_error: {},
    delete_multiple_item: {},
    area_search: "",
    update_area_loading: false,
    g703_report: false,
    g703_cost_plus_report: false,
    update_area_dialog: false,
    show_area_dialog: false,
    contract_report: false,
    change_order_report: false,
    partial_lien_release_report: false,
    final_lien_release_report: false,
    sign_off_for: "",
    sort_field: "item_job_name",
    invoice_group_search: "",
    sort_type: "ASC",
    panel: [],
    group_item_loading: false,
    group_item_dialog: false,
    group_item_list: [],
    group_response_status: false,
    group_item_click: false,
    selected_project: "",
    project_data_items: [],
    project_data_vendors: [],
    project_data_areas: [],
    project_data_filter: {
      item_id: "",
      vendor_id: "",
      area_id: ""
    },
    closeOnContentClick: false,
    active_item_job_index: "",
    active_stone_select_index: "",
    active_item_job_vendor_id: "",
    sales_invoice_report: false,
    counter_top_sales_invoice_report: false,
    counter_top_order_report: false,
    acceptance_report: false,
    sign_off_report: false,
    add_vendor_flag: null,
    invoice_group_modal: false,
    invoice_group_loading: false,
    invoice_group_data: {},
    invoice_group_error: {},
    invoice_group_list: [],
    update_invoice_group_error: {},
    update_invoice_group_data: {},
    save_invoice_group_data: {},
    desc_modal_id: "",
    desc_modal_description: "",
    update_invoice_group_modal: false,
    vendor_data: {
      price_override: true
    },
    vendor_data_error: {},
    setting_data: {},
    add_new_vendor_loading: false,
    active_project_data_index: null,
    add_new_vendor_dialog: false,
    // new_vendor_price_override: false,
    // new_vendor_rate:'',
    change_item_job_price_dialog: false,
    active_stone_index: null,
    change_stone_price_dialog: false,
    change_price_dialog: false,
    change_group_price_dialog: false,
    vendor_change_dialog: false,
    vendor_change_group_dialog: false,
    vendor_master_price_change_dialog: false,
    item_vendor_index: "",
    active_index: null,
    description_box: false,
    group_description_box: false,
    delete_change_order_dialog: false,
    delete_change_order_flag: false,
    change_order_flag: false,
    open_doc_model_falg: false,
    open_log_model_falg: false,
    total_value: 0,
    counter_area_search: null,
    total_invoice_amt: 0,
    total_payment_due: 0,
    total_received_money: 0,
    total_pending_invoice_amount: 0,
    total_balance: 0,
    project_work_menu: false,
    project_work_menu2: false,
    report_menu: false,
    change_order_id: null,
    next_change_order_id: 0,
    is_change_order: "no",
    item_group_data: {},
    item_group_error: {},
    change_orders: [],
    item_group_loading: false,
    item_group_dialog: false,
    discount_dialog: false,
    add_accessory_flag: false,
    discount_dialog_loading: false,
    cabinet_order_model: false,
    view_cabinet_order_screen: false,
    delete_project_cabinet_order_dialog: false,
    delete_assign_group_item: false,
    accessory_item_list_loading: false,
    remove_assign_transaction_group: false,
    remove_project_data_id: "",
    edit_cabinet_order_flag: false,
    cabinet_order_flag: null,
    remove_acc_item_dialog: false,
    accessory_item_dialog: false,
    cabinet_order_setting_flag: false,
    cabinet_order_setting: {},
    cabinet_order_id: null,
    cab_o_acc_item_id: null,
    remove_acc_item_index: null,
    edit_product_cab_o_id: null,
    add_item_accessory_flag: null,
    discount_data: {},
    cabinet_order_loading: false,
    cabinet_selection: [],
    cabinet_order_list: [],
    accessory_item_list: [],
    cabinet_accessory_item_data: {
      custom_qty_flag: false,
      qty: 1,
      item_vendor_list: []
    },
    search: "",
    loading: false,
    counter_top_id: null,
    delete_project_countor_top_dialog: false,
    counter_list_expand: false,
    cabinet_order_list_expand: false,
    stone_selection_expand: true,
    cabinet_selection_expand: true,
    item_job_list_expand: false,
    view_counter_top_screen: false,
    edit_countor_top_entry: false,
    edit_counter_top_id: null,
    add_new_item_job: false,
    remove_item_job_id: null,
    change_stock_item_id: null,
    remove_item_job_dialog: false,
    item_vendor_list: [],
    cabinet_type_list: [],
    cabinet_style_list: [],
    total_balance_flag: false,
    item_job_data: {
      item_job: "0"
    },
    item_job_error: {},
    items: {
      data: []
    },
    users: [],
    countertop_list: [],
    sink_group_list: [],
    item_job_list: [],
    filter_menu: false,
    delete_dialog: false,
    add_project_data_model: false,
    add_project_data_loading: false,
    add_counter_top_loading: false,
    project_data_flag: null,
    selected_project_data_index: null,
    selected_project_stone_index: null,
    delete_project_data_dialog: false,
    delete_project_stone_dialog: false,
    selected_project_cabinet_index: null,
    delete_project_cabinet_dialog: false,
    update_invoice_group_description_modal: false,
    stone_data: [],
    sink_vendor_list: [],
    cut_job_vendor_list: [],
    countertop_order_data: {
      left_splash: false,
      back_splash: false,
      right_splash: false,
      electrical_cut_out: false,
      sink_cut_out: false,
      cooktop_cut_out: false,
      qty: 1
    },
    countertop_order_error: {},
    cabinet_order_data: {
      modify_flag: false,
      cabinet_width_list: [],
      accessory: false,
      modify: false,
      custom_order_qty: false,
      order_qty: 1,
      assembly: false,
      delivery_charge: false
    },
    cabinet_order_error: {},
    selected_stone: [],
    add_counter_top_model: false,
    add_project_data: [],
    item_list: [],
    counter_top_item_list: [],
    uom_list: [],
    vendor_list: [],
    expanded: [],
    customer_list: [],
    area_list: [],
    job_list: [],
    edge_profile_list: [],
    elec_cut_out_list: [],
    sink_cut_out_list: [],
    cooktop_cut_out_list: [],
    sink_list: [],
    cut_job_list: [],
    stone_group_list: [],
    group_stone_list: [],
    all_type_item_list: [],
    select_all_checkbox: false,
    is_with_rate: false,
    g703_change_report: false,
    g703_cost_plus_change_report: false,
    g702_change_report: false,
    stone_edit_data: {},
    task_project_list: [],
    task_vendor_list: [],
    report_header_name: "",
    TE_report: false,
    selectAllAreas: false,
    item_type_list: [
      { text: "Item", value: "0" },
      { text: "Stone", value: "1" },
      { text: "Job", value: "2" }
    ],
    headers: [
      { value: "", text: "", sortable: false, width: "3%" },
      { value: "checkbox", text: "#", sortable: false, width: "3%" },
      { value: "display_date", text: "Date", sortable: true, width: "7%" },
      {
        value: "short_order_type",
        text: "O/E",
        sortable: false,
        width: "5%",
        align: "center"
      },
      // { value: "customer.full_name", text: "Customer", sortable: true, width: "17%"},
      { value: "p_name", text: "Project", sortable: true, width: "19%" },
      // { value: "p_code", text: "Code", sortable: false, width: "7%" },
      // { value: "mobile", text: "Mobile", sortable: false, width: "10%", align:"center" },
      {
        value: "",
        text: "Order Value",
        sortable: false,
        width: "9%",
        align: "right"
      },
      {
        value: "",
        text: "P & L",
        sortable: false,
        width: "9%",
        align: "right"
      },
      {
        value: "",
        text: "Pen.Invoice",
        sortable: false,
        width: "9%",
        align: "right"
      },
      {
        value: "",
        text: "Invoiced",
        sortable: false,
        width: "9%",
        align: "right"
      },
      {
        value: "",
        text: "Pay. Due",
        sortable: false,
        width: "9%",
        align: "right"
      },
      { value: "", text: "", sortable: false, width: "7%" },
      // { value: "estimated_completed_date", text: "Compl. Dt", sortable: false, width: "8%", align:"center" },
      {
        value: "",
        text: "Money Rec.",
        sortable: false,
        align: "right",
        width: "9%"
      },
      { value: "", text: "", sortable: false, width: "2%" }
    ],
    discount_types: [
      { text: "Percentage(%)", value: 1 },
      { text: "Flat($)", value: 2 }
    ],
    date_filter: [
      { text: "Today", value: "1" },
      { text: "Custom", value: "8" },
      { text: "Last 7 Days", value: "2" },
      { text: "Last 30 Days", value: "3" },
      { text: "Last 60 Days", value: "4" },
      { text: "Last 90 Days", value: "5" },
      { text: "This Year", value: "6" },
      { text: "Last Year", value: "7" }
    ],
    types: [
      { text: "All", value: "1" },
      { text: "Estimate", value: "2" },
      { text: "Order", value: "3" }
    ],
    status: [
      { text: "Order", value: "1" },
      { text: "Estimate", value: "2" },
      { text: "EstToOrd", value: "3" },
      { text: "Outstading", value: "4" },
      { text: "Open Orders", value: "5" },
      { text: "Canceled Estimates", value: "6" },
      { text: "Canceled Orders", value: "7" },
      { text: "Customer Refund", value: "8" }
    ],
    status2: [
      { text: "All", value: "all" },
      { text: "Active", value: "1" },
      { text: "Inactive", value: "0" }
    ],
    splash_height_list: [
      { text: "4", value: "4" },
      { text: "6", value: "6" },
      { text: "Custom", value: "custom" }
    ],
    dimension_list: [
      { text: "25.5", value: "25.5" },
      { text: "22.5", value: "22.5" },
      { text: "Custom", value: "custom" }
    ],
    qty_list: [
      {
        text: "0",
        value: "0"
      },
      {
        text: "1",
        value: "1"
      },
      {
        text: "2",
        value: "2"
      },
      {
        text: "3",
        value: "3"
      },
      {
        text: "4",
        value: "4"
      },
      {
        text: "5",
        value: "5"
      },
      {
        text: "6",
        value: "6"
      },
      {
        text: "7",
        value: "7"
      },
      {
        text: "8",
        value: "8"
      },
      {
        text: "9",
        value: "9"
      }
    ],
    order_qty_list: [
      {
        text: "1",
        value: 1
      },
      {
        text: "2",
        value: 2
      },
      {
        text: "3",
        value: 3
      },
      {
        text: "4",
        value: 4
      },
      {
        text: "5",
        value: 5
      },
      {
        text: "6",
        value: 6
      },
      {
        text: "7",
        value: 7
      },
      {
        text: "8",
        value: 8
      },
      {
        text: "9",
        value: 9
      },
      {
        text: "10",
        value: 10
      },
      {
        text: "Custom",
        value: "custom"
      }
    ],

    tran_start_date: "",
    tran_end_date: "",
    pagination: {
      itemsPerPage: 25,
      sortBy: ["p_name"],
      page: 1,
      filters: {
        tran_start_date: "",
        tran_end_date: "",
        date_filter: "",
        type: "1",
        status: "",
        p_active: "1",
        user: "",
        assign_to: "",
        access_to: "",
        customer: ""
      }
    },

    transaction_list_dialogue: false,
    transaction_list: [],
    transaction_list_total: "",
    transaction_list_inv_total: "",
    transaction_group_name: "",
    search_menu: false,
    first_click: true
  };
}
const moment = require("moment");
export default {
  name: "ProjectList",
  data() {
    return intialData();
  },
  components: {
    Add,
    Edit,
    Upload,
    LogList,
    DocList,
    TaskList,
    SalesInvoiceReport,
    CounterTopSalesInvoiceReport,
    CounterTopOrderReport,
    AcceptanceReport,
    SignOffReport,
    AddItem,
    EditItem,
    // AddJob,
    // EditJob,
    G702Report,
    G703Report,
    ChangeOrderReport,
    TEReport,
    ContractReport,
    PartialLienReleaseReport,
    FinalLienReleaseReport,
    G703CostPlusReport
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("project", ["add_modal", "edit_modal"]),
    ...mapState("item", [
      "add_item_modal",
      "edit_item_modal",
      "last_add_item_id",
      "is_cancel"
    ]),
    ...mapState("job", ["add_job_modal", "edit_job_modal", "last_add_job_id"]),
    ...mapState("document", ["doc_list_modal", "refresh_doc_list"]),
    ...mapState("log", ["log_list_modal", "refresh_log_list"]),
    ...mapState("task", ["task_list_modal", "refresh_task_list"]),

    projectWorkTooltip() {
      if (
        this.selectedRows.length == 1 &&
        this.selectedRows[0].project_work.length > 0
      ) {
        if (this.next_change_order_id == 0) {
          return "Add Sales Order";
        } else {
          return "Change Order";
        }
        // if(this.selectedRows[0].project_work == 'counter_tops') {
        //   return 'Counter Tops'
        // } else if(this.selectedRows[0].project_work == 'remodeling') {
        //   return 'Remodeling'
        // } else if(this.selectedRows[0].project_work == 'new_construction') {
        //   return 'New Construction'
        // } else if(this.selectedRows[0].project_work == 'project_management') {
        //   return 'Project Management'
        // } else if(this.selectedRows[0].project_work == 'retail_sales') {
        //   return 'General Invoice'
        // } else {
        //   return ''
        //   }
      } else {
        return "";
      }
    },
    orderTitle() {
      let _self = this;
      let name = _self.next_change_order_id;
      if (name == 0) {
        return "SO";
      } else {
        return "CO-" + name;
      }
    },
    transaction_list_header() {
      return [
        {
          text: "Bank",
          width: "14%",
          sortable: false,
          align: "left",
          class: "text-subtitle-2 font-weight-regular",
          value: "bank.bank_code"
        },
        {
          text: "Date",
          width: "14%",
          sortable: false,
          align: "left",
          class: "text-subtitle-2 font-weight-regular",
          value: "trans_date"
        },
        {
          text: "Amount",
          width: "14%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular",
          value: "amount"
        },
        {
          text: "INV NO.",
          width: "14%",
          sortable: false,
          align: "center",
          class: "text-subtitle-2 font-weight-regular",
          value: "trans_date"
        },
        {
          text: "INV Amt.",
          width: "14%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular",
          value: "amount"
        },
        {
          text: "Vendor",
          width: "14%",
          sortable: false,
          align: "left",
          class: "text-subtitle-2 font-weight-regular",
          value: "vendor.v_code"
        }
      ];
    },
    getGroupTotal() {
      let total = 0;
      this.group_item_list.filter(item => {
        total =
          parseFloat(total) + parseFloat(this.getGroupItemTotal(item.items));
      });
      return total.toFixed(2);
    },
    selected_item_job() {
      return this.add_project_data.filter(item => {
        return item.selected == true;
      });
    },
    getTotalOfSelectedItems() {
      let total = 0;
      this.add_project_data.filter(item => {
        if (item.selected) {
          if (item.qty * item.rate > 0) {
            total =
              parseFloat(total) + parseFloat(this.getProjectDataAmt(item));
          }
        }
      });
      return total.toFixed(2);
    },
    selected_item_job_index() {
      let active_index = "";
      if (this.selected_item_job.length == 1) {
        this.add_project_data.filter((item, index) => {
          if (item.selected) {
            active_index = index;
          }
        });
      }
      return active_index;
    },
    disable_order_type() {
      let flag = false;
      if (
        this.selectedRows.length != 1 ||
        this.open_doc_model_falg ||
        this.open_log_model_falg ||
        this.selectedRows[0].project_work.length == 0
      ) {
        flag = true;
      }
      return flag;
    },
    checkValueForAddVendor() {
      if (
        this.vendor_data.vendor_id &&
        ((this.vendor_data.invoice_price && this.vendor_data.deliver_price) ||
          (this.vendor_data.override_price && this.vendor_data.price_override))
      ) {
        return false;
      } else {
        return true;
      }
    },
    get_selected_item_name() {
      let item_name = "";
      if (this.add_vendor_flag == "project_data") {
        if (this.add_project_data[this.active_project_data_index]) {
          for (let i = 0; i < this.item_list.length; i++) {
            if (
              this.item_list[i].item_id ==
              this.add_project_data[this.active_project_data_index].item_job_id
            ) {
              item_name = this.item_list[i].item_name;
            }
          }
        }
      } else if (this.add_vendor_flag == "group_item") {
        if (this.update_invoice_group_data) {
          for (let i = 0; i < this.item_list.length; i++) {
            if (
              this.item_list[i].item_id ==
              this.update_invoice_group_data.item_job_id
            ) {
              item_name = this.item_list[i].item_name;
            }
          }
        }
      } else if (this.add_vendor_flag == "stone") {
        if (this.stone_data[this.active_project_data_index]) {
          for (let i = 0; i < this.group_stone_list.length; i++) {
            if (
              this.group_stone_list[i].item_id ==
              this.stone_data[this.active_project_data_index].stone_id
            ) {
              item_name = this.group_stone_list[i].item_name;
            }
          }
        }
      } else if (this.add_vendor_flag == "item") {
        if (this.item_job_data.item_job_id) {
          for (let i = 0; i < this.item_list.length; i++) {
            if (this.item_list[i].item_id == this.item_job_data.item_job_id) {
              item_name = this.item_list[i].item_name;
            }
          }
        }
      } else if (this.add_vendor_flag == "counter_top_item") {
        if (this.item_job_data.item_job_id) {
          for (let i = 0; i < this.counter_top_item_list.length; i++) {
            if (
              this.counter_top_item_list[i].item_id ==
              this.item_job_data.item_job_id
            ) {
              item_name = this.counter_top_item_list[i].item_name;
            }
          }
        }
      }
      return item_name;
    },
    is_enable_change_order() {
      if (this.selectedRows.length != 1) {
        return false;
      } else {
        let returnData = false;
        if (
          this.selectedRows[0].invoices_count > 0 &&
          !this.change_order_flag
        ) {
          returnData = true;
        }
        return returnData;
      }
    },
    disableChangeOrder() {
      if (this.selectedRows.length != 1 || this.change_order_id) {
        return true;
      } else {
        let returnData = true;
        if (this.selectedRows[0].invoices_count > 0) {
          returnData = false;
        }
        return returnData;
      }
    },
    getAssignUserName() {
      let user_name = "";
      if (this.pagination.filters.assign_to) {
        this.users.filter(item => {
          if (item.user_id == this.pagination.filters.assign_to) {
            user_name = item.full_name;
          }
        });
      }
      return user_name;
    },
    disableGroupBtn() {
      let disable = true;
      this.add_project_data.filter(item => {
        if (item.selected) {
          disable = false;
        }
      });
      return disable;
    },
    totalAssembly() {
      let total = 0;
      this.cabinet_order_list.filter(item => {
        if (this.cabinet_order_setting.assembly && item.assembly) {
          total += parseFloat(this.cabinet_order_setting.assembly);
        }
      });
      return total.toFixed(2);
    },
    totalDeliveryCharge() {
      let total = 0;
      this.cabinet_order_list.filter(item => {
        if (
          this.cabinet_order_setting.delivery_charge &&
          item.delivery_charge
        ) {
          total += parseFloat(this.cabinet_order_setting.delivery_charge);
        }
      });
      return total.toFixed(2);
    },
    totalInstall() {
      let total = 0;
      this.cabinet_order_list.filter(item => {
        if (this.cabinet_order_setting.install && item.install) {
          total += parseFloat(this.cabinet_order_setting.install);
        }
      });
      return total.toFixed(2);
    },
    getProjectOrderAmount() {
      if (this.selectedRows[0]) {
        let total_discount = 0;
        this.countertop_list.filter(item => {
          let counter_cost = this.getCounterCost(item);
          total_discount += parseFloat(
            this.getCounterCostDiscoutedAmt(counter_cost)
          );
        });

        this.item_job_list.filter(item => {
          if (item.qty && item.rate) {
            let item_job_cost = item.qty * item.rate;
            total_discount += parseFloat(
              this.getCounterCostDiscoutedAmt(item_job_cost)
            );
          }
        });
        if (
          this.selectedRows[0].countertop_discount > 0 &&
          this.selectedRows[0].countertop_discount_type == 2
        ) {
          total_discount =
            total_discount - this.selectedRows[0].countertop_discount;
        }

        return total_discount.toFixed(2);

        // let orderAmount = this.totalCounterTopAmount;
        // if(orderAmount > 0) {
        //   let discount = 0;
        //   if(this.selectedRows[0].countertop_discount_type == 2) {
        //     discount = this.selectedRows[0].countertop_discount;
        //   } else {
        //     discount = (orderAmount * this.selectedRows[0].countertop_discount) / 100
        //   }
        //   if(this.selectedRows[0].customer && this.selectedRows[0].customer.multiplier > 0) {
        //     orderAmount = orderAmount * this.selectedRows[0].customer.multiplier
        //   }
        //   if(discount > 0) {
        //     orderAmount = orderAmount - discount;
        //   }
        //   return orderAmount.toFixed(2)
        // } else {
        //   return 0.00
        // }
      } else {
        return 0.0;
      }
    },
    getCabinetOrderFinelAmount() {
      if (this.selectedRows[0]) {
        let total = 0.0;
        this.cabinet_order_list.filter(item => {
          total += parseFloat(
            this.getCabinetOrderDiscountAmt(this.getCabinetOrderAmount(item))
          );
        });
        return total.toFixed(2);
        // let orderAmount = this.totalCabinetOrderAmount;
        // if(orderAmount > 0) {
        //   let order_discount_type = this.selectedRows[0].cabinet_order_discount_type;
        //   let order_discount = this.selectedRows[0].cabinet_order_discount;
        //   if(this.cabinet_order_flag == 2) {
        //     order_discount_type = this.selectedRows[0].closet_discount_type;
        //     order_discount = this.selectedRows[0].closet_discount;
        //   }

        //   let discount = 0;
        //   if(order_discount_type == 2) {
        //     discount = order_discount;
        //   } else {
        //     discount = (orderAmount * order_discount) / 100
        //   }
        //   if(this.selectedRows[0].customer && this.selectedRows[0].customer.multiplier > 0) {
        //     orderAmount = orderAmount * this.selectedRows[0].customer.multiplier
        //   }
        //   if(discount > 0) {
        //     orderAmount = orderAmount - discount;
        //   }
        //   return orderAmount.toFixed(2)
        // } else {
        //   return 0.00
        // }
      } else {
        return 0.0;
      }
    },
    getProjectOrderAmount2() {
      if (this.selectedRows[0]) {
        let total_order_amt = 0.0;
        this.add_project_data.filter(item => {
          if (!item.new_entry) {
            total_order_amt += parseFloat(this.orderAmount(item));
          }
        });
        return total_order_amt.toFixed(2);
      } else {
        return 0.0;
      }
    },
    totalCounterTopAmount() {
      let total_counter_cost = this.totalCounterCost;
      let total_item_job = this.totalItemJobCost;
      let orderAmount = 0;
      if (total_counter_cost > 0) {
        orderAmount += parseFloat(total_counter_cost);
      }
      if (total_item_job > 0) {
        orderAmount += parseFloat(total_item_job);
      }
      return orderAmount.toFixed(2);
    },
    getProjectDiscount() {
      let total_discount =
        this.totalCounterTopAmount - this.getProjectOrderAmount;
      return total_discount.toFixed(2);
      // let total_discount = 0.00;
      // let orderAmount = this.totalCounterTopAmount;
      // if(this.selectedRows[0] && orderAmount > 0) {
      //   if(this.selectedRows[0].countertop_discount > 0) {
      //     if(this.selectedRows[0].countertop_discount_type == 2) {
      //       total_discount = this.selectedRows[0].countertop_discount;
      //     } else {
      //       total_discount = (orderAmount * this.selectedRows[0].countertop_discount) / 100
      //     }
      //   }
      //   if(this.selectedRows[0].customer && this.selectedRows[0].customer.multiplier > 0 && this.selectedRows[0].customer.multiplier < 1) {
      //     let multiplier_amount = orderAmount * this.selectedRows[0].customer.multiplier
      //     let multipler_discount = orderAmount - multiplier_amount;
      //     total_discount += parseFloat(multipler_discount);
      //   }
      // }
      // return total_discount.toFixed(2)
    },
    getCabinetOrderDiscount() {
      let total =
        this.totalCabinetOrderAmount - this.getCabinetOrderFinelAmount;
      return total.toFixed(2);
      // let total_discount = 0.00;
      // let orderAmount = this.totalCabinetOrderAmount;
      // if(this.selectedRows[0] && orderAmount > 0) {
      //   let order_discount_type = this.selectedRows[0].cabinet_order_discount_type;
      //   let order_discount = this.selectedRows[0].cabinet_order_discount;
      //   if(this.cabinet_order_flag == 2) {
      //     order_discount_type = this.selectedRows[0].closet_discount_type;
      //     order_discount = this.selectedRows[0].closet_discount;
      //   }
      //   if(order_discount > 0) {
      //     if(order_discount_type == 2) {
      //       total_discount = parseFloat(order_discount);
      //     } else {
      //       total_discount = parseFloat((orderAmount * order_discount) / 100)
      //     }
      //   }
      //   if(this.selectedRows[0].customer && this.selectedRows[0].customer.multiplier > 0 && this.selectedRows[0].customer.multiplier < 1) {
      //     let multiplier_amount = orderAmount * this.selectedRows[0].customer.multiplier
      //     let multipler_discount = orderAmount - multiplier_amount;
      //     total_discount += parseFloat(multipler_discount);
      //   }
      // }
      // return total_discount.toFixed(2)
    },
    getProjectDiscount2() {
      let total_discount = this.totalOrderAmount - this.getProjectOrderAmount2;
      return total_discount.toFixed(2);
    },
    totalOrderAmount() {
      let total_order_amt = 0.0;
      this.add_project_data.filter(item => {
        if (!item.new_entry && item.qty * item.rate > 0) {
          total_order_amt += parseFloat(item.qty * item.rate);
        }
      });
      return total_order_amt.toFixed(2);
    },
    totalCounterCost() {
      let total_counter_cost = 0.0;
      this.countertop_list.filter(item => {
        let counter_cost = this.getCounterCost(item);
        if (counter_cost > 0) {
          total_counter_cost += parseFloat(counter_cost);
        }
      });
      return total_counter_cost;
    },
    totalCabinetOrderAmount() {
      let total = 0.0;
      this.cabinet_order_list.filter(item => {
        total += parseFloat(this.getCabinetOrderAmount(item));
      });
      return total.toFixed(2);
    },
    totalItemJobCost() {
      let total_item_job_cost = 0.0;
      this.item_job_list.filter(item => {
        if (item.qty && item.rate) {
          let item_job_cost = item.qty * item.rate;
          total_item_job_cost += parseFloat(item_job_cost);
        }
      });
      return total_item_job_cost.toFixed(2);
    },
    total_amount() {
      if (this.total_sq_ft > 0 && this.countertop_order_data.price > 0) {
        let total_amount = this.total_sq_ft * this.countertop_order_data.price;
        return total_amount.toFixed(2);
      } else {
        return "";
      }
    },
    disableAddEditItemJobIcon() {
      if (this.add_new_item_job) {
        return true;
      } else {
        let edit_mode_entry = "no";
        this.item_job_list.filter(item => {
          if (item.edit_mode) {
            edit_mode_entry = "yes";
          }
        });
        if (edit_mode_entry == "yes") {
          return true;
        } else {
          return false;
        }
      }
    },
    calculatSinkCost() {
      return this.countertop_order_data.sink_qty &&
        this.countertop_order_data.sink_price
        ? (
            this.countertop_order_data.sink_qty *
            this.countertop_order_data.sink_price
          ).toFixed(2)
        : " ";
    },
    calculatCutJobCost() {
      console.log(
        "this.countertop_order_data.cut_job_qty",
        this.countertop_order_data.cut_job_qty,
        this.countertop_order_data.cut_job_price
      );
      return this.countertop_order_data.cut_job_qty &&
        this.countertop_order_data.cut_job_price
        ? (
            this.countertop_order_data.cut_job_qty *
            this.countertop_order_data.cut_job_price
          ).toFixed(2)
        : " ";
    },
    calculateCounterCost() {
      let total_cost = 0;
      if (this.total_amount > 0) {
        total_cost = parseFloat(this.total_amount);
      }
      if (this.calculatSinkCost > 0) {
        total_cost = parseFloat(total_cost) + parseFloat(this.calculatSinkCost);
      }
      if (this.calculateCutOutPrice > 0) {
        total_cost =
          parseFloat(total_cost) + parseFloat(this.calculateCutOutPrice);
      }
      return total_cost > 0 ? total_cost.toFixed(2) : "";
    },
    calculateCutOutPrice() {
      let edge_profile = 0;
      if (
        this.countertop_order_data.edge_profile &&
        this.countertop_order_data.edge_profile_qty &&
        this.countertop_order_data.edge_profile_price
      ) {
        edge_profile =
          this.countertop_order_data.edge_profile_qty *
          this.countertop_order_data.edge_profile_price;
      }
      let ele_cut_out = 0;
      if (
        this.countertop_order_data.elec_cut_out_job_id &&
        this.countertop_order_data.elec_cut_out_qty &&
        this.countertop_order_data.elec_cut_out_price
      ) {
        ele_cut_out =
          this.countertop_order_data.elec_cut_out_qty *
          this.countertop_order_data.elec_cut_out_price;
      }
      let sink_cut_out = 0;
      if (
        this.countertop_order_data.sink_cut_out_job_id &&
        this.countertop_order_data.sink_cut_out_qty &&
        this.countertop_order_data.sink_cut_out_price
      ) {
        sink_cut_out =
          this.countertop_order_data.sink_cut_out_qty *
          this.countertop_order_data.sink_cut_out_price;
      }
      let cooktop_cut_out = 0;
      if (
        this.countertop_order_data.cooktop_cut_out_job_id &&
        this.countertop_order_data.cooktop_cut_out_qty &&
        this.countertop_order_data.cooktop_cut_out_price
      ) {
        cooktop_cut_out =
          this.countertop_order_data.cooktop_cut_out_qty *
          this.countertop_order_data.cooktop_cut_out_price;
      }
      let total =
        parseFloat(edge_profile) +
        parseFloat(ele_cut_out) +
        parseFloat(sink_cut_out) +
        parseFloat(cooktop_cut_out);
      return total > 0 ? total.toFixed(2) : "";
    },
    disableRemodeling() {
      if (this.selectedRows.length != 1) {
        return true;
      } else {
        let returnData = true;
        this.selectedRows[0].project_work.filter(item => {
          if (item.project_work == "remodeling") {
            returnData = false;
          }
        });
        return returnData;
      }
    },
    disableDesignWork() {
      if (this.selectedRows.length != 1) {
        return true;
      } else {
        let returnData = true;
        this.selectedRows[0].project_work.filter(item => {
          if (item.project_work == "design_work") {
            returnData = false;
          }
        });
        return returnData;
      }
    },
    disableCounterTopOrder() {
      if (this.selectedRows.length != 1) {
        return true;
      } else {
        let returnData = true;
        this.selectedRows[0].project_work.filter(item => {
          if (item.project_work == "counter_tops") {
            returnData = false;
          }
        });
        return returnData;
      }
    },
    disableCabinetOrder() {
      if (this.selectedRows.length != 1) {
        return true;
      } else {
        let returnData = true;
        this.selectedRows[0].project_work.filter(item => {
          if (item.project_work == "cabinets") {
            returnData = false;
          }
        });
        return returnData;
      }
    },
    disableNewConstruction() {
      if (this.selectedRows.length != 1) {
        return true;
      } else {
        let returnData = true;
        this.selectedRows[0].project_work.filter(item => {
          if (item.project_work == "new_construction") {
            returnData = false;
          }
        });
        return returnData;
      }
    },
    disableProjectManagement() {
      if (this.selectedRows.length != 1) {
        return true;
      } else {
        let returnData = true;
        this.selectedRows[0].project_work.filter(item => {
          if (item.project_work == "project_management") {
            returnData = false;
          }
        });
        return returnData;
      }
    },
    disableRetailSales() {
      if (this.selectedRows.length != 1) {
        return true;
      } else {
        let returnData = true;
        this.selectedRows[0].project_work.filter(item => {
          if (item.project_work == "retail_sales") {
            returnData = false;
          }
        });
        return returnData;
      }
    },
    disableClosets() {
      if (this.selectedRows.length != 1) {
        return true;
      } else {
        let returnData = true;
        this.selectedRows[0].project_work.filter(item => {
          if (item.project_work == "closets") {
            returnData = false;
          }
        });
        return returnData;
      }
    },
    cutOutLine() {
      if (
        this.countertop_order_data.area_id &&
        this.countertop_order_data.stone_id &&
        this.countertop_order_data.qty &&
        this.countertop_order_data.length &&
        this.countertop_order_data.dimension
      ) {
        return false;
      } else {
        return true;
      }
    },
    sinkLine() {
      if (
        this.countertop_order_data.area_id &&
        this.countertop_order_data.stone_id &&
        this.countertop_order_data.qty &&
        this.countertop_order_data.length &&
        this.countertop_order_data.dimension
      ) {
        return false;
      } else {
        return true;
      }
    },
    qtyLine() {
      if (
        this.countertop_order_data.area_id &&
        this.countertop_order_data.stone_id
      ) {
        return false;
      } else {
        return true;
      }
    },
    splashHeight() {
      if (
        this.countertop_order_data.area_id &&
        this.countertop_order_data.stone_id &&
        (this.countertop_order_data.right_splash ||
          this.countertop_order_data.back_splash ||
          this.countertop_order_data.left_splash)
      ) {
        return false;
      } else {
        return true;
      }
    },
    disableBtn() {
      if (
        this.countertop_order_data.qty &&
        this.countertop_order_data.length &&
        this.countertop_order_data.dimension
      ) {
        if (this.countertop_order_data.dimension == "custom") {
          if (this.countertop_order_data.custom_dimension) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    totalStone() {
      let total_stone = 0;
      this.stone_data.filter(item => {
        if (!item.new_entry) {
          total_stone++;
        }
      });
      return total_stone;
    },
    totalCabinetSelection() {
      let total = 0;
      this.cabinet_selection.filter(item => {
        if (!item.new_entry) {
          total++;
        }
      });
      return total;
    },
    editModeRecord() {
      if (this.add_project_data) {
        let edit_mode_data = this.add_project_data.filter(item => {
          if (item.edit_mode) {
            return item;
          }
        });
        if (edit_mode_data.length >= 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    editModeRecord2() {
      if (this.stone_data) {
        let edit_mode_data = this.stone_data.filter(item => {
          if (item.edit_mode) {
            return item;
          }
        });

        if (edit_mode_data.length >= 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    editModeCabinetSelection() {
      if (this.cabinet_selection) {
        let edit_mode_data = this.cabinet_selection.filter(item => {
          if (item.edit_mode) {
            return item;
          }
        });
        if (edit_mode_data.length >= 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    total_sq_ft() {
      let sq_ft = 0;
      let dimension = this.countertop_order_data.dimension;
      if (this.countertop_order_data.dimension == "custom") {
        dimension = this.countertop_order_data.custom_dimension;
      }
      if (
        this.countertop_order_data.left_splash ||
        this.countertop_order_data.back_splash ||
        this.countertop_order_data.right_splash
      ) {
        let total = 0;
        if (this.countertop_order_data.left_splash) {
          total = total + parseFloat(dimension);
        }
        if (this.countertop_order_data.back_splash) {
          total = total + parseFloat(this.countertop_order_data.length);
        }
        if (this.countertop_order_data.right_splash) {
          total = total + parseFloat(dimension);
        }
        let splace_height = this.countertop_order_data.splace_height;
        if (this.countertop_order_data.splace_height == "custom") {
          splace_height = this.countertop_order_data.custom_splace_height;
        }
        if (splace_height > 0) {
          sq_ft = (total * splace_height) / 144;
          sq_ft = sq_ft * this.countertop_order_data.qty;
        }
      }
      let sq_ft2 = (this.countertop_order_data.length * dimension) / 144;
      sq_ft2 = sq_ft2 * this.countertop_order_data.qty;
      sq_ft = parseFloat(sq_ft) + parseFloat(sq_ft2);
      if (sq_ft > 0) {
        return sq_ft.toFixed(2);
      } else {
        return "";
      }
    },
    filtersCount() {
      let count = 0;
      for (var key in this.pagination.filters) {
        if (
          this.pagination.filters[key] &&
          key != "tran_start_date" &&
          key != "tran_end_date"
        ) {
          count++;
        }
      }
      if (
        this.pagination.filters.tran_start_date &&
        this.pagination.filters.tran_end_date
      ) {
        count++;
      }
      if (count == 1) {
        return "D";
      } else {
        return count;
      }
    },
    filtersCount2() {
      let count = 0;
      if (this.project_data_filter.item_id) {
        count++;
      }
      if (this.project_data_filter.vendor_id) {
        count++;
      }
      if (this.project_data_filter.area_id) {
        count++;
      }
      return count;
    },
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "tbl_projects.p_name";
      return paginationData;
    },
    getStyles() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {
          maxWidth: "95%",
          margin: "0 auto"
        };
      } else {
        return {};
      }
    }
  },
  watch: {
    doc_list_modal: function(value) {
      if (!value) {
        this.open_doc_model_falg = false;
      } else {
        this.open_doc_model_falg = true;
      }
    },
    log_list_modal: function(value) {
      if (!value) {
        this.open_log_model_falg = false;
      } else {
        this.open_log_model_falg = true;
      }
    },
    search() {
      this.getProjects();
    },
    project_data_filter: {
      handler: function() {
        this.filter_menu2 = false;
        this.getProjectData();
      },
      deep: true
    },
    pagination: {
      handler: function() {
        console.log("this.getProjects");
        this.getProjects();
      },
      deep: true
    },
    add_modal: function(value) {
      if (!value) {
        this.resetFilter();
      }
    },
    edit_modal: function(value) {
      if (!value) {
        this.resetFilter();
      }
    },
    add_item_modal: function(value) {
      if (!value) {
        this.getItems("add");
      }
    },
    edit_item_modal: function(value) {
      if (!value) {
        if (!this.is_cancel) {
          this.getItems("edit");
        }
      }
    },
    add_job_modal: function(value) {
      if (!value) {
        this.getJobs("add");
      }
    },
    edit_job_modal: function(value) {
      if (!value) {
        this.getJobs("edit");
      }
    },
    group_response_status: function(value) {
      if (value && this.group_item_click) {
        this.group_item_dialog = true;
        this.loading = false;
      }
    }
  },
  methods: {
    ...mapMutations("item", ["setItemData"]),
    ...mapMutations("job", ["setJobData"]),
    ...mapMutations("utils", ["setAlert"]),
    ...mapMutations("project", ["setData"]),
    ...mapMutations("document", ["setModal", "setDocumentData"]),
    ...mapMutations("task", ["setTaskData"]),
    ...mapMutations("log", ["setLogData"]),
    ...mapMutations("transaction", ["setTransactionData"]),
    row_qty_rate_color(val) {
      if (val < 0) {
        return "red--text";
      }
    },
    showProjectWorkPopup() {
      if (this.selectedRows[0].project_work == "counter_tops") {
        this.add_counter_top_model = true;
      } else {
        this.add_project_data_model = true;
        // this.group_item_dialog = true;
      }
    },
    toggleSelectAll(val) {
      if (val) {
        // Select all area IDs
        this.selected_area_for_report = this.area_list_for_report.map(
          a => a.area_id
        );
      } else {
        // Deselect all
        this.selected_area_for_report = [];
      }
    },
    showProjectGroupPopup() {
      this.addProjectOrderValueLog(this.selectedRows[0].project_id, "start");
      this.loading = true;
      if (this.group_response_status == true) {
        this.group_item_dialog = true;
        this.loading = false;
      }
    },
    itemFormatWithDollar(val) {
      if (val < 0) {
        val = val.toString();
        val = val.replace("-", "");
        return "($" + val + ")";
      } else {
        return "$" + val;
      }
    },
    itemFormat(val) {
      if (val < 0) {
        val = val.toString();
        val = val.replace("-", "");
        return "(" + val + ")";
      } else {
        return val;
      }
    },
    itemFormatForSent(val) {
      if (val < 0) {
        val = val.toString();
        val = val.replace("-", "");
        return val;
      } else {
        return val;
      }
    },
    row_backgroup_color_item(item) {
      let child_count = item.child_count;
      if (child_count > 0) {
        return "red lighten-5";
      }
      if (item.is_split == "YES") {
        return "orange lighten-5";
      }
    },
    row_backgroup_color_group(row) {
      let order = row.change_order;
      let next_change_order_id = this.next_change_order_id;
      if (next_change_order_id - parseFloat(1) == order) {
        return "light-green lighten-4";
      } else if (next_change_order_id == order) {
        return "grey lighten-2";
      } else {
        return "red lighten-5";
      }
    },
    resetProjectDataFilter() {
      this.project_data_filter = {
        item_id: "",
        vendor_id: "",
        area_id: ""
      };
    },
    removeDiscount() {
      let _self = this;
      _self.discount_data = { ..._self.discount_data, discount: 0 };
    },
    changeSelectAll() {
      if (this.select_all_checkbox) {
        this.add_project_data = this.add_project_data.map(function(item) {
          item.selected = true;
          return item;
        });
      } else {
        this.add_project_data = this.add_project_data.map(function(item) {
          item.selected = false;
          return item;
        });
      }
    },

    getProjectShortType(item) {
      // if (item.project_work.length > 0) {
      if (item.project_work == "counter_tops") {
        return "C/";
      } else if (item.project_work == "remodeling") {
        return "R/";
      } else if (item.project_work == "new_construction") {
        return "N/";
      } else if (item.project_work == "project_management") {
        return "P/";
      }
      // } else {
      //   return "";
      // }
    },
    getOriginUpx(row_data) {
      let rate = 0;
      if (row_data.item_vendor_list && row_data.item_vendor_list.length > 0) {
        row_data.item_vendor_list.filter(item => {
          if (item.vendor_id == row_data.vendor_id) {
            if (item.price_override == "1") {
              rate = item.override_price;
            } else {
              rate = item.sales_price;
            }
          }
        });
        return rate;
      }
    },
    getAddedSinkItem(event, project_counter_top_entry_id) {
      if (event == true) {
        this.countertop_list = this.countertop_list.map(function(item) {
          if (
            item.project_counter_top_entry_id == project_counter_top_entry_id
          ) {
            item.selected = true;
          } else {
            item.selected = false;
          }
          return item;
        });
        this.item_job_list_expand = true;
        this.item_job_list = this.item_job_list.map(function(item) {
          var all_counter_top_ids_array = item.all_counter_top_id
            ? item.all_counter_top_id.split(",").map(Number)
            : "";
          if (
            all_counter_top_ids_array.includes(project_counter_top_entry_id)
          ) {
            item.sink_item = true;
          } else {
            item.sink_item = false;
          }
          return item;
        });
      } else {
        this.countertop_list = this.countertop_list.map(function(item) {
          item.selected = false;
          return item;
        });
        this.item_job_list = this.item_job_list.map(function(item) {
          item.sink_item = false;
          return item;
        });
      }
    },
    getAssignCounterTopItem(event, counter_top_id, all_counter_top_id) {
      var all_counter_top_ids_array = all_counter_top_id.split(",").map(Number);
      this.counter_list_expand = true;
      if (event == true) {
        this.item_job_list = this.item_job_list.map(function(item) {
          if (item.counter_top_id == counter_top_id) {
            item.selected = true;
          } else {
            item.selected = false;
          }
          return item;
        });
        this.item_job_list_expand = true;
        this.countertop_list = this.countertop_list.map(function(item) {
          if (
            all_counter_top_ids_array.includes(
              item.project_counter_top_entry_id
            )
          ) {
            item.sink_item = true;
          } else {
            item.sink_item = false;
          }
          return item;
        });
      } else {
        this.item_job_list = this.item_job_list.map(function(item) {
          item.selected = false;
          return item;
        });
        this.countertop_list = this.countertop_list.map(function(item) {
          item.sink_item = false;
          return item;
        });
      }
    },
    redirectToTransaction(co_group_id, tab, co_co_id, co_item_id) {
      this.setTransactionData({ key: "is_from_project", value: true });
      this.setTransactionData({ key: "redirect_to", value: tab });
      this.setTransactionData({
        key: "co_project_id",
        value: this.selectedRows[0].project_id
      });
      this.setTransactionData({ key: "co_group_id", value: co_group_id });
      this.setTransactionData({ key: "co_co_id", value: co_co_id });
      this.setTransactionData({ key: "co_item_id", value: co_item_id });
      let routeData = this.$router.resolve({ name: "Transaction" });
      window.open(
        routeData.href,
        "_blank",
        "newwindow",
        "width=1300, height=768"
      );
    },
    redirectToTransactionPayDue() {
      this.setTransactionData({ key: "is_from_project", value: true });
      this.setTransactionData({
        key: "redirect_to",
        value: "transaction_income"
      });
      this.setTransactionData({
        key: "co_project_id",
        value: this.selectedRows[0].project_id
      });
      let routeData = this.$router.resolve({ name: "Transaction" });
      window.open(
        routeData.href,
        "_blank",
        "newwindow",
        "width=1300, height=768"
      );
    },

    getProjectList() {
      let _self = this;

      axios
        .get("get_project_list_with_work_type?project_work_type=")
        .then(response => {
          if (response.data.status) {
            _self.task_project_list = response.data.data.projects;
          }
        })
        .catch(function() {});
    },

    generateItemPDF() {
      this.loading = true;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let url =
        "project_id=" +
        this.selectedRows[0].project_id +
        "&user_name=" +
        localStorage.getItem("user_id") +
        "&company_id=" +
        company_data.company_id +
        "&project_data_flag=" +
        this.project_data_flag;
      axios
        .get("generate_item_pdf?" + url)
        .then(response => {
          if (response.data.status) {
            var File_url = response.data.file_url;
            window.open(File_url, "Download");
            this.loading = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      //   window.open(process.env.VUE_APP_BASEURL+'/generate_item_pdf?project_id='+this.selectedRows[0].project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&project_data_flag='+this.project_data_flag,
      //       '_blank'
      //  );
    },
    generateGroupItemPDF() {
      this.loading = true;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let url =
        "project_id=" +
        this.selectedRows[0].project_id +
        "&user_name=" +
        localStorage.getItem("user_id") +
        "&company_id=" +
        company_data.company_id +
        "&project_data_flag=" +
        this.project_data_flag +
        "&is_with_cost=" +
        this.is_with_cost +
        "&is_with_qty=" +
        this.is_with_qty +
        "&is_item_spent=" +
        this.is_item_spent +
        "&is_with_order_amount=" +
        this.is_with_order_amount +
        "&report_header_name=" +
        this.report_header_name;
      axios
        .get("generate_group_item_pdf?" + url)
        .then(response => {
          if (response.data.status) {
            var File_url = response.data.file_url;
            window.open(File_url, "Download");
            this.loading = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      // window.open(
      //     process.env.VUE_APP_BASEURL+'/generate_group_item_pdf?project_id='+this.selectedRows[0].project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&project_data_flag='+this.project_data_flag+'&is_with_cost='+this.is_with_cost+'&is_with_qty='+this.is_with_qty+'&is_item_spent='+this.is_item_spent,
      //     '_blank'
      // );
    },
    generateSalesIncomeReport() {
      this.loading = true;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let url =
        "project_id=" +
        this.selectedRows[0].project_id +
        "&user_name=" +
        localStorage.getItem("user_id") +
        "&company_id=" +
        company_data.company_id +
        "&project_data_flag=" +
        this.project_data_flag +
        "&report_header_name=" +
        this.report_header_name;
      axios
        .get("generate_sales_income_pdf?" + url)
        .then(response => {
          if (response.data.status) {
            var File_url = response.data.file_url;
            window.open(File_url, "Download");
            this.loading = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    generateCalendarTaskReport() {
      this.loading = true;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let url =
        "o_id=" +
        this.selectedRows[0].project_id +
        "&type=8" +
        "&user_name=" +
        localStorage.getItem("user_id") +
        "&company_id=" +
        company_data.company_id +
        "&project_data_flag=" +
        this.project_data_flag +
        "&report_header_name=" +
        this.report_header_name;
      axios
        .get("generate_calendar_task_detail_pdf?" + url)
        .then(response => {
          if (response.data.status) {
            var File_url = response.data.file_url;
            window.open(File_url, "Download");
            this.loading = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      // window.open(
      //     process.env.VUE_APP_BASEURL+'/generate_group_item_pdf?project_id='+this.selectedRows[0].project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&project_data_flag='+this.project_data_flag+'&is_with_cost='+this.is_with_cost+'&is_with_qty='+this.is_with_qty+'&is_item_spent='+this.is_item_spent,
      //     '_blank'
      // );
    },
    generateGroupItemAreaPDF() {
      this.loading = true;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let url =
        "project_id=" +
        this.selectedRows[0].project_id +
        "&user_name=" +
        localStorage.getItem("user_id") +
        "&company_id=" +
        company_data.company_id +
        "&project_data_flag=" +
        this.project_data_flag +
        "&is_with_cost=" +
        this.is_with_cost +
        "&is_with_qty=" +
        this.is_with_qty +
        "&is_item_spent=" +
        this.is_item_spent +
        "&is_with_order_amount=" +
        this.is_with_order_amount +
        "&is_area_wise_without_cost=" +
        this.is_area_wise_without_cost +
        "&report_header_name=" +
        this.report_header_name +
        "&selected_area_for_report=" +
        this.selected_area_for_report;
      axios
        .get("generate_group_item_area_pdf?" + url)
        .then(response => {
          if (response.data.status) {
            this.show_area_dialog = false;
            this.selected_area_for_report = "";
            var File_url = response.data.file_url;
            window.open(File_url, "Download");
            this.loading = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      // window.open(
      //     process.env.VUE_APP_BASEURL+'/generate_group_item_pdf?project_id='+this.selectedRows[0].project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&project_data_flag='+this.project_data_flag+'&is_with_cost='+this.is_with_cost+'&is_with_qty='+this.is_with_qty+'&is_item_spent='+this.is_item_spent,
      //     '_blank'
      // );
    },
    showAreaPopup() {
      this.show_area_dialog = true;
      this.loading = true;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      axios
        .get(
          "get_group_item_area?project_id=" +
            this.selectedRows[0].project_id +
            "&company_id=" +
            company_data.company_id
        )
        .then(response => {
          this.area_list_for_report = response.data.data;

          this.show_area_dialog = true;
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    generateTEReport() {
      this.TE_report = true;
    },
    generateG702Report() {
      this.loading = true;
      axios
        .get(
          "get_total_of_ungroup_item?project_id=" +
            this.selectedRows[0].project_id +
            "&report_header_name=" +
            this.report_header_name
        )
        .then(response => {
          if (response.data.total > 0) {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
              dismissCountDown: 0
            });
          } else {
            this.g702_report = true;
          }
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    generateG703Report(p_type = "") {
      this.loading = true;
      axios
        .get(
          "get_total_of_ungroup_item?project_id=" +
            this.selectedRows[0].project_id +
            "&report_header_name=" +
            this.report_header_name
        )
        .then(response => {
          if (response.data.total > 0) {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
              dismissCountDown: 0
            });
          } else {
            if (p_type == "cost_plus") {
              this.g703_cost_plus_report = true;
            } else {
              this.g703_report = true;
            }
          }
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    generateChangeOrderReport() {
      if (this.selectedRows[0].change_order_list > 0) {
        this.loading = true;
        axios
          .get(
            "get_total_of_ungroup_item?project_id=" +
              this.selectedRows[0].project_id +
              "&report_header_name=" +
              this.report_header_name
          )
          .then(response => {
            if (response.data.total > 0) {
              this.setAlert({
                show: true,
                variant: "error",
                message:
                  "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
                dismissCountDown: 0
              });
            } else {
              this.change_order_report = true;
            }
            this.loading = false;
          })
          .catch(function() {
            this.loading = false;
          });
      }
    },
    generateContractReport() {
      this.loading = true;
      axios
        .get(
          "get_total_of_ungroup_item?project_id=" +
            this.selectedRows[0].project_id +
            "&report_header_name=" +
            this.report_header_name
        )
        .then(response => {
          if (response.data.total > 0) {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
              dismissCountDown: 0
            });
          } else {
            this.contract_report = true;
          }
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    generatePartialLienReleaseReport() {
      this.loading = true;
      axios
        .get(
          "get_total_of_ungroup_item?project_id=" +
            this.selectedRows[0].project_id +
            "&report_header_name=" +
            this.report_header_name
        )
        .then(response => {
          if (response.data.total > 0) {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
              dismissCountDown: 0
            });
          } else {
            this.partial_lien_release_report = true;
          }
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    generateFinalLienReleaseReport() {
      this.loading = true;
      axios
        .get(
          "get_total_of_ungroup_item?project_id=" +
            this.selectedRows[0].project_id +
            "&report_header_name=" +
            this.report_header_name
        )
        .then(response => {
          if (response.data.total > 0) {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
              dismissCountDown: 0
            });
          } else {
            this.final_lien_release_report = true;
          }
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    signOffReport() {
      if (
        this.selectedRows.length == 1 &&
        this.selectedRows[0].project_work.length > 0
      ) {
        if (this.selectedRows[0].project_work == "counter_tops") {
          this.generateSignOffReport(2);
        } else if (this.selectedRows[0].project_work == "remodeling") {
          this.generateSignOffReport(4);
        } else if (this.selectedRows[0].project_work == "new_construction") {
          this.generateSignOffReport(5);
        } else if (this.selectedRows[0].project_work == "project_management") {
          this.generateSignOffReport(6);
        }
      }
    },
    addEditProjectWork() {
      if (
        this.selectedRows.length == 1 &&
        this.selectedRows[0].project_work.length > 0
      ) {
        this.change_order_id = null;
        if (this.selectedRows[0].project_work == "counter_tops") {
          this.addCounterTop();
        } else if (this.selectedRows[0].project_work == "remodeling") {
          this.addProjectData(2);
        } else if (this.selectedRows[0].project_work == "new_construction") {
          this.addProjectData(1);
        } else if (this.selectedRows[0].project_work == "project_management") {
          this.addProjectData(4);
        } else if (this.selectedRows[0].project_work == "retail_sales") {
          this.addProjectData(5);
        }
      }
      if (this.first_click == true) {
        this.getVendors();
        this.getItems("", true);
        this.getAreas();
        this.geUom();

        if (this.selectedRows[0].project_work == "counter_tops") {
          this.getAllTypeItem();
          this.getStone();
          this.getSink();
          this.getCutJob();
          this.getCounterTopItemList(0);
        }

        this.getItemSettings();
        this.first_click = false;
      }
    },
    all() {
      this.panel = this.group_item_list.map((key, index) => index);
    },
    none() {
      this.panel = [];
    },
    getAmountFormat(value) {
      if (value) {
        value = value.toString();
        return value.replace("-", "");
      } else {
        return 0;
      }
    },
    updateGroupItem() {
      this.group_item_loading = true;

      axios
        .post("edit_invoice_group_items", this.update_invoice_group_data)
        .then(response => {
          let data = response.data;
          this.update_invoice_group_error = {};
          if (!data.status) {
            for (let key in data.errors) {
              this.update_invoice_group_error[key] = data.errors[key][0];
            }
          } else {
            this.update_invoice_group_data = {};
            (this.select_all_checkbox = false),
              (this.update_invoice_group_modal = false);
            this.itemGroupList();
          }
          this.group_item_loading = false;
        })
        .catch(() => {
          this.group_item_loading = false;
        });
    },
    removeItemFromGroup(project_data_id, $type, $change_order) {
      this.group_item_loading = true;
      let remove_assign_transaction_group = this
        .remove_assign_transaction_group;
      let next_change_order_id = this.next_change_order_id;
      let type = $type;
      let change_order = $change_order;
      let project_id = this.selectedRows[0].project_id;

      axios
        .post("remove_invoice_group_items", {
          project_data_id: project_data_id,
          remove_assign_transaction_group: remove_assign_transaction_group,
          next_change_order_id: next_change_order_id,
          type: type,
          change_order: change_order,
          project_id: project_id
        })
        .then(res => {
          if (res.data.status) {
            this.itemGroupList();
            this.getProjectData();
            this.getProjectBalanceData();
          } else {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "Group is assigned to Transaction <br/>Item can not be Delete.",
              dismissCountDown: 0
            });
            //  this.remove_project_data_id=res.data.project_data_id;
            //  this.delete_assign_group_item=true;
            //  this.remove_assign_transaction_group=false;
          }
          this.group_item_loading = false;
        })
        .catch(() => {
          this.group_item_loading = false;
        });
    },
    getGroupItemTotal(items) {
      let total = 0;
      items.filter(item => {
        if (item.qty * item.rate > 0) {
          total = parseFloat(total) + parseFloat(this.orderAmount(item));
        }
      });
      return total.toFixed(2);
    },
    itemGroupList(isInitialCall) {
      // this.loading = true;
      this.group_item_loading = true;
      axios
        .get(
          "get_item_group?project_data_flag=" +
            this.project_data_flag +
            "&project_id=" +
            this.selectedRows[0].project_id +
            "&next_change_order_id=" +
            this.next_change_order_id
        )
        .then(response => {
          let data = response.data;
          this.group_response_status = data.status;
          this.group_item_list = data.data;
          this.group_item_list = this.group_item_list.map(function(item) {
            let data = item.items;
            let child_counts = [];
            for (let key in data) {
              if (data[key].child_count > 0) {
                child_counts.push(data[key].child_count);
              }
            }
            if (child_counts.length > 0) {
              item.has_child_count = "1";
            } else {
              item.has_child_count = "0";
            }
            return item;
          });

          //  this.items.data = this.items.data.map(function (item) {
          //           if (item.project_id == itemData.item.project_id) {
          //             item.expande_icon = 'mdi-chevron-up';
          //             item.selected = true;
          //           } else {
          //             item.expande_icon = 'mdi-chevron-down';
          //           }
          //           return item;
          //         });

          if (isInitialCall && this.group_item_list.length > 0) {
            // this.panel = [];
            // this.group_item_dialog = true;
          }
          this.group_total_amt = {
            total_amt: data.total_amt,
            total_cost_amt: data.total_cost_amt,
            total_invoiced_amt: data.total_invoiced_amt,
            total_spent_amt: data.total_spent_amt,
            total_ungroup_spent_amt: data.total_ungroup_spent_amt
          };
          this.group_item_loading = false;
          // this.loading = false;
        })
        .catch(function() {
          this.group_item_loading = false;
          // this.loading = false;
        });
    },
    addInvoiceGroup() {
      this.item_group_loading = true;
      axios
        .post("add_invoice_group", { name: this.invoice_group_search })
        .then(response => {
          this.invoice_group_list.push(response.data.data);
          this.invoice_group_data.invoice_group_id =
            response.data.data.invoice_group_id;
          this.update_invoice_group_data.invoice_group_id =
            response.data.data.invoice_group_id;
          this.item_group_loading = false;
        })
        .catch(function() {
          this.item_group_loading = false;
        });
    },
    sortList(field_name) {
      if (this.sort_type == "ASC") {
        this.sort_type = "DESC";
      } else {
        this.sort_type = "ASC";
      }
      this.sort_field = field_name;
      this.getProjectData();
    },
    groupItems() {
      this.invoice_group_loading = true;
      let ids = [];
      this.selected_item_job.map(item => {
        ids.push(item.project_data_id);
      });
      this.invoice_group_data.items = ids;
      this.invoice_group_data.next_change_order_id = this.next_change_order_id;
      axios
        .post("edit_invoice_group_items", this.invoice_group_data)
        .then(response => {
          let data = response.data;
          this.invoice_group_error = {};
          if (!data.status) {
            for (let key in data.errors) {
              this.invoice_group_error[key] = data.errors[key][0];
            }
          } else {
            this.invoice_group_data = {};
            (this.select_all_checkbox = false),
              (this.invoice_group_modal = false);
            this.getProjectData();
          }
          this.invoice_group_loading = false;
        })
        .catch(() => {
          this.invoice_group_loading = false;
        });
    },
    updateItemsArea() {
      this.update_area_loading = true;
      let ids = [];
      this.selected_item_job.map(item => {
        ids.push(item.project_data_id);
      });
      this.update_multiple_item.items = ids;
      axios
        .post("update_items_area", this.update_multiple_item)
        .then(response => {
          let data = response.data;
          this.update_multiple_item_error = {};
          if (!data.status) {
            for (let key in data.errors) {
              this.update_multiple_item_error[key] = data.errors[key][0];
            }
          } else {
            this.update_multiple_item = {};
            this.update_area_dialog = false;
            (this.select_all_checkbox = false), this.getProjectData();
          }
          this.update_area_loading = false;
        })
        .catch(() => {
          this.update_area_loading = false;
        });
    },
    openInvoiceGroupDialog() {
      this.invoice_group_modal = true;
      this.invoice_group_data = {};
      this.invoice_group_error = {};
    },
    openUpdateInvoiceGroupDialog(item) {
      this.save_invoice_group_data = Object.assign({}, item);
      this.update_invoice_group_modal = true;
      this.update_invoice_group_data = item;
      let selected_group_id = item.group_details.invoice_group_id;
      var index = this.invoice_group_list.findIndex(
        item => item.invoice_group_id === selected_group_id
      );
      if (index == -1) {
        this.invoice_group_list.unshift({
          invoice_group_id: selected_group_id,
          name: item.group_details.name
        });
      }

      // this.update_invoice_group_data = {
      //   items: [],
      //   invoice_group_id: item.invoice_group_id
      // }
      // this.update_invoice_group_data.items.push(item.project_data_id)
      this.update_invoice_group_error = {};
      this.update_invoice_group_data.change_price_in_master = false;
      this.update_invoice_group_data.price_override = false;
      this.update_invoice_group_data.item_spent = item.item_spent;
      if (this.update_invoice_group_data.item_vendor_list.length > 0) {
        this.update_invoice_group_data.item_vendor_list.filter(item => {
          if (
            item.vendor_id == this.update_invoice_group_data.vendor_id &&
            item.price_override
          ) {
            this.update_invoice_group_data.price_override = item.price_override;
          }
        });
      }
    },

    addItem(index, from) {
      this.active_item_job_index = index;
      this.active_stone_select_index = index;
      this.from_add_edit_item = from;
      this.setItemData({ key: "add_item_modal", value: true });
      this.setItemData({ key: "is_cancel", value: false });
    },
    editItem(index, item_id, is_view_mode, vendor_id, flag, from = "") {
      this.active_item_job_index = index;
      this.active_stone_select_index = index;
      this.active_item_job_vendor_id = vendor_id;
      this.active_flag = flag;
      this.from_add_edit_item = from;
      this.setItemData({ key: "edit_item_modal", value: true });
      this.setItemData({ key: "id", value: item_id });
      this.setItemData({ key: "is_view_mode", value: is_view_mode });
      this.setItemData({ key: "is_cancel", value: false });
    },
    // addJob(index) {
    //   this.active_item_job_index = index;
    //   this.setJobData({ key: "add_job_modal", value: true });
    // },
    // editJob(index, item_id, is_view_mode) {
    //   this.active_item_job_index = index;
    //   this.setJobData({ key: "edit_job_modal", value: true });
    //   this.setJobData({ key: "id", value: item_id });
    //   this.setJobData({ key: "is_view_mode", value: is_view_mode });
    // },
    generateSalesInvoiceReport() {
      if (this.selectedRows[0].project_work == "counter_tops") {
        this.counter_top_sales_invoice_report = true;
      } else {
        this.sales_invoice_report = true;
      }
    },
    generateCounterTopOrderReport() {
      this.counter_top_order_report = true;
    },
    generateAcceptanceReport() {
      this.acceptance_report = true;
    },
    generateSignOffReport(sign_off_for) {
      this.report_menu = false;
      this.sign_off_report = true;
      this.sign_off_for = sign_off_for;
    },
    generateCounterReport() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      window.location.href =
        process.env.VUE_APP_BASEURL +
        "/generate_counter_pdf?project_id=" +
        this.selectedRows[0].project_id +
        "&user_name=" +
        localStorage.getItem("user_id") +
        "&company_id=" +
        company_data.company_id +
        "&report_header_name=" +
        this.report_header_name;
    },
    addItemVendor() {
      this.add_new_vendor_loading = true;
      if (this.add_vendor_flag == "project_data") {
        this.vendor_data.item_id = this.add_project_data[
          this.active_project_data_index
        ].item_job_id;
      } else if (this.add_vendor_flag == "stone") {
        this.vendor_data.item_id = this.stone_data[
          this.active_project_data_index
        ].stone_id;
      } else if (this.add_vendor_flag == "item") {
        this.vendor_data.item_id = this.item_job_data.item_job_id;
      } else if (this.add_vendor_flag == "group_item") {
        this.vendor_data.item_id = this.update_invoice_group_data.item_job_id;
      } else if (this.add_vendor_flag == "counter_top_item") {
        this.vendor_data.item_id = this.item_job_data.item_job_id;
      } else if (this.add_vendor_flag == "counter_top_stone") {
        this.vendor_data.item_id = this.countertop_order_data.sink_id;
      } else if (this.add_vendor_flag == "counter_top_cut_job") {
        this.vendor_data.item_id = this.countertop_order_data.cut_job_id;
      }
      this.vendor_data_error = {};
      let _self = this;
      axios
        .post("add_item_vendor", this.vendor_data)
        .then(function(response) {
          let data = response.data.data;
          if (!response.data.status) {
            for (let key in response.data.errors) {
              _self.vendor_data_error[key] = response.data.errors[key][0];
            }
          } else {
            if (_self.add_vendor_flag == "project_data") {
              _self.add_project_data[
                _self.active_project_data_index
              ].item_vendor_list.push(data);
              _self.add_project_data[
                _self.active_project_data_index
              ].vendor_id = _self.vendor_data.vendor_id;
              _self.changeVendor(_self.active_project_data_index);
            } else if (_self.add_vendor_flag == "stone") {
              _self.stone_data[
                _self.active_project_data_index
              ].stone_vendor_list.push(data);
              _self.stone_data[_self.active_project_data_index].vendor_id =
                _self.vendor_data.vendor_id;
              _self.changeVendor2(_self.active_project_data_index);
            } else if (_self.add_vendor_flag == "item") {
              _self.item_vendor_list.push(data);
              _self.item_job_data.vendor_id = _self.vendor_data.vendor_id;
              _self.changeVendor4();
            } else if (_self.add_vendor_flag == "group_item") {
              _self.update_invoice_group_data.item_vendor_list.push(data);
              _self.update_invoice_group_data.vendor_id =
                _self.vendor_data.vendor_id;
              _self.changeGroupVendor();
            } else if (_self.add_vendor_flag == "counter_top_item") {
              _self.item_vendor_list.push(data);
              _self.item_job_data.vendor_id = _self.vendor_data.vendor_id;
              _self.changeVendor4();
            } else if (_self.add_vendor_flag == "counter_top_stone") {
              _self.sink_vendor_list.push(data);
              _self.countertop_order_data.vendor_id =
                _self.vendor_data.vendor_id;
              _self.changeVendor3();
            } else if (_self.add_vendor_flag == "counter_top_cut_job") {
              _self.cut_job_vendor_list.push(data);
              _self.countertop_order_data.cut_job_vendor_id =
                _self.vendor_data.vendor_id;
              _self.changeVendor3();
            }
            _self.add_new_vendor_dialog = false;
          }
          _self.add_new_vendor_loading = false;
        })
        .catch(function() {
          _self.add_new_vendor_loading = false;
        });
    },
    calculateSalesPrice() {
      let invoice_price = parseFloat(this.vendor_data.deliver_price);
      if (invoice_price > 0) {
        let sales_price =
          invoice_price +
          parseFloat((invoice_price * this.setting_data.sales_tax) / 100) +
          parseFloat((invoice_price * this.setting_data.finance_cost) / 100) +
          parseFloat((invoice_price * this.setting_data.markup) / 100) +
          parseFloat(this.setting_data.delivery_cost);
        this.vendor_data.sales_price = sales_price.toFixed(2);
      } else {
        this.vendor_data.sales_price = null;
      }
    },
    addVendorInItem(index, flag, row_data) {
      this.vendor_data = {
        price_override: true
      };
      if (flag == "counter_top_stone" || flag == "counter_top_cut_job") {
        this.add_new_vendor_dialog = true;
        this.add_vendor_flag = flag;
      } else if (flag == "counter_top_item") {
        let price_override = true;
        let rate = row_data.rate;
        let vendor_id = row_data.vendor_id;
        this.vendor_data_error = {};
        this.active_project_data_index = index;
        this.add_vendor_flag = flag;
        if (row_data.item_job_id) {
          this.add_new_vendor_dialog = true;
          this.item_vendor_list.filter(item => {
            if (vendor_id == item.vendor_id) {
              if (item.price_override) {
                this.vendor_data.override_price = rate;
              } else {
                this.vendor_data.invoice_price = item.invoice_price;
                this.vendor_data.deliver_price = item.deliver_price;
                this.calculateSalesPrice();
              }
            }
          });
          this.vendor_data.price_override = price_override;
        }
      } else if (flag == "stone") {
        let price_override = true;
        let rate = row_data.rate;
        let vendor_id = row_data.vendor_id;
        this.vendor_data_error = {};
        this.active_project_data_index = index;
        this.add_vendor_flag = flag;
        if (row_data.stone_id) {
          this.add_new_vendor_dialog = true;
          row_data.stone_vendor_list.filter(item => {
            if (vendor_id == item.vendor_id) {
              if (item.price_override) {
                this.vendor_data.override_price = rate;
              } else {
                this.vendor_data.invoice_price = item.invoice_price;
                this.vendor_data.deliver_price = item.deliver_price;
                this.calculateSalesPrice();
              }
            }
          });
          this.vendor_data.price_override = price_override;
        }
      } else {
        let price_override = row_data.price_override;
        let rate = row_data.rate;
        let vendor_id = row_data.vendor_id;
        this.vendor_data_error = {};
        this.active_project_data_index = index;
        this.add_vendor_flag = flag;
        if (row_data.item_job_id) {
          this.add_new_vendor_dialog = true;
          row_data.item_vendor_list.filter(item => {
            if (vendor_id == item.vendor_id) {
              if (item.price_override) {
                this.vendor_data.override_price = rate;
              } else {
                this.vendor_data.invoice_price = item.invoice_price;
                this.vendor_data.deliver_price = item.deliver_price;
                this.calculateSalesPrice();
              }
            }
          });
          this.vendor_data.price_override = price_override;
        }
      }
    },
    updatePriceAsCurrentItemJob(row_data, index) {
      this.add_counter_top_loading = true;
      let current_price = this.getCurrentPriceOfItemjob(row_data);
      let _self = this;
      axios
        .post("update_price_as_current_item_job", {
          content_id: row_data.counter_top_item_job_id,
          current_price: current_price
        })
        .then(function() {
          _self.item_job_list[index].rate = current_price;
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    getCurrentPriceOfItemjob(row_data) {
      let price = 0;
      this.all_type_item_list.filter(item => {
        if (item.item_id == row_data.item_job_id) {
          item.vendors.filter(item2 => {
            if (item2.vendor_id == row_data.vendor_id) {
              if (item2.price_override) {
                price = item2.override_price;
              } else {
                price = item2.sales_price;
              }
            }
          });
        }
      });
      return price;

      // let price = 0;
      // if(row_data.item_job == '1') {
      //   this.item_list.filter((item) => {
      //     if(item.item_id == row_data.item_job_id) {
      //       item.vendors.filter((item2) => {
      //         if(item2.vendor_id == row_data.vendor_id) {
      //           if(item2.price_override) {
      //             price = item2.override_price
      //           } else {
      //             price = item2.sales_price
      //           }
      //         }
      //       })
      //     }
      //   })
      // } else {
      //   this.job_list.filter((item) => {
      //     if(item.job_id == row_data.item_job_id) {
      //       if(item.px_override) {
      //         price = item.override_price
      //       } else {
      //         price = item.sales_price
      //       }
      //     }
      //   })
      // }
      // return price
    },
    checkChangePrice(index) {
      //if(this.add_project_data[index].new_entry) {
      let price = 0;
      if (this.add_project_data[index].item_job == "1") {
        price = this.getOriginUpx(this.add_project_data[index]);
      } else {
        this.job_list.filter(item => {
          if (item.job_id == this.add_project_data[index].item_job_id) {
            if (item.px_override) {
              price = item.override_price;
            } else {
              price = item.sales_price;
            }
          }
        });
      }
      if (this.add_project_data[index].rate > 0 && price > 0) {
        if (this.add_project_data[index].rate != price) {
          this.active_index = index;
          this.change_price_dialog = true;
        } else {
          this.saveProjectData(index);
        }
      } else {
        this.saveProjectData(index);
      }
      // } else {
      //   this.saveProjectData(index)
      // }
    },
    checkGroupChangePrice() {
      let price = 0;
      price = this.getOriginUpx(this.update_invoice_group_data);
      if (this.update_invoice_group_data.rate > 0 && price > 0) {
        if (this.update_invoice_group_data.rate != price) {
          this.change_group_price_dialog = true;
        } else {
          this.saveGroupProjectData();
        }
      } else {
        this.saveGroupProjectData();
      }
    },
    updatePriceAsCurrent() {
      this.add_project_data_loading = true;
      let _self = this;
      let ids = [];
      this.add_project_data.map((item, index) => {
        this.selected_item_job.map(item1 => {
          if (item1.project_data_id == item.project_data_id) {
            ids.push({
              id: item.project_data_id,
              price: this.getCurrentPrice(item, index)
            });
          }
        });
      });
      axios
        .post("update_price_as_current", {
          content_id: ids
        })
        .then(function() {
          //  this.add_project_data.map((item,index) => {
          //   item.rate =this.getCurrentPrice(item,index)
          //   console.log(item);
          //   return item;
          //  })
          _self.getProjectData();
          _self.getProjectBalanceData();
          _self.select_all_checkbox = false;
          _self.add_project_data_loading = false;
        })
        .catch(function() {
          _self.add_project_data_loading = false;
        });
    },
    updateStonePriceAsCurrent(index) {
      this.add_counter_top_loading = true;
      let standard_price = this.getStonePrice(index);
      let sales_price = standard_price;
      let selected_stone = [];
      this.group_stone_list.filter(item => {
        if (item.item_id == this.stone_data[index].stone_id) {
          selected_stone = item;
        }
      });
      if (
        selected_stone.on_sale &&
        selected_stone.start_date &&
        selected_stone.end_date &&
        selected_stone.discount &&
        this.selectedRows[0]
      ) {
        let project_date = moment(
          this.selectedRows[0].created_at,
          "YYYY-MM-DD"
        );
        if (
          moment(project_date).isBetween(
            selected_stone.start_date,
            selected_stone.end_date,
            "days",
            true
          )
        ) {
          let discount = (sales_price * selected_stone.discount) / 100;
          sales_price = (sales_price - discount).toFixed(2);
        }
      }
      let _self = this;
      axios
        .post("update_stone_price_as_current", {
          content_id: this.stone_data[index].project_stone_id,
          standard_price: standard_price,
          price: sales_price
        })
        .then(function() {
          _self.stone_data[index].standard_price = standard_price;
          _self.stone_data[index].price = sales_price;
          _self.add_counter_top_loading = false;
          _self.getProjectCountorTop();
          _self.getProjectCounterTopItemJob();
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    getCurrentPrice(row_data, index) {
      let price = 0;
      if (row_data.item_job == "1") {
        price = this.getOriginUpx(row_data);
      } else {
        this.job_list.filter(item => {
          if (item.job_id == this.add_project_data[index].item_job_id) {
            if (item.px_override) {
              price = item.override_price;
            } else {
              price = item.sales_price;
            }
          }
        });
      }
      return price;
    },
    getAreaByForm(project_data_flag) {
      let form_name = this.getFormName(project_data_flag);
      let forms_area = this.area_list.filter(item => {
        let module_exists = item.modules.filter(p => p.form_code == form_name);
        if (module_exists.length > 0) {
          return item;
        }
      });
      return forms_area;
    },
    getFormName(project_data_flag) {
      let form_name = "";
      if (project_data_flag == "1") {
        form_name = "NEW_CONSTRUCTION";
      } else if (project_data_flag == "2") {
        form_name = "REMODELING";
      } else if (project_data_flag == "3") {
        form_name = "DESIGN_WORK";
      } else if (project_data_flag == "4") {
        form_name = "PROJECT_MANAGEMENT";
      } else if (project_data_flag == "5") {
        form_name = "RETAIL_SALES";
      } else if (project_data_flag == "6") {
        form_name = "COUNTER_TOP_ORDER";
      } else if (project_data_flag == "7") {
        form_name = "CABINET_ORDER";
      } else if (project_data_flag == "8") {
        form_name = "CLOSETS";
      }
      return form_name;
    },
    addStone() {
      this.$router.push({ path: "/items" });
    },
    addArea(project_data_flag, index) {
      let form_name = this.getFormName(project_data_flag);
      let active_module = [];
      active_module.push(form_name);
      var area_name = "";
      if (project_data_flag >= 1 && project_data_flag <= 5) {
        area_name = this.add_project_data[index].area_search;
        this.add_project_data_loading = true;
      } else if (project_data_flag == "6") {
        area_name = this.counter_area_search;
        this.add_counter_top_loading = true;
      } else if (project_data_flag == "7" || project_data_flag == "8") {
        area_name = this.cabinet_selection[index].wall_name_search;
        this.cabinet_order_loading = true;
      } else if (project_data_flag == "9") {
        area_name = this.update_invoice_group_data.area_search;
      }
      let _self = this;
      axios
        .post("add_area", { name: area_name, modules: active_module })
        .then(function(res) {
          let data = res.data.data;
          _self.area_list.push(data);
          if (project_data_flag >= 1 && project_data_flag <= 5) {
            _self.add_project_data[index].area_id = data.area_id;
          } else if (project_data_flag == "6") {
            _self.countertop_order_data.area_id = data.area_id;
          } else if (project_data_flag == "7" || project_data_flag == "8") {
            _self.cabinet_selection[index].area_id = data.area_id;
          } else if (project_data_flag == "9") {
            _self.update_invoice_group_data.area_id = data.area_id;
          }
          _self.add_counter_top_loading = false;
          _self.add_project_data_loading = false;
          _self.cabinet_order_loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.add_counter_top_loading = false;
          _self.add_project_data_loading = false;
          _self.cabinet_order_loading = false;
        });
    },
    addArea2(project_data_flag) {
      let form_name = this.getFormName(project_data_flag);
      let active_module = [];
      active_module.push(form_name);
      this.update_area_loading = true;
      axios
        .post("add_area", { name: this.area_search, modules: active_module })
        .then(res => {
          let data = res.data.data;
          this.area_list.push(data);
          this.update_multiple_item.area_id = data.area_id;
          this.update_area_loading = false;
        })
        .catch(error => {
          console.log("FAILURE!!", error);
          this.update_area_loading = false;
        });
    },
    deleteChangeOrder() {
      let _self = this;
      axios
        .post("delete_change_order", {
          project_data_flag: this.project_data_flag,
          change_order_id: this.change_order_id
        })
        .then(function() {
          _self.change_order_id = null;
          if (_self.project_data_flag >= 1 && _self.project_data_flag <= 5) {
            _self.addProjectData(_self.project_data_flag);
          } else if (_self.project_data_flag == "6") {
            _self.addCounterTop();
          } else if (_self.project_data_flag == "7") {
            _self.cabinetOrderDialog(1);
          } else if (_self.project_data_flag == "8") {
            _self.cabinetOrderDialog(2);
          }
        })
        .catch(function() {
          console.log("here");
        });
    },

    selectRecord(val) {
      this.getProjectsWithBalance();
      if (this.selectedRows.length == 1) {
        this.group_response_status = false;
        this.group_item_click = false;
        this.group_item_list = [];
        this.addEditProjectWork();
        this.selected_project = this.selectedRows[0].project_id;
      }

      // if (this.selectedRows.length == 0) {

      // }
      if (this.open_doc_model_falg || this.open_log_model_falg) {
        this.items.data.filter(item => {
          if (val == item.project_id) {
            if (this.open_doc_model_falg && this.open_log_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openDocList(item);
              this.openLogList(item);
              setTimeout(() => {
                this.openDocList(item);
                this.openLogList(item);
              }, 500);
            } else if (this.open_doc_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.openDocList(item);
            } else if (this.open_log_model_falg) {
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openLogList(item);
            }
          } else {
            item.selected = false;
          }
        });
      }
    },
    row_backgroup_color(item) {
      if (!item.p_active) {
        return "red lighten-5";
      } else if (item.order_type == "1") {
        return "blue lighten-5";
      } else if (item.order_type == "3") {
        return "indigo lighten-5";
      } else if (item.order_type == "4") {
        return "yellow lighten-5";
      } else if (item.order_type == "5") {
        return "green lighten-5";
      } else if (item.order_type == "6") {
        return "deep-orange lighten-5";
      } else if (item.order_type == "7") {
        return "red lighten-5";
      } else if (item.order_type == "8") {
        return "teal lighten-5";
      } else {
        return "";
      }
    },
    getChangeLogs() {
      if (this.project_data_flag >= 1 && this.project_data_flag <= 5) {
        this.addProjectData(this.project_data_flag);
      } else if (this.project_data_flag == 6) {
        this.addCounterTop();
      } else if (this.project_data_flag == 7 || this.project_data_flag == 8) {
        this.cabinetOrderDialog(this.cabinet_order_flag);
      }
    },
    getChangeOrders() {
      let _self = this;
      // this.loading = true;
      axios
        .get(
          "get_project_change_logs?project_data_flag=" +
            this.project_data_flag +
            "&project_id=" +
            this.selectedRows[0].project_id
        )
        .then(response => {
          _self.change_orders = response.data.data;
          // _self.loading = false;
        })
        .catch(function() {
          // _self.loading = false;
        });
    },
    orderAmount(row_data) {
      if (this.selectedRows.length > 0) {
        let amount = this.getProjectDataAmt(row_data);
        amount =
          parseFloat(amount) +
          parseFloat(
            getOverhandAndProfitAmt(this.selectedRows[0].p_price, amount)
          );
        return amount.toFixed(2);
        // if(this.selectedRows[0].p_price > 0) {
        //   let amount = this.getProjectDataAmt(row_data)
        //   let profilt = (amount * this.selectedRows[0].p_price) / 100
        //   return (parseFloat(amount) + parseFloat(profilt)).toFixed(2)
        // } else {
        //   return this.getProjectDataAmt(row_data)
        // }
      }
    },
    getProjectDataAmt(row_data) {
      if (this.selectedRows.length > 0) {
        let amount = row_data.qty * row_data.rate;
        amount =
          amount -
          getMultiplierDiscount(this.selectedRows[0].multiplier, amount);
        return amount.toFixed(2);
      }
      // let total_discount = 0.00;
      // let orderAmount = row_data.qty * row_data.rate;
      // let discount_type = ''
      // let discount_amt = ''
      // if(this.selectedRows.length > 0){
      //   if(this.project_data_flag == '1') {
      //     discount_type = this.selectedRows[0].new_con_discount_type
      //     discount_amt = this.selectedRows[0].new_con_discount
      //   } else if(this.project_data_flag == '2') {
      //     discount_type = this.selectedRows[0].remodeling_discount_type
      //     discount_amt = this.selectedRows[0].remodeling_discount
      //   } else if(this.project_data_flag == '3') {
      //     discount_type = this.selectedRows[0].design_work_discount_type
      //     discount_amt = this.selectedRows[0].design_work_discount
      //   } else if(this.project_data_flag == '4') {
      //     discount_type = this.selectedRows[0].pro_management_discount_type
      //     discount_amt = this.selectedRows[0].pro_management_discount
      //   } else if(this.project_data_flag == '5') {
      //     discount_type = this.selectedRows[0].retail_sale_discount_type
      //     discount_amt = this.selectedRows[0].retail_sale_discount
      //   }
      //   if(discount_amt > 0) {
      //     if(discount_type == 2) {
      //       total_discount = discount_amt;
      //     } else {
      //       total_discount = (orderAmount * discount_amt) / 100
      //     }
      //   }
      //   if(this.selectedRows[0].customer && this.selectedRows[0].customer.multiplier > 0 && this.selectedRows[0].customer.multiplier < 1) {
      //     let multiplier_amount = orderAmount * this.selectedRows[0].customer.multiplier
      //     let multipler_discount = orderAmount - multiplier_amount;
      //     total_discount += parseFloat(multipler_discount);
      //   }
      //   let total = orderAmount - total_discount;
      //   return total.toFixed(2)
      // }
    },
    getProjectDataItemBalance(row_data) {
      if (this.selectedRows.length > 0) {
        let item_spent = row_data.item_spent ? row_data.item_spent : 0;
        let item_balance_amount =
          parseFloat(this.getProjectDataAmt(row_data)) + parseFloat(item_spent);
        return item_balance_amount.toFixed(2);
      }
    },
    addItemGroup() {
      let _self = this;
      _self.item_group_loading = true;
      this.item_group_data.ids = [];
      this.add_project_data.filter(item => {
        if (item.selected) {
          this.item_group_data.ids.push(item.project_data_id);
        }
      });
      this.item_group_data.project_data_group_flag = this.project_data_flag;
      this.item_group_data.project_id = this.selectedRows[0].project_id;
      axios
        .post("project_data_group", _self.item_group_data)
        .then(response => {
          _self.item_group_data = {};
          _self.item_group_error = {};
          let data = response.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.item_group_error[key] = data.errors[key][0];
            }
          } else {
            _self.setAlert({
              show: true,
              variant: "primary",
              message: data.message,
              dismissCountDown: 0
            });
            this.item_group_dialog = false;
            _self.getProjectData();
            _self.getProjectBalanceData();
          }
          _self.item_group_loading = false;
        })
        .catch(function() {
          _self.item_group_loading = false;
        });
    },
    updateCabinetOrderSetting() {
      this.cabinet_order_setting.project_id = this.selectedRows[0].project_id;
      let _self = this;
      this.cabinet_order_loading = true;
      this.cabinet_order_setting.cabinet_order_flag = this.cabinet_order_flag;
      axios
        .post("update_cabinet_order_setting", this.cabinet_order_setting)
        .then(function(res) {
          _self.selectedRows[0].assembly = res.data.data.assembly;
          _self.selectedRows[0].delivery_charge = res.data.data.delivery_charge;
          _self.selectedRows[0].install = res.data.data.install;
          _self.selectedRows[0].closet_assembly = res.data.data.closet_assembly;
          _self.selectedRows[0].closet_delivery_charge =
            res.data.data.closet_delivery_charge;
          _self.selectedRows[0].closet_install = res.data.data.closet_install;
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
    },
    getCabinetOrderDiscountAmt(orderAmount) {
      let total_discount = 0.0;
      let order_discount_type = this.selectedRows[0]
        .cabinet_order_discount_type;
      let order_discount = this.selectedRows[0].cabinet_order_discount;
      if (this.cabinet_order_flag == 2) {
        order_discount_type = this.selectedRows[0].closet_discount_type;
        order_discount = this.selectedRows[0].closet_discount;
      }
      if (order_discount > 0) {
        if (order_discount_type == 2) {
          total_discount = parseFloat(order_discount);
        } else {
          total_discount = parseFloat((orderAmount * order_discount) / 100);
        }
      }
      if (
        this.selectedRows[0].multiplier > 0 &&
        this.selectedRows[0].multiplier < 1
      ) {
        let multiplier_amount = orderAmount * this.selectedRows[0].multiplier;
        let multipler_discount = orderAmount - multiplier_amount;
        total_discount += parseFloat(multipler_discount);
      }
      let total = orderAmount - total_discount;
      return total.toFixed(2);
    },
    getCabinetOrderAmount(cabinet_row) {
      let totalAmount = cabinet_row.price * cabinet_row.order_qty;
      if (this.cabinet_order_setting.assembly && cabinet_row.assembly) {
        totalAmount += parseFloat(this.cabinet_order_setting.assembly);
      }
      if (
        this.cabinet_order_setting.delivery_charge &&
        cabinet_row.delivery_charge
      ) {
        totalAmount += parseFloat(this.cabinet_order_setting.delivery_charge);
      }
      if (this.cabinet_order_setting.install && cabinet_row.install) {
        totalAmount += parseFloat(this.cabinet_order_setting.install);
      }
      if (cabinet_row.accessory_items.length > 0) {
        cabinet_row.accessory_items.filter(item => {
          totalAmount += item.price * item.qty;
        });
      }
      return totalAmount.toFixed(2);
    },
    getBalance(cabinet) {
      let totalWidth = 0;
      this.cabinet_order_list.filter(item => {
        if (item.cabinet_selection_id == cabinet.cabinet_selection_id) {
          if (item.w && item.order_qty) {
            totalWidth += item.w * item.order_qty;
          }
        }
      });
      if (totalWidth > 0) {
        return (cabinet.wall_length - totalWidth).toFixed(2);
      } else {
        return cabinet.wall_length;
      }
    },
    removeAccessoryItem(row, index) {
      if (row.new_entry) {
        this.accessory_item_list.splice(index, 1);
      } else {
        this.cab_o_acc_item_id = row.cab_o_acc_item_id;
        this.remove_acc_item_dialog = true;
        this.remove_acc_item_index = index;
      }
    },
    removeAccItem() {
      let _self = this;
      this.accessory_item_list_loading = true;
      axios
        .post("remove_accessory_item", {
          id: this.cab_o_acc_item_id,
          is_change_order: this.is_change_order
        })
        .then(function() {
          if (_self.remove_acc_item_index != "list") {
            _self.accessory_item_list.splice(_self.remove_acc_item_index, 1);
          }
          _self.is_change_order = "no";
          _self.getProjectCabinetOrder();
          _self.accessory_item_list_loading = false;
        })
        .catch(function() {
          _self.accessory_item_list_loading = false;
        });
    },
    accessoryItemList() {
      this.accessory_item_dialog = true;
    },
    addAccessoryItem() {
      this.cabinet_accessory_item_data.item_accessory_flag = this.add_item_accessory_flag;
      if (this.edit_cabinet_order_flag) {
        this.cabinet_accessory_item_data.product_cab_o_id = this.edit_product_cab_o_id;
        this.cabinet_accessory_item_data.is_change_order = this.is_change_order;
        this.cabinet_order_loading = true;
        let _self = this;
        axios
          .post("add_accessory_item", this.cabinet_accessory_item_data)
          .then(function(res) {
            _self.accessory_item_list.push(res.data.data);
            _self.resetAccessoryItemData();
            _self.is_change_order = "no";
            _self.cabinet_order_loading = false;
          })
          .catch(function() {
            _self.cabinet_order_loading = false;
          });
      } else {
        this.cabinet_accessory_item_data.new_entry = true;
        if (this.add_item_accessory_flag == 1) {
          this.accessory_list.filter(item => {
            if (
              item.cabinet_id ==
              this.cabinet_accessory_item_data.accessory_item_id
            ) {
              this.cabinet_accessory_item_data.accessory = item;
            }
          });
        } else {
          this.item_list.filter(item => {
            if (
              item.item_id == this.cabinet_accessory_item_data.accessory_item_id
            ) {
              this.cabinet_accessory_item_data.item = item;
            }
          });
          this.cabinet_accessory_item_data.item_vendor_list.filter(item => {
            if (item.vendor_id == this.cabinet_accessory_item_data.vendor_id) {
              this.cabinet_accessory_item_data.vendor = item.vendor;
            }
          });
        }
        this.accessory_item_list.push(this.cabinet_accessory_item_data);
        this.resetAccessoryItemData();
      }
    },
    resetAccessoryItemData() {
      this.cabinet_accessory_item_data = {
        custom_qty_flag: false,
        qty: 1,
        item_vendor_list: []
      };
    },
    changeAccessory() {
      this.accessory_list.filter(item => {
        if (
          item.cabinet_id == this.cabinet_accessory_item_data.accessory_item_id
        ) {
          this.cabinet_accessory_item_data.price = item.list_px;
        }
      });
    },
    changeAccessoryItemQty() {
      if (this.cabinet_accessory_item_data.qty == "custom") {
        this.cabinet_accessory_item_data.custom_qty_flag = true;
        this.cabinet_accessory_item_data.qty = null;
      }
    },
    changeOrderQty() {
      if (this.cabinet_order_data.order_qty == "custom") {
        this.cabinet_order_data.custom_order_qty = true;
        this.cabinet_order_data.order_qty = null;
      }
    },
    changeDefaultCabinet(selected_index) {
      this.cabinet_selection.filter((item, index) => {
        if (selected_index != index) {
          item.default_cabinet = null;
        }
      });
      this.changeCabinetDefaultSelection();
    },
    changeCabinetDefaultSelection() {
      if (!this.edit_cabinet_order_flag) {
        let selectedCabinet = [];
        this.cabinet_selection.filter(item => {
          if (item.default_cabinet == "true") {
            selectedCabinet = item;
          }
        });
        this.cabinet_order_data.area_id = selectedCabinet.area_id;
        this.area_list.filter(item => {
          if (item.area_id == selectedCabinet.area_id) {
            this.cabinet_order_data.area_name = item.name;
          }
        });
        this.cabinet_order_data.cabinet_selection_id =
          selectedCabinet.cabinet_selection_id;
        this.cabinet_order_data.cabinet_type_id =
          selectedCabinet.cabinet_type_id;
        this.cabinet_order_data.h = selectedCabinet.cabinet_height;
        this.cabinet_order_data.d = selectedCabinet.depth;
        let cabinetBalance = this.getBalance(selectedCabinet);
        this.getCabinetWidth(cabinetBalance);
        let _self = this;
        selectedCabinet.cabinet_flag = "details";
        let url = parseParams(selectedCabinet);
        axios
          .get("get_cabinet_selection?" + url)
          .then(response => {
            if (response.data.status) {
              if (response.data.data) {
                let responseData = response.data.data;
                _self.cabinet_order_data.accessory = responseData.accessory;
                _self.cabinet_order_data.modify = responseData.modify;
                _self.cabinet_order_data.item_id = responseData.item_id;
                _self.cabinet_order_data.price = responseData.list_px;
                _self.cabinet_order_data.item_name =
                  responseData.item.item_name;
                _self.cabinet_order_data.cabinet_type_name =
                  responseData.type.name;
              }
            }
            _self.cabinet_order_loading = false;
          })
          .catch(function() {
            _self.cabinet_order_loading = false;
          });

        this.getAccessory(selectedCabinet.width);
      }
    },
    changeModify() {
      this.cabinet_order_loading = true;
      delete this.cabinet_order_data.mw;
      delete this.cabinet_order_data.mh;
      delete this.cabinet_order_data.md;
      this.cabinet_order_loading = false;
    },
    getFinishedEnd(val) {
      let return_val = "";
      if (val == "1") {
        return_val = "Left";
      } else if (val == "2") {
        return_val = "Right";
      } else if (val == "3") {
        return_val = "Both";
      }
      return return_val;
    },
    getHing(val) {
      let return_val = "";
      if (val == "1") {
        return_val = "Left";
      } else if (val == "2") {
        return_val = "Right";
      }
      return return_val;
    },
    resetCabinetOrderData() {
      this.add_accessory_flag = false;
      this.edit_cabinet_order_flag = false;
      this.cabinet_order_data = {
        modify_flag: false,
        cabinet_width_list: [],
        accessory: false,
        modify: false,
        custom_order_qty: false,
        order_qty: 1,
        assembly: false,
        delivery_charge: false
      };
      this.accessory_item_list = [];
      this.changeCabinetDefaultSelection();
    },
    getCabinetWidth(cabinetBalance) {
      let _self = this;
      this.cabinet_order_loading = true;
      axios
        .get(
          "get_cabinet_selection?cabinet_flag=width&cabinet_type_id=" +
            this.cabinet_order_data.cabinet_type_id +
            "&cabinet_balance=" +
            cabinetBalance
        )
        .then(response => {
          if (response.data.status) {
            _self.cabinet_order_data.cabinet_width_list = response.data.data;
          }
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
    },
    resetProjectCabinet(index) {
      let _self = this;
      this.cabinet_order_loading = true;
      axios
        .get(
          "get_project_cabinet_details?cabinet_selection_id=" +
            this.cabinet_selection[index].cabinet_selection_id
        )
        .then(response => {
          _self.cabinet_selection[index].edit_mode = false;
          _self.cabinet_selection[index].new_entry = false;
          _self.cabinet_selection[index] = response.data.data;
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
    },
    getCabinetSelection(index, flag) {
      this.cabinet_order_loading = true;
      let _self = this;
      this.cabinet_selection[index].cabinet_flag = flag;
      let url = parseParams(this.cabinet_selection[index]);
      axios
        .get("get_cabinet_selection?" + url)
        .then(response => {
          if (response.data.status) {
            if (flag == "width") {
              _self.cabinet_selection[index].cabinet_width_list =
                response.data.data;
              _self.cabinet_selection[index].width = null;
              _self.cabinet_selection[index].cabinet_height = null;
              _self.cabinet_selection[index].depth = null;
              _self.cabinet_selection[index].vendor_id = null;
              _self.cabinet_selection[index].cabinet_line_id = null;
              _self.cabinet_selection[index].cabinet_color_id = null;
            } else if (flag == "depth") {
              _self.cabinet_selection[index].cabinet_depth_list =
                response.data.data;
              _self.cabinet_selection[index].cabinet_height = null;
              _self.cabinet_selection[index].depth = null;
              _self.cabinet_selection[index].vendor_id = null;
              _self.cabinet_selection[index].cabinet_line_id = null;
              _self.cabinet_selection[index].cabinet_color_id = null;
            } else if (flag == "height") {
              _self.cabinet_selection[index].cabinet_height_list =
                response.data.data;
              _self.cabinet_selection[index].cabinet_height = null;
              _self.cabinet_selection[index].vendor_id = null;
              _self.cabinet_selection[index].cabinet_line_id = null;
              _self.cabinet_selection[index].cabinet_color_id = null;
            } else if (flag == "vendor") {
              _self.cabinet_selection[index].cabinet_vendor_list =
                response.data.data;
              _self.cabinet_selection[index].vendor_id = null;
              _self.cabinet_selection[index].cabinet_line_id = null;
              _self.cabinet_selection[index].cabinet_color_id = null;
            } else if (flag == "line") {
              _self.cabinet_selection[index].cabinet_line_list =
                response.data.data;
              _self.cabinet_selection[index].cabinet_line_id = null;
              _self.cabinet_selection[index].cabinet_color_id = null;
            } else if (flag == "color") {
              _self.cabinet_selection[index].cabinet_color_list =
                response.data.data;
              _self.cabinet_selection[index].cabinet_color_id = null;
            }
          }
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
    },
    openDiscountDialog() {
      this.discount_dialog = true;
      if (this.project_data_flag == "1") {
        this.discount_data.discount_type = this.selectedRows[0].new_con_discount_type;
        this.discount_data.discount = this.selectedRows[0].new_con_discount;
      } else if (this.project_data_flag == "2") {
        this.discount_data.discount_type = this.selectedRows[0].remodeling_discount_type;
        this.discount_data.discount = this.selectedRows[0].remodeling_discount;
      } else if (this.project_data_flag == "3") {
        this.discount_data.discount_type = this.selectedRows[0].design_work_discount_type;
        this.discount_data.discount = this.selectedRows[0].design_work_discount;
      } else if (this.project_data_flag == "4") {
        this.discount_data.discount_type = this.selectedRows[0].pro_management_discount_type;
        this.discount_data.discount = this.selectedRows[0].pro_management_discount;
      } else if (this.project_data_flag == "5") {
        this.discount_data.discount_type = this.selectedRows[0].retail_sale_discount_type;
        this.discount_data.discount = this.selectedRows[0].retail_sale_discount;
      } else if (this.project_data_flag == "6") {
        this.discount_data.discount_type = this.selectedRows[0].countertop_discount_type;
        this.discount_data.discount = this.selectedRows[0].countertop_discount;
      } else if (this.project_data_flag == "7") {
        this.discount_data.discount_type = this.selectedRows[0].cabinet_order_discount_type;
        this.discount_data.discount = this.selectedRows[0].cabinet_order_discount;
      } else if (this.project_data_flag == "8") {
        this.discount_data.discount_type = this.selectedRows[0].closet_discount_type;
        this.discount_data.discount = this.selectedRows[0].closet_discount;
      }
    },
    saveDiscount() {
      this.discount_data.project_id = this.selectedRows[0].project_id;
      this.discount_data.project_data_flag = this.project_data_flag;
      let _self = this;
      this.discount_dialog_loading = true;
      axios
        .post("update_project_discount", this.discount_data)
        .then(function(res) {
          _self.selectedRows[0].new_con_discount_type =
            res.data.data.new_con_discount_type;
          _self.selectedRows[0].new_con_discount =
            res.data.data.new_con_discount;
          _self.selectedRows[0].remodeling_discount_type =
            res.data.data.remodeling_discount_type;
          _self.selectedRows[0].remodeling_discount =
            res.data.data.remodeling_discount;
          _self.selectedRows[0].design_work_discount_type =
            res.data.data.design_work_discount_type;
          _self.selectedRows[0].design_work_discount =
            res.data.data.design_work_discount;
          _self.selectedRows[0].pro_management_discount_type =
            res.data.data.pro_management_discount_type;
          _self.selectedRows[0].pro_management_discount =
            res.data.data.pro_management_discount;
          _self.selectedRows[0].retail_sale_discount_type =
            res.data.data.retail_sale_discount_type;
          _self.selectedRows[0].retail_sale_discount =
            res.data.data.retail_sale_discount;
          _self.selectedRows[0].countertop_discount_type =
            res.data.data.countertop_discount_type;
          _self.selectedRows[0].countertop_discount =
            res.data.data.countertop_discount;
          _self.selectedRows[0].cabinet_order_discount_type =
            res.data.data.cabinet_order_discount_type;
          _self.selectedRows[0].cabinet_order_discount =
            res.data.data.cabinet_order_discount;
          _self.selectedRows[0].closet_discount_type =
            res.data.data.closet_discount_type;
          _self.selectedRows[0].closet_discount = res.data.data.closet_discount;
          _self.discount_dialog = false;
          _self.discount_dialog_loading = false;
        })
        .catch(function() {
          _self.discount_dialog_loading = false;
        });
    },
    useStoneInCounter(stone_id, new_entry) {
      let use_stone = "no";
      this.countertop_list.filter(item => {
        if (item.stone_id == stone_id) {
          use_stone = "yes";
        }
      });
      if (use_stone == "no" || new_entry) {
        return true;
      } else {
        return false;
      }
    },
    getCounterCostDiscoutedAmt(orderAmount) {
      let total_discount = 0.0;
      if (this.selectedRows[0].countertop_discount > 0) {
        if (this.selectedRows[0].countertop_discount_type == 2) {
          // total_discount = parseFloat(this.selectedRows[0].countertop_discount);
        } else {
          total_discount = parseFloat(
            (orderAmount * this.selectedRows[0].countertop_discount) / 100
          );
        }
      }
      if (
        this.selectedRows[0].multiplier > 0 &&
        this.selectedRows[0].multiplier < 1
      ) {
        let multiplier_amount = orderAmount * this.selectedRows[0].multiplier;
        let multipler_discount = orderAmount - multiplier_amount;
        total_discount += parseFloat(multipler_discount);
      }
      let total = orderAmount - total_discount;
      return total;
    },
    getCounterCost(row) {
      let totalSqFt = this.getSqFt(row);
      if (totalSqFt > 0 && row.price > 0) {
        let totalCost = totalSqFt * row.price;
        return totalCost;
      } else {
        return 0;
      }
    },
    getSqFt(row) {
      let sq_ft = 0;
      let dimension = row.dimension;
      if (row.dimension == "custom") {
        dimension = row.custom_dimension;
      }
      if (row.left_splash || row.back_splash || row.right_splash) {
        let total = 0;
        if (row.left_splash) {
          total = total + parseFloat(dimension);
        }
        if (row.back_splash) {
          total = total + parseFloat(row.length);
        }
        if (row.right_splash) {
          total = total + parseFloat(dimension);
        }
        let splace_height = row.splace_height;
        if (row.splace_height == "custom") {
          splace_height = row.custom_splace_height;
        }
        if (splace_height > 0) {
          sq_ft = (total * splace_height) / 144;
          sq_ft = sq_ft * row.qty;
        }
      }
      let sq_ft2 = (row.length * dimension) / 144;
      sq_ft2 = sq_ft2 * row.qty;
      sq_ft = parseFloat(sq_ft) + parseFloat(sq_ft2);
      if (sq_ft > 0) {
        return sq_ft.toFixed(2);
      } else {
        return "";
      }
    },
    changeCounterTopStone() {
      this.add_counter_top_loading = true;
      this.stone_data.filter(item => {
        if (item.stone_id == this.countertop_order_data.stone_id) {
          this.countertop_order_data.price = item.price;
        }
      });
      this.add_counter_top_loading = false;
    },
    calculateSaleQty(stone_id) {
      let total_sale_qty = 0;
      this.countertop_list.filter(item => {
        if (item.stone_id == stone_id) {
          let sale_qty = this.getSqFt(item);
          if (sale_qty > 0) {
            total_sale_qty += parseFloat(sale_qty);
          }
        }
      });
      this.item_job_list.filter(item => {
        if (item.item_job_id == stone_id) {
          total_sale_qty += parseFloat(item.qty);
        }
      });

      if (total_sale_qty > 0) {
        return total_sale_qty.toFixed(2);
      } else {
        return "";
      }
    },
    // calculateInStock(stone_id){

    //   var sale_qty=this.calculateSaleQty(stone_id)
    //   let total=0;
    //   this.group_stone_list.filter((item)=>{
    //     if(item.item_id==stone_id){
    //        total += parseFloat(item.opening_stock ? item.opening_stock : 0) + parseFloat(item.order_qty ? item.order_qty :0) -
    //        parseFloat(sale_qty ? sale_qty :0) - parseFloat(item.lost ? item.lost : 0)
    //     }
    //   })
    //   return total.toFixed(2);
    // },
    openAddNewItemJob() {
      this.add_new_item_job = true;
      this.item_job_list_expand = true;
      this.item_job_data = {
        item_job: "0"
      };
      this.item_job_error = {};
    },
    stoneEditMode(item, index) {
      this.add_counter_top_loading = true;
      this.stone_data[index].edit_mode = true;
      // this.stone_edit_data={
      //     stone_id: item.stone_id,
      //     vendor_id: item.vendor_id,
      //     stone_vendor_list: item.stone_vendor_list,
      //     standard_price: item.standard_price,
      //     price_override: item.price_override,
      //     price: item.price,
      //     stock_qty: item.stock_qty,
      //     form_error: item.form_error
      // }
      this.add_counter_top_loading = false;
    },
    itemJobEditMode(item, index) {
      console.log(item, index);
      this.item_job_list[index].edit_mode = true;
      this.item_job_data = {
        counter_top_item_job_id: item.counter_top_item_job_id,
        item_job: item.item_job,
        item_job_id: item.item_job_id,
        qty: item.qty,
        rate: item.rate,
        vendor_id: item.vendor_id
      };
      // if(item.item_job == '1') {
      this.getItemDetails2("yes");

      // } else {
      //   this.getJobDetails2();
      // }
    },
    resetItemJob(index) {
      this.item_job_list[index].edit_mode = false;
      this.closeJobItemEntry();
    },
    closeJobItemEntry() {
      this.add_new_item_job = false;
      this.item_job_data = {
        item_job: "0"
      };
      this.item_job_error = {};
    },
    getItemJobName(item) {
      // if(item.item_job == '1') {
      return item.item ? item.item.item_name : "";
      // } else {
      //   return (item.job)?item.job.job_name:''
      // }
    },
    changeEdgeProfile() {
      this.edge_profile_list.filter(item => {
        if (item.value == this.countertop_order_data.edge_profile) {
          if (item.px_override) {
            this.countertop_order_data.edge_profile_price = item.override_price;
          } else {
            this.countertop_order_data.edge_profile_price = item.sales_price;
          }
          this.countertop_order_data.edge_profile_group_id = item.group_id;
          this.countertop_order_data.edge_profile_vendor_id = item.vendor_id;
        }
      });
    },
    changeEleCutOut() {
      this.elec_cut_out_list.filter(item => {
        if (item.value == this.countertop_order_data.elec_cut_out_job_id) {
          if (item.px_override) {
            this.countertop_order_data.elec_cut_out_price = item.override_price;
          } else {
            this.countertop_order_data.elec_cut_out_price = item.sales_price;
          }
          this.countertop_order_data.elec_cut_out_group_id = item.group_id;
          this.countertop_order_data.elec_cut_out_vendor_id = item.vendor_id;
        }
      });
    },
    changeSinkCutOut() {
      this.sink_cut_out_list.filter(item => {
        if (item.value == this.countertop_order_data.sink_cut_out_job_id) {
          if (item.px_override) {
            this.countertop_order_data.sink_cut_out_price = item.override_price;
          } else {
            this.countertop_order_data.sink_cut_out_price = item.sales_price;
          }
          this.countertop_order_data.sink_cut_out_group_id = item.group_id;
          this.countertop_order_data.sink_cut_out_vendor_id = item.vendor_id;
        }
      });
    },
    changeCookTopCutOut() {
      this.cooktop_cut_out_list.filter(item => {
        if (item.value == this.countertop_order_data.cooktop_cut_out_job_id) {
          if (item.px_override) {
            this.countertop_order_data.cooktop_cut_out_price =
              item.override_price;
          } else {
            this.countertop_order_data.cooktop_cut_out_price = item.sales_price;
          }
          this.countertop_order_data.cooktop_cut_out_group_id = item.group_id;
          this.countertop_order_data.cooktop_cut_out_vendor_id = item.vendor_id;
        }
      });
    },
    resetCounterTopEntry() {
      this.countertop_order_data = {
        left_splash: false,
        back_splash: false,
        right_splash: false,
        electrical_cut_out: false,
        sink_cut_out: false,
        cooktop_cut_out: false,
        qty: 1
      };
      if (this.selected_stone.length > 0) {
        this.countertop_order_data.stone_id = this.selected_stone[0].value;
        this.changeCounterTopStone();
      }
    },
    closeCounterTopEntry() {
      this.view_counter_top_screen = false;
      this.resetCounterTopEntry();
      this.countertop_order_error = {};
    },
    toggleBtn() {
      if (
        !this.countertop_order_data.right_splash &&
        !this.countertop_order_data.back_splash &&
        !this.countertop_order_data.left_splash
      ) {
        this.countertop_order_data.splace_height = null;
      }
    },
    openUploader(item) {
      this.setModal(true);
      this.setDocumentData({ key: "type", value: 8 });
      this.setDocumentData({ key: "o_id", value: item.project_id });
      this.setDocumentData({ key: "items", value: this.items });
      this.setDocumentData({ key: "item", value: item });
    },
    openDocList(item) {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 8 });
      this.setDocumentData({ key: "o_id", value: item.project_id });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "form_name", value: "Project" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      if (item.customer) {
        this.setDocumentData({
          key: "customer_name",
          value: item.customer.full_name
        });
      } else {
        this.setDocumentData({ key: "customer_name", value: "" });
      }
      this.setDocumentData({ key: "bank_name", value: "" });
      this.setDocumentData({ key: "project_name", value: item.p_name });
      this.setDocumentData({ key: "vendor_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "PROJECT" });
      // this.$router.push({name: 'projects_document'});
    },
    openLogList(item) {
      this.setLogData({ key: "log_list_modal", value: true });
      this.setLogData({ key: "type", value: 8 });
      this.setLogData({ key: "o_id", value: item.project_id });
      this.setLogData({ key: "item", value: item });

      this.setLogData({ key: "form_name", value: "Project" });
      this.setLogData({ key: "item_name", value: "" });
      this.setLogData({ key: "job_name", value: "" });
      this.setLogData({ key: "user_name", value: "" });
      if (item.customer) {
        this.setLogData({
          key: "customer_name",
          value: item.customer.full_name
        });
      } else {
        this.setLogData({ key: "customer_name", value: "" });
      }
      this.setLogData({ key: "bank_name", value: "" });
      this.setLogData({ key: "project_name", value: item.p_name });
      this.setLogData({ key: "vendor_name", value: "" });
    },
    openTaskList(item) {
      this.setTaskData({ key: "task_list_modal", value: true });
      this.setTaskData({ key: "type", value: 8 });
      this.setTaskData({ key: "o_id", value: item.project_id });
      this.setTaskData({ key: "item", value: item });
      this.setTaskData({ key: "form_name", value: "Project" });
      this.setTaskData({ key: "item_name", value: "" });
      this.setTaskData({ key: "job_name", value: "" });
      this.setTaskData({ key: "user_name", value: "" });
      if (item.customer) {
        this.setTaskData({
          key: "customer_name",
          value: item.customer.full_name
        });
      } else {
        this.setTaskData({ key: "customer_name", value: "" });
      }
      this.setTaskData({ key: "bank_name", value: "" });
      this.setTaskData({ key: "project_name", value: item.p_name });
      this.setTaskData({ key: "vendor_name", value: "" });
      this.setTaskData({ key: "display_date", value: item.display_date });
      // this.setTaskData({ key: "estimated_completed_date", value: item.estimated_completed_date });
      // this.setTaskData({ key: "revised_completion_date", value: item.revised_completion_date });
    },
    changeSink() {
      this.sink_list.filter(item => {
        if (item.item_id == this.countertop_order_data.sink_id) {
          this.sink_vendor_list = item.vendors;
          this.changeVendor3();
        }
      });
      if (this.sink_vendor_list.length == 1) {
        this.countertop_order_data.vendor_id = this.sink_vendor_list[0].vendor_id;
        this.changeVendor3();
      }
    },
    changeCutJob() {
      this.cut_job_list.filter(item => {
        if (item.item_id == this.countertop_order_data.cut_job_id) {
          this.cut_job_vendor_list = item.vendors;
          this.changeVendorCutJob();
        }
      });

      if (this.cut_job_vendor_list.length == 1) {
        this.countertop_order_data.cut_job_vendor_id = this.cut_job_vendor_list[0].vendor_id;
        this.changeVendorCutJob();
      }
    },
    getJobDetails(index) {
      this.add_project_data[index].change_price_in_master = false;
      this.job_list.filter(item => {
        if (item.job_id == this.add_project_data[index].item_job_id) {
          this.add_project_data[index].item_vendor_list = [];
          this.vendor_list.filter(item2 => {
            this.add_project_data[index].item_vendor_list.push(item2);
          });
          item.vendors.filter(item3 => {
            this.add_project_data[index].item_vendor_list.unshift(item3.vendor);
          });
          // if(this.add_project_data[index].item_vendor_list == 1) {
          //   this.add_project_data[index].vendor_id = this.add_project_data[index].item_vendor_list[0].vendor_id
          // } else {
          //   this.add_project_data[index].vendor_id = null
          // }
          this.add_project_data[index].price_override = item.px_override;
          if (item.px_override) {
            this.add_project_data[index].rate = item.override_price;
          } else {
            this.add_project_data[index].rate = item.sales_price;
          }
          this.add_project_data[index].uom_id = item.uom_id;
        }
      });
    },
    getJobDetails2() {
      this.item_job_data.change_price_in_master = false;
      this.job_list.filter(item => {
        if (item.job_id == this.item_job_data.item_job_id) {
          //this.item_vendor_list = item.vendors;

          this.item_vendor_list = [];
          this.vendor_list.filter(item2 => {
            this.item_vendor_list.push(item2);
          });
          item.vendors.filter(item3 => {
            this.item_vendor_list.unshift(item3.vendor);
          });

          // if(this.item_vendor_list.length == 1) {
          //   this.item_job_data.vendor_id = this.item_vendor_list[0].vendor_id
          // } else {
          //   this.item_job_data.vendor_id = null
          // }
          this.item_job_data.price_override = item.px_override;
          if (item.px_override) {
            this.item_job_data.rate = item.override_price;
          } else {
            this.item_job_data.rate = item.sales_price;
          }
        }
      });
    },
    changeVendorPrice(index, $is) {
      if ($is == "YES") {
        this.changeVendor(index);
      }
    },

    changeVendor(index) {
      this.add_project_data[index].change_price_in_master = false;
      this.add_project_data[index].rate = this.getPrice(index);
    },
    changeVendorItemJob(index) {
      this.item_job_data.change_price_in_master = false;
      this.item_job_data.rate = this.getPriceItemJob(index);
    },

    showVendorPopupInEdit(new_entry) {
      if (!new_entry) {
        this.vendor_change_dialog = true;
      } else {
        this.changeVendor(this.item_vendor_index);
      }
    },
    changeGroupVendor(from) {
      this.update_invoice_group_data.change_price_in_master = false;
      if (from == "from_group") {
        this.vendor_change_group_dialog = true;
      } else {
        this.update_invoice_group_data.rate = this.getGroupItemPrice();
      }
    },
    changeVendorPriceGroup() {
      this.update_invoice_group_data.rate = this.getGroupItemPrice();
    },

    getGroupItemPrice() {
      let price = 0;
      this.update_invoice_group_data.item_vendor_list.filter(item => {
        if (item.vendor_id == this.update_invoice_group_data.vendor_id) {
          this.update_invoice_group_data.price_override = item.price_override;
          if (item.price_override == "1") {
            price = item.override_price;
          } else {
            price = item.sales_price;
          }
          let selected_stone = [];
          this.item_list.filter(item => {
            if (item.item_id == this.update_invoice_group_data.item_job_id) {
              selected_stone = item;
            }
          });
          if (this.selectedRows[0]) {
            price =
              price -
              getUpxDiscount(
                selected_stone,
                this.selectedRows[0].created_at,
                price
              );
          }
          // if(selected_stone.on_sale && selected_stone.start_date && selected_stone.end_date && selected_stone.discount && this.selectedRows[0]) {
          //   let project_date = moment(this.selectedRows[0].created_at, "YYYY-MM-DD");
          //   if(moment(project_date).isBetween(selected_stone.start_date, selected_stone.end_date, 'days', true)) {
          //     let discount = (price * selected_stone.discount) / 100;
          //     price = (price - discount).toFixed(2);
          //   }
          // }
        }
      });
      return price;
    },
    getPrice(index) {
      let rate = 0;
      this.add_project_data[index].item_vendor_list.filter(item => {
        if (item.vendor_id == this.add_project_data[index].vendor_id) {
          this.add_project_data[index].price_override = item.price_override;
          if (item.price_override == "1") {
            rate = item.override_price;
          } else {
            rate = item.sales_price;
          }

          let selected_stone = [];
          this.item_list.filter(item => {
            if (item.item_id == this.add_project_data[index].item_job_id) {
              selected_stone = item;
            }
          });
          if (this.selectedRows[0]) {
            rate =
              rate -
              getUpxDiscount(
                selected_stone,
                this.selectedRows[0].created_at,
                rate
              );
          }
          // if(selected_stone.on_sale && selected_stone.start_date && selected_stone.end_date && selected_stone.discount && this.selectedRows[0]) {
          //   let project_date = moment(this.selectedRows[0].created_at, "YYYY-MM-DD");
          //   if(moment(project_date).isBetween(selected_stone.start_date, selected_stone.end_date, 'days', true)) {
          //     let discount = (this.add_project_data[index].rate * selected_stone.discount) / 100;
          //     rate = (this.add_project_data[index].rate - discount).toFixed(2);
          //   }
          // }
        }
      });
      return rate.toFixed(2);
    },
    getPriceItemJob(index) {
      console.log(index);
      let rate = 0;
      this.item_vendor_list.filter(item => {
        if (item.vendor_id == this.item_job_data.vendor_id) {
          this.item_job_data.price_override = item.price_override;
          if (item.price_override == "1") {
            rate = item.override_price;
          } else {
            rate = item.sales_price;
          }

          let selected_stone = [];
          this.counter_top_item_list.filter(item => {
            if (item.item_id == this.item_job_data.item_job_id) {
              selected_stone = item;
            }
          });

          if (this.selectedRows[0]) {
            rate =
              rate -
              getUpxDiscount(
                selected_stone,
                this.selectedRows[0].created_at,
                rate
              );
          }
        }
      });
      return rate.toFixed(2);
    },
    changeVendor4() {
      this.add_counter_top_loading = true;
      this.item_job_data.change_price_in_master = false;
      this.item_job_data.rate = this.getPrice2();
      this.add_counter_top_loading = false;
    },
    getPrice2() {
      let price = 0;
      this.item_vendor_list.filter(item => {
        if (item.vendor_id == this.item_job_data.vendor_id) {
          this.item_job_data.price_override = item.price_override;
          if (item.price_override == "1") {
            price = item.override_price;
          } else {
            price = item.sales_price;
          }
          let selected_stone = [];
          this.all_type_item_list.filter(item => {
            if (item.item_id == this.item_job_data.item_job_id) {
              selected_stone = item;
            }
          });

          if (
            selected_stone.on_sale &&
            selected_stone.start_date &&
            selected_stone.end_date &&
            selected_stone.discount &&
            this.selectedRows[0]
          ) {
            let project_date = moment(
              this.selectedRows[0].created_at,
              "YYYY-MM-DD"
            );
            if (
              moment(project_date).isBetween(
                selected_stone.start_date,
                selected_stone.end_date,
                "days",
                true
              )
            ) {
              let discount = (price * selected_stone.discount) / 100;
              price = (price - discount).toFixed(2);
            }
          }
        }
      });
      return price;
    },
    changeVendor5() {
      this.cabinet_accessory_item_data.item_vendor_list.filter(item => {
        if (item.vendor_id == this.cabinet_accessory_item_data.vendor_id) {
          if (item.price_override == "1") {
            this.cabinet_accessory_item_data.price = item.override_price;
          } else {
            this.cabinet_accessory_item_data.price = item.sales_price;
          }
          let selected_stone = [];
          this.item_list.filter(item => {
            if (
              item.item_id == this.cabinet_accessory_item_data.accessory_item_id
            ) {
              selected_stone = item;
            }
          });

          if (
            selected_stone.on_sale &&
            selected_stone.start_date &&
            selected_stone.end_date &&
            selected_stone.discount &&
            this.selectedRows[0]
          ) {
            let project_date = moment(
              this.selectedRows[0].created_at,
              "YYYY-MM-DD"
            );
            if (
              moment(project_date).isBetween(
                selected_stone.start_date,
                selected_stone.end_date,
                "days",
                true
              )
            ) {
              let discount =
                (this.cabinet_accessory_item_data.price *
                  selected_stone.discount) /
                100;
              this.cabinet_accessory_item_data.price = (
                this.cabinet_accessory_item_data.price - discount
              ).toFixed(2);
            }
          }
        }
      });
    },
    changeVendor2(index) {
      this.add_counter_top_loading = true;
      this.stone_data[index].change_price_in_master = false;
      let price = this.getStonePrice(index);
      this.stone_data[index].price = price;
      this.stone_data[index].standard_price = price;
      let selected_stone = [];
      this.group_stone_list.filter(item => {
        if (item.item_id == this.stone_data[index].stone_id) {
          selected_stone = item;
        }
      });
      if (
        selected_stone.on_sale &&
        selected_stone.start_date &&
        selected_stone.end_date &&
        selected_stone.discount &&
        this.selectedRows[0]
      ) {
        let project_date = moment(
          this.selectedRows[0].created_at,
          "YYYY-MM-DD"
        );
        if (
          moment(project_date).isBetween(
            selected_stone.start_date,
            selected_stone.end_date,
            "days",
            true
          )
        ) {
          let discount =
            (this.stone_data[index].price * selected_stone.discount) / 100;
          this.stone_data[index].price = (
            this.stone_data[index].price - discount
          ).toFixed(2);
        }
      }
      this.add_counter_top_loading = false;
    },
    getStonePrice(index) {
      let price = 0;
      this.stone_data[index].stone_vendor_list.filter(item => {
        if (item.vendor_id == this.stone_data[index].vendor_id) {
          this.stone_data[index].price_override = item.price_override;
          if (item.price_override == "1") {
            price = item.override_price;
          } else {
            price = item.sales_price;
          }
        }
      });
      return price;
    },
    changeSalesPrice(index) {
      this.add_counter_top_loading = true;
      let selected_stone = [];
      this.group_stone_list.filter(item => {
        if (item.item_id == this.stone_data[index].stone_id) {
          selected_stone = item;
        }
      });
      this.stone_data[index].price = this.stone_data[index].standard_price;
      if (
        selected_stone.on_sale &&
        selected_stone.start_date &&
        selected_stone.end_date &&
        selected_stone.discount &&
        this.selectedRows[0]
      ) {
        let project_date = moment(
          this.selectedRows[0].created_at,
          "YYYY-MM-DD"
        );
        if (
          moment(project_date).isBetween(
            selected_stone.start_date,
            selected_stone.end_date,
            "days",
            true
          )
        ) {
          let discount =
            (this.stone_data[index].price * selected_stone.discount) / 100;
          this.stone_data[index].price = (
            this.stone_data[index].price - discount
          ).toFixed(2);
        }
      }
      this.add_counter_top_loading = false;
    },
    changeVendor3() {
      this.sink_vendor_list.filter(item => {
        console.log("test");
        if (item.vendor_id == this.countertop_order_data.vendor_id) {
          if (item.price_override == "1") {
            this.countertop_order_data.sink_price = item.override_price;
          } else {
            console.log("item.sales_price", item.sales_price);
            this.countertop_order_data.sink_price = item.sales_price;
          }

          let selected_stone = [];
          this.sink_list.filter(item => {
            if (item.item_id == this.countertop_order_data.sink_id) {
              selected_stone = item;
            }
          });
          if (
            selected_stone.on_sale &&
            selected_stone.start_date &&
            selected_stone.end_date &&
            selected_stone.discount &&
            this.selectedRows[0]
          ) {
            let project_date = moment(
              this.selectedRows[0].created_at,
              "YYYY-MM-DD"
            );
            if (
              moment(project_date).isBetween(
                selected_stone.start_date,
                selected_stone.end_date,
                "days",
                true
              )
            ) {
              let discount =
                (this.countertop_order_data.sink_price *
                  selected_stone.discount) /
                100;
              this.countertop_order_data.sink_price = (
                this.countertop_order_data.sink_price - discount
              ).toFixed(2);
            }
          }
        }
      });
    },
    changeVendorCutJob() {
      this.cut_job_vendor_list.filter(item => {
        if (item.vendor_id == this.countertop_order_data.cut_job_vendor_id) {
          if (item.price_override == "1") {
            this.countertop_order_data.cut_job_price = item.override_price;
          } else {
            this.countertop_order_data.cut_job_price = item.sales_price;
          }

          let selected_stone = [];
          this.cut_job_list.filter(item => {
            if (item.item_id == this.countertop_order_data.cut_job_id) {
              selected_stone = item;
            }
          });
          if (
            selected_stone.on_sale &&
            selected_stone.start_date &&
            selected_stone.end_date &&
            selected_stone.discount &&
            this.selectedRows[0]
          ) {
            let project_date = moment(
              this.selectedRows[0].created_at,
              "YYYY-MM-DD"
            );
            if (
              moment(project_date).isBetween(
                selected_stone.start_date,
                selected_stone.end_date,
                "days",
                true
              )
            ) {
              let discount =
                (this.countertop_order_data.cut_job_price *
                  selected_stone.discount) /
                100;
              this.countertop_order_data.cut_job_price = (
                this.countertop_order_data.cut_job_price - discount
              ).toFixed(2);
            }
          }
        }
      });
    },
    changeItemJob(index) {
      this.add_project_data[index].item_job_id = null;
      this.add_project_data[index].item_vendor_list = [];
      this.add_project_data[index].vendor_id = null;
      this.add_project_data[index].uom_id = null;
      this.add_project_data[index].rate = null;
      this.add_project_data[index].change_price_in_master = false;
    },
    getItemDetails(index) {
      let _self = this;
      axios
        .get("get_item?id=" + this.add_project_data[index].item_job_id)
        .then(response => {
          if (response.data.status) {
            _self.add_project_data[index].item_vendor_list =
              response.data.data.vendors;
            let is_active_item_job_vendor_id = false;
            response.data.data.vendors.filter(item => {
              if (item.vendor_id == this.active_item_job_vendor_id) {
                is_active_item_job_vendor_id = true;
              }
            });

            if (is_active_item_job_vendor_id) {
              _self.add_project_data[
                index
              ].vendor_id = this.active_item_job_vendor_id;
              _self.changeVendor(index);
            } else {
              if (response.data.data.vendors.length == 1) {
                _self.add_project_data[index].vendor_id =
                  response.data.data.vendors[0].vendor_id;
                _self.changeVendor(index);
              } else {
                _self.add_project_data[index].vendor_id = null;
                _self.add_project_data[index].rate = null;
                _self.add_project_data[index].price_override = null;
              }
            }
            _self.add_project_data[index].uom_id = response.data.data.item_uom;
          }
        })
        .catch(function() {});
    },
    getItemJobDetails(index) {
      let _self = this;
      axios
        .get("get_item?id=" + this.item_job_data.item_job_id)
        .then(response => {
          if (response.data.status) {
            _self.item_vendor_list = response.data.data.vendors;
            let is_active_item_job_vendor_id = false;
            response.data.data.vendors.filter(item => {
              if (item.vendor_id == this.active_item_job_vendor_id) {
                is_active_item_job_vendor_id = true;
              }
            });

            if (is_active_item_job_vendor_id) {
              _self.item_job_data.vendor_id = this.active_item_job_vendor_id;
              _self.changeVendorItemJob(index);
            } else {
              if (response.data.data.vendors.length == 1) {
                _self.item_job_data.vendor_id =
                  response.data.data.vendors[0].vendor_id;
                _self.changeVendorItemJob(index);
              } else {
                if (_self.item_job_data.vendor_id != "") {
                  _self.changeVendorItemJob(index);
                } else {
                  _self.item_job_data.vendor_id = null;
                  _self.item_job_data.rate = null;
                  _self.item_job_data.price_override = null;
                }
              }
            }
            _self.item_job_data.uom_id = response.data.data.item_uom;
          }
        })
        .catch(function() {});
    },
    getGroupItemDetails() {
      let _self = this;
      axios
        .get("get_item?id=" + this.update_invoice_group_data.item_job_id)
        .then(response => {
          if (response.data.status) {
            _self.update_invoice_group_data.item_vendor_list =
              response.data.data.vendors;
            let is_active_item_job_vendor_id = false;
            response.data.data.vendors.filter(item => {
              if (item.vendor_id == this.active_item_job_vendor_id) {
                is_active_item_job_vendor_id = true;
              }
            });
            if (is_active_item_job_vendor_id) {
              _self.update_invoice_group_data.vendor_id = this.active_item_job_vendor_id;
              _self.changeGroupVendor();
            } else {
              if (response.data.data.vendors.length == 1) {
                _self.update_invoice_group_data.vendor_id =
                  response.data.data.vendors[0].vendor_id;
                _self.changeGroupVendor();
              } else {
                _self.update_invoice_group_data.vendor_id = null;
                _self.update_invoice_group_data.rate = null;
                _self.update_invoice_group_data.price_override = null;
              }
            }
            _self.update_invoice_group_data.uom_id =
              response.data.data.item_uom;
          }
        })
        .catch(function() {});
    },
    changeItemJob2() {
      this.item_vendor_list = [];
      this.item_job_data.vendor_id = null;
      this.item_job_data.rate = null;
      this.item_job_data.item_job_id = null;
      this.item_job_data.change_price_in_master = false;
    },
    getItemDetails2(is_edit_mode) {
      let _self = this;
      axios
        .get("get_item?id=" + this.item_job_data.item_job_id)
        .then(response => {
          if (response.data.status) {
            _self.item_vendor_list = response.data.data.vendors;
            if (is_edit_mode != "yes") {
              _self.item_job_data.vendor_id = null;
              _self.item_job_data.rate = null;

              if (response.data.data.vendors.length == 1) {
                _self.item_job_data.vendor_id =
                  response.data.data.vendors[0].vendor_id;
                _self.changeVendor4();
              }
            } else {
              _self.changeVendor4();
            }
          }
        })
        .catch(function() {});
    },
    getStoneDetails(index) {
      let _self = this;
      axios
        .get("get_item?id=" + this.stone_data[index].stone_id)
        .then(response => {
          if (response.data.status) {
            _self.stone_data[index].stone_vendor_list =
              response.data.data.vendors;
            let is_active_item_job_vendor_id = false;
            response.data.data.vendors.filter(item => {
              if (item.vendor_id == this.active_item_job_vendor_id) {
                is_active_item_job_vendor_id = true;
              }
            });

            if (is_active_item_job_vendor_id) {
              _self.stone_data[
                index
              ].vendor_id = this.active_item_job_vendor_id;
              _self.changeVendor2(index);
            } else {
              if (response.data.data.vendors.length == 1) {
                _self.stone_data[index].vendor_id =
                  response.data.data.vendors[0].vendor_id;
                _self.changeVendor2(index);
              } else {
                console.log(
                  _self.stone_data[index].vendor_id,
                  "_self.stone_data[index].vendor_id"
                );
                if (_self.stone_data[index].vendor_id != "") {
                  console.log("testtt");
                  _self.changeVendor2(index);
                } else {
                  _self.stone_data[index].vendor_id = null;
                  _self.stone_data[index].price = null;
                  _self.stone_data[index].standard_price = null;
                  _self.stone_data[index].price_override = null;
                }
              }
            }
          }
        })
        .catch(function() {});
    },
    // getStoneDetails(index) {
    //     let _self = this
    //    axios
    //     .get("get_item?id="+_self.stone_data[index].stone_id)
    //     .then((response) => {
    //       if (response.data.status) {
    //         _self.stone_data[index].stone_vendor_list = response.data.data.vendors;
    //         // if(is_edit_mode != 'yes') {
    //           _self.stone_data[index].vendor_id = null
    //           _self.stone_data[index].rate = null

    //           if(response.data.data.vendors.length == 1) {
    //             _self.stone_data[index].vendor_id = response.data.data.vendors[0].vendor_id
    //             _self.changeVendor2(index)
    //           }
    //         // }
    //       }
    //     })
    //     .catch(function () {});
    // },
    getItemDetails3() {
      let _self = this;
      axios
        .get(
          "get_item?id=" + this.cabinet_accessory_item_data.accessory_item_id
        )
        .then(response => {
          if (response.data.status) {
            _self.cabinet_accessory_item_data.item_vendor_list =
              response.data.data.vendors;
            _self.cabinet_accessory_item_data.vendor_id = null;
            _self.cabinet_accessory_item_data.price = null;

            if (response.data.data.vendors.length == 1) {
              _self.cabinet_accessory_item_data.vendor_id =
                response.data.data.vendors[0].vendor_id;
              _self.changeVendor5();
            }
          }
        })
        .catch(function() {});
    },
    addNewProjectData(is_add, index) {
      if (is_add == "no") {
        if (index != undefined) {
          if (this.add_project_data[index].new_entry) {
            this.add_project_data.splice(index, 1);
          } else {
            this.delete_project_data_dialog = true;
          }
        } else {
          this.delete_project_data_dialog = true;
        }
      } else {
        var myDiv = document.getElementById("scroll_to_top");
        myDiv.scrollTop = 0;

        let lastElement = this.add_project_data.slice(-1);
        let area_id = null;
        if (lastElement.length > 0) {
          area_id = lastElement[0].area_id;
        }
        this.add_project_data.unshift({
          selected: true,
          project_data_id: null,
          item_job: "0",
          item_job_id: null,
          area_id: area_id,
          description: null,
          qty: null,
          uom_id: null,
          rate: null,
          amount: null,
          vendor_id: null,
          item_vendor_list: [],
          edit_mode: true,
          new_entry: true,
          form_error: {}
        });
      }
    },
    addRemoveCabinetSelection(is_add, index) {
      if (is_add == "no") {
        if (this.cabinet_selection[index].new_entry) {
          this.cabinet_selection.splice(index, 1);
        } else {
          this.selected_project_cabinet_index = index;
          this.delete_project_cabinet_dialog = true;
        }
      } else {
        this.cabinet_selection.push({
          cabinet_selection_id: null,
          area_id: null,
          wall_length: null,
          cabinet_type_id: null,
          cabinet_height: null,
          depth: null,
          vendor_id: null,
          cabinet_line_id: null,
          cabinet_color_id: null,
          cabinet_style_id: null,
          cabinet_height_list: [],
          cabinet_depth_list: [],
          cabinet_width_list: [],
          cabinet_vendor_list: [],
          cabinet_line_list: [],
          cabinet_color_list: [],
          default_cabinet: null,
          edit_mode: true,
          new_entry: true,
          form_error: {}
        });
      }
    },
    addRemoveStone(is_add, index) {
      if (is_add == "no") {
        if (this.stone_data[index].new_entry) {
          this.stone_data.splice(index, 1);
        } else {
          this.selected_project_stone_index = index;
          this.delete_project_stone_dialog = true;
        }
      } else {
        this.stone_data.push({
          project_stone_id: null,
          group_id: null,
          stone_id: null,
          vendor_id: null,
          standard_price: null,
          price: null,
          stock_qty: null,
          sale_qty: null,
          stone_vendor_list: [],
          group_stone_list: [],
          edit_mode: true,
          new_entry: true,
          form_error: {}
        });
      }
    },
    removeCounterTop(counter_top_id) {
      this.counter_top_id = counter_top_id;
      this.delete_project_countor_top_dialog = true;
    },
    removeCabinetOrder(cabinet_order_id) {
      this.cabinet_order_id = cabinet_order_id;
      this.delete_project_cabinet_order_dialog = true;
    },
    editCounterTop(counter_top_id) {
      this.edit_counter_top_id = counter_top_id;
      this.view_counter_top_screen = true;
      this.edit_countor_top_entry = true;

      let _self = this;
      this.add_counter_top_loading = true;
      axios
        .get(
          "get_project_countor_top_details?project_counter_top_entry_id=" +
            counter_top_id
        )
        .then(response => {
          let resData = response.data;
          _self.countertop_order_data = resData.countor_top_data;
          _self.getSink();
          setTimeout(() => {
            _self.changeSink();
          }, 1000);
          _self.getCutJob();
          setTimeout(() => {
            _self.changeCutJob();
          }, 1000);

          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    editCabinetOrder(product_cab_o_id) {
      this.edit_product_cab_o_id = product_cab_o_id;
      this.view_cabinet_order_screen = true;
      this.edit_cabinet_order_flag = true;

      let _self = this;
      this.cabinet_order_loading = true;
      axios
        .get(
          "get_project_cabinet_order_details?product_cab_o_id=" +
            product_cab_o_id
        )
        .then(response => {
          let resData = response.data.data;
          _self.accessory_item_list = response.data.accessory_item_list;
          _self.cabinet_order_data = resData;
          _self.cabinet_order_data.area_name = resData.area.name;
          _self.cabinet_order_data.cabinet_type_name =
            resData.cabinet_type.name;
          _self.cabinet_order_data.item_name = resData.item.item_name;
          if (_self.cabinet_order_data.order_qty > 10) {
            _self.cabinet_order_data.custom_order_qty = true;
          } else {
            _self.cabinet_order_data.custom_order_qty = false;
          }
          let cabinetBalance = 0;
          this.cabinet_selection.filter(item => {
            if (
              item.cabinet_selection_id ==
              this.cabinet_order_data.cabinet_selection_id
            ) {
              cabinetBalance = this.getBalance(item);
            }
          });
          cabinetBalance =
            parseFloat(this.cabinet_order_data.w) + parseFloat(cabinetBalance);
          _self.getCabinetWidth(cabinetBalance);
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
    },
    addProjectOrderValueLog(project_id, type) {
      // let _self = this;
      // this.add_project_data_loading = true;
      axios
        .get(
          "add_project_order_value_log?project_id=" +
            project_id +
            "&type=" +
            type
        )
        .then(() => {})
        .catch(function() {
          // _self.add_project_data_loading = false;
        });
    },
    addProjectData(flag) {
      this.change_order_flag = false;
      this.project_data_flag = flag;
      this.add_project_data = [];
      if (this.selectedRows[0].invoices_count > 0) {
        this.is_change_order = "yes";
      } else {
        this.is_change_order = "no";
      }
      this.getChangeOrders();
      this.getInvoiceGroup();
      // this.getProjectData(true);
      this.getProjectData();

      this.getProjectBalanceData();
    },
    getInvoiceGroup() {
      let _self = this;
      // this.add_project_data_loading = true;
      axios
        .get("get_invoice_group_only?itemsPerPage=-1&filter[group_active]=1")
        .then(response => {
          _self.invoice_group_list = response.data.data;
          // _self.add_project_data_loading = false;
        })
        .catch(function() {
          // _self.add_project_data_loading = false;
        });
    },
    getProjectBalanceData() {
      axios
        .get(
          "get_project_balance?project_ids=" + this.selectedRows[0].project_id
        )
        .then(response => {
          this.project_invoice_amt = response.data.data[0].invoice_amt;
          this.project_payment_due = response.data.data[0].payment_due;
          this.project_order_value = response.data.data[0].project_order_value;
          this.project_received_value =
            response.data.data[0].project_received_value;
        })
        .catch(function() {});
    },
    getProjectData() {
      let _self = this;
      // this.add_project_data_loading = true;
      let is_lock = this.selectedRows[0].p_lock;
      let last_change_order = this.selectedRows[0].last_change_order;
      this.next_change_order_id = is_lock
        ? last_change_order + parseFloat(1)
        : last_change_order;
      axios
        .get(
          "get_project_data?project_data_flag=" +
            this.project_data_flag +
            "&project_id=" +
            this.selectedRows[0].project_id +
            "&next_change_order_id=" +
            this.next_change_order_id +
            "&sort_type=" +
            this.sort_type +
            "&sort_field=" +
            this.sort_field +
            "&item_id=" +
            this.project_data_filter.item_id +
            "&vendor_id=" +
            this.project_data_filter.vendor_id +
            "&area_id=" +
            this.project_data_filter.area_id
        )
        .then(response => {
          _self.add_project_data = response.data.data;
          _self.project_data_items = response.data.items;
          _self.project_data_vendors = response.data.vendors;
          _self.project_data_areas = response.data.areas;
          _self.delete_change_order_flag =
            response.data.delete_change_order_flag;
          for (let i = 0; i < _self.add_project_data.length; i++) {
            if (_self.add_project_data[i].item_job == "2") {
              _self.getJobDetails(i);
            }
          }
          // if (isInitialCall && _self.add_project_data.length == 0) {
          _self.itemGroupList(true);
          // }
          // _self.add_project_data_loading = false;
        })
        .catch(function() {
          // _self.add_project_data_loading = false;
        });
    },
    resetProjectData(index) {
      if (this.add_project_data[index].new_entry) {
        this.addNewProjectData("no", index);
      } else {
        let _self = this;
        this.add_project_data_loading = true;
        axios
          .get(
            "get_project_data_details?project_data_id=" +
              this.add_project_data[index].project_data_id
          )
          .then(response => {
            let data = response.data.data;
            _self.add_project_data[index].edit_mode = false;
            _self.add_project_data[index].new_entry = false;
            _self.add_project_data[index].selected = false;

            _self.add_project_data[index].item_job_id = data.item_job_id;
            _self.add_project_data[index].item_vendor_list =
              data.item_vendor_list;
            _self.add_project_data[index].area_id = data.area_id;
            _self.add_project_data[index].description = data.description;
            _self.add_project_data[index].qty = data.qty;
            _self.add_project_data[index].uom_id = data.uom_id;
            _self.add_project_data[index].rate = data.rate;
            _self.add_project_data[index].item_job_id = data.item_job_id;

            if (_self.add_project_data[index].item_job == "2") {
              _self.getJobDetails(index);
            }
            _self.add_project_data_loading = false;
          })
          .catch(function() {
            _self.add_project_data_loading = false;
          });
      }
    },
    deleteProjectData() {
      let _self = this;
      this.add_project_data_loading = true;
      let ids = [];
      this.selected_item_job.map(item => {
        ids.push(item.project_data_id);
      });
      this.delete_multiple_item.items = ids;
      axios
        .post("delete_project_data", {
          id: this.delete_multiple_item.items,
          is_change_order: this.is_change_order
        })
        .then(function(res) {
          if (res.data.status) {
            _self.delete_multiple_item = {};
            _self.select_all_checkbox = false;
            _self.getProjectData();
            _self.getProjectBalanceData();
          }
          _self.add_project_data_loading = false;
        })
        .catch(function() {
          _self.add_project_data_loading = false;
        });
    },
    checkPriceItemJob() {
      let price = 0;
      // if(this.item_job_data.item_job == '1') {
      price = this.getPrice2();
      // }
      // else {
      //   this.job_list.filter((item) => {
      //     if(item.job_id == this.item_job_data.item_job_id) {
      //       if(item.px_override) {
      //         price = item.override_price
      //       } else {
      //         price = item.sales_price
      //       }
      //     }
      //   })
      // }
      if (this.item_job_data.rate > 0 && price > 0) {
        if (this.item_job_data.rate != price) {
          this.change_item_job_price_dialog = true;
        } else {
          this.saveItemJob();
        }
      } else {
        this.saveItemJob();
      }
    },
    saveItemJob() {
      let _self = this;
      this.item_job_data.project_id = this.selectedRows[0].project_id;
      this.item_job_data.is_change_order = this.is_change_order;
      this.add_counter_top_loading = true;
      axios
        .post("add_project_countor_top_item_job", this.item_job_data)
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.item_job_error[key] = data.errors[key][0];
            }
          } else {
            if (_self.item_job_data.change_price_in_master) {
              _self.getJobs();
            }
            _self.is_change_order = "no";
            _self.getProjectCounterTopItemJob();
            // setTimeout(() => {
            //      _self.updateSaleQtyOfItem(_self.item_job_data.item_job_id);
            //  }, 2000);

            setTimeout(() => {
              _self.closeJobItemEntry();
            }, 2000);
          }
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    updateItemJob(index) {
      let _self = this;

      _self.item_job_data.counter_top_item_job_id =
        _self.item_job_list[index].counter_top_item_job_id;
      _self.item_job_data.is_change_order = _self.is_change_order;
      _self.add_counter_top_loading = true;
      axios
        .post("edit_project_countor_top_item_job", _self.item_job_data)
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.item_job_error[key] = data.errors[key][0];
            }
          } else {
            _self.is_change_order = "no";
            _self.getProjectCounterTopItemJob();

            // setTimeout(() => {
            // _self.updateSaleQtyOfItem(_self.item_job_data.item_job_id);
            //  }, 2000);

            setTimeout(() => {
              _self.resetItemJob();
            }, 2000);
          }
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    // updateSaleQtyOfItem(item_id){
    //   let _self = this
    //   axios
    //     .post("update_sale_qty_of_item",{
    //       'item_id': item_id,
    //       'sale_qty': _self.calculateSaleQty(item_id),
    //     })
    //     .then(function () {

    //     })
    //     .catch(function () {

    //     });

    // },
    removeItemJob() {
      let _self = this;
      this.add_counter_top_loading = true;
      axios
        .post("delete_project_countor_top_item_job", {
          id: this.remove_item_job_id,
          is_change_order: this.is_change_order
        })
        .then(function() {
          //let data = res.data;
          _self.getProjectCounterTopItemJob();
          // setTimeout(() => {
          // _self.updateSaleQtyOfItem(_self.change_stock_item_id);
          //   }, 2000);
          _self.is_change_order = "no";
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    saveProjectData(index) {
      this.add_project_data[index].form_error = {};
      this.add_project_data[index].project_data_flag = this.project_data_flag;
      this.add_project_data[index].project_id = this.selectedRows[0].project_id;
      this.add_project_data[index].is_change_order = this.is_change_order;
      this.add_project_data[
        index
      ].next_change_order_id = this.next_change_order_id;
      this.add_project_data[index].item_job = 1;
      this.add_project_data[index].user_name = localStorage.getItem("user_id");
      let _self = this;
      this.add_project_data_loading = true;
      if (this.add_project_data[index].new_entry) {
        axios
          .post("add_project_data", this.add_project_data[index])
          .then(function(res) {
            let data = res.data;
            if (!data.status) {
              for (let key in data.errors) {
                _self.add_project_data[index].form_error[key] =
                  data.errors[key][0];
              }
            } else {
              _self.getProjectData();
              _self.getProjectBalanceData();
              _self.is_change_order = "no";
              _self.add_project_data[index].edit_mode = false;
              _self.add_project_data[index].new_entry = false;
              _self.add_project_data[index].selected = false;
              _self.add_project_data[index].project_data_id =
                data.data.project_data_id;
              if (
                _self.project_data_flag == "3" ||
                _self.project_data_flag == "5"
              ) {
                if (_self.project_data_flag == "3") {
                  _self.item_group_data.description = "Design Work";
                } else {
                  _self.item_group_data.description = "General Invoice";
                }
                _self.item_group_data.ids = [];
                _self.item_group_data.ids.push(data.data.project_data_id);
                _self.item_group_data.project_data_group_flag =
                  _self.project_data_flag;
                _self.item_group_data.project_id =
                  _self.selectedRows[0].project_id;
                _self.getProjectData();
                _self.getProjectBalanceData();
                axios
                  .post("project_data_group", _self.item_group_data)
                  .then(() => {
                    _self.item_group_data = {};
                    _self.item_group_error = {};
                  })
                  .catch(function() {});
              }
            }
            if (_self.add_project_data[index].change_price_in_master) {
              _self.getJobs();
            }
            _self.getProjectBalanceData();
            _self.add_project_data_loading = false;
          })
          .catch(function() {
            _self.add_project_data_loading = false;
          });
      } else {
        axios
          .post("edit_project_data", this.add_project_data[index])
          .then(function(res) {
            let data = res.data;
            if (!data.status) {
              for (let key in data.errors) {
                _self.add_project_data[index].form_error[key] =
                  data.errors[key][0];
              }
            } else {
              _self.is_change_order = "no";
              _self.add_project_data[index].edit_mode = false;
              _self.add_project_data[index].selected = false;
            }
            if (_self.add_project_data[index].change_price_in_master) {
              _self.getJobs();
            }
            _self.getProjectData();
            _self.getProjectBalanceData();

            _self.add_project_data_loading = false;
          })
          .catch(function() {
            _self.add_project_data_loading = false;
          });
      }
    },
    saveGroupProjectData() {
      this.update_invoice_group_error = {};
      this.update_invoice_group_data.project_data_flag = this.project_data_flag;
      this.update_invoice_group_data.project_id = this.selectedRows[0].project_id;
      this.update_invoice_group_data.is_change_order = this.is_change_order;
      this.update_invoice_group_data.next_change_order_id = this.next_change_order_id;
      this.update_group_item_loading = true;
      //   console.log('this.update_invoice_group_data',this.update_invoice_group_data);
      //   let amount= this.getProjectDataAmt(this.update_invoice_group_data);
      //   let rate= this.group_item_list.find((item)=>{
      //     if(item.invoice_group_id==this.update_invoice_group_data.invoice_group_id){
      //       return item;
      //     }
      //   });
      //   let total_amount=0;
      //   console.log('rate.item',rate);
      //    for(let key in rate.items){
      //      if(rate.items[key].project_data_id!=this.update_invoice_group_data.project_data_id){
      //        total_amount+=parseFloat(total_amount)+parseFloat(this.getProjectDataAmt(rate.items[key]));
      //      }
      //    }

      //  total_amount=parseFloat(total_amount)+parseFloat(amount);
      //  alert('total_amount',total_amount);
      //   if(total_amount < rate.total_spent_amount.replace("-", "")){
      //     alert('you can not change amount')
      //     this.update_group_item_loading = false;
      //     this.update_invoice_group_modal = false;
      //      this.itemGroupList()
      //   }else{
      axios
        .post("edit_project_data", this.update_invoice_group_data)
        .then(res => {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              this.update_invoice_group_error[key] = data.errors[key][0];
            }
          } else {
            this.update_invoice_group_modal = false;
            this.itemGroupList();
            this.getProjectBalanceData();
          }
          this.update_group_item_loading = false;
        })
        .catch(function() {
          this.update_group_item_loading = false;
        });
      // }
    },
    addDescription() {
      this.update_invoice_group_error = {};
      this.update_invoice_group_data.project_data_id = this.desc_modal_id;
      this.update_invoice_group_data.description = this.desc_modal_description;
      this.update_group_item_loading = true;
      axios
        .post("add_project_description", this.update_invoice_group_data)
        .then(res => {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              this.update_invoice_group_error[key] = data.errors[key][0];
            }
          } else {
            this.update_invoice_group_description_modal = false;
            this.itemGroupList();
          }
          this.update_group_item_loading = false;
        })
        .catch(function() {
          this.update_group_item_loading = false;
        });
    },

    cabinetOrderDialog(flag) {
      this.change_order_flag = false;
      if (this.selectedRows[0].invoices_count > 0) {
        this.is_change_order = "yes";
      } else {
        this.is_change_order = "no";
      }
      this.cabinet_order_flag = flag;
      this.cabinet_order_model = true;
      if (flag == 2) {
        this.project_data_flag = 8;
        this.cabinet_order_setting.assembly = this.selectedRows[0].closet_assembly;
        this.cabinet_order_setting.delivery_charge = this.selectedRows[0].closet_delivery_charge;
        this.cabinet_order_setting.install = this.selectedRows[0].closet_install;
      } else {
        this.project_data_flag = 7;
        this.cabinet_order_setting.assembly = this.selectedRows[0].assembly;
        this.cabinet_order_setting.delivery_charge = this.selectedRows[0].delivery_charge;
        this.cabinet_order_setting.install = this.selectedRows[0].install;
      }
      this.cabinet_order_list_expand = false;
      this.cabinet_selection = [];

      this.resetCabinetOrderData();
      this.resetAccessoryItemData();
      this.view_cabinet_order_screen = false;
      this.cabinet_order_loading = true;
      let _self = this;
      axios
        .get(
          "get_project_cabinet?project_id=" +
            this.selectedRows[0].project_id +
            "&cabinet_order_flag=" +
            this.cabinet_order_flag +
            "&change_order_id=" +
            this.change_order_id
        )
        .then(response => {
          _self.cabinet_selection = response.data.data;
          _self.delete_change_order_flag =
            response.data.delete_change_order_flag;
          if (_self.cabinet_selection.length == 0) {
            _self.addRemoveCabinetSelection("yes");
          } else {
            _self.cabinet_selection[0].default_cabinet = "true";
            _self.changeCabinetDefaultSelection();
          }
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
      this.getProjectCabinetOrder();
      this.getChangeOrders();
    },

    getProjectCabinetOrder() {
      this.cabinet_order_loading = true;
      let _self = this;
      axios
        .get(
          "get_project_cabinet_order?project_id=" +
            this.selectedRows[0].project_id +
            "&cabinet_order_flag=" +
            this.cabinet_order_flag +
            "&change_order_id=" +
            this.change_order_id
        )
        .then(response => {
          _self.cabinet_order_list = response.data.data;
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
    },

    addCounterTop() {
      this.change_order_flag = false;
      if (this.selectedRows[0].invoices_count > 0) {
        this.is_change_order = "yes";
      } else {
        this.is_change_order = "no";
      }
      this.project_data_flag = 6;
      this.stone_data = [];
      this.selected_stone = [];
      this.view_counter_top_screen = false;
      this.resetCounterTopEntry();
      this.countertop_order_error = {};
      // this.add_counter_top_model = true;

      let _self = this;
      this.add_counter_top_loading = true;
      axios
        .get(
          "get_project_stone?project_id=" +
            this.selectedRows[0].project_id +
            "&change_order_id=" +
            this.change_order_id
        )
        .then(response => {
          _self.stone_data = response.data.data;
          _self.delete_change_order_flag =
            response.data.delete_change_order_flag;
          if (_self.stone_data.length == 0) {
            _self.addRemoveStone("yes");
          }
          if (this.stone_data.length > 0) {
            for (let i = 0; i < this.stone_data.length; i++) {
              if (!this.stone_data[i].new_entry) {
                let selected_stone_name = "";
                this.group_stone_list.filter(item => {
                  if (item.item_id == this.stone_data[i].stone_id) {
                    selected_stone_name = item.item_name;
                  }
                });
                _self.selected_stone.push({
                  text: selected_stone_name,
                  value: this.stone_data[i].stone_id
                });
              }
            }
          }
          if (_self.selected_stone.length > 0) {
            _self.countertop_order_data.stone_id =
              _self.selected_stone[0].value;
            _self.changeCounterTopStone();
          }
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
      this.getProjectCountorTop();
      this.getProjectCounterTopItemJob();
      this.getChangeOrders();
    },
    getProjectCountorTop() {
      let _self = this;
      this.add_counter_top_loading = true;
      axios
        .get(
          "get_project_countor_top?project_id=" +
            this.selectedRows[0].project_id +
            "&change_order_id=" +
            this.change_order_id
        )
        .then(response => {
          _self.countertop_list = response.data.data;
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    getProjectCounterTopItemJob() {
      let _self = this;
      this.add_counter_top_loading = true;
      axios
        .get(
          "get_project_countor_top_item_job?project_id=" +
            this.selectedRows[0].project_id +
            "&change_order_id=" +
            this.change_order_id
        )
        .then(response => {
          _self.item_job_list = response.data.data;
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    resetProjectStone(index) {
      let _self = this;
      this.add_counter_top_loading = true;
      axios
        .get(
          "get_project_stone_details?project_stone_id=" +
            this.stone_data[index].project_stone_id
        )
        .then(response => {
          _self.stone_data[index].edit_mode = false;
          _self.stone_data[index].new_entry = false;
          _self.stone_data[index] = response.data.data;
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    deleteProjectStone() {
      let _self = this;
      this.add_counter_top_loading = true;
      axios
        .post("delete_project_stone", {
          id: this.stone_data[this.selected_project_stone_index]
            .project_stone_id,
          is_change_order: this.is_change_order
        })
        .then(function(res) {
          if (res.data.status) {
            _self.is_change_order = "no";
            _self.stone_data.splice(_self.selected_project_stone_index, 1);
            _self.selected_stone.splice(_self.selected_project_stone_index, 1);
            _self.add_counter_top_loading = false;
            if (_self.selected_stone.length > 0) {
              _self.countertop_order_data.stone_id =
                _self.selected_stone[0].value;
            } else {
              _self.countertop_order_data.stone_id = null;
            }
            _self.changeCounterTopStone();
          } else {
            _self.setAlert({
              show: true,
              variant: "error",
              message: res.data.message,
              dismissCountDown: 0
            });
          }
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    deleteProjectCabinet() {
      let _self = this;
      this.cabinet_order_loading = true;
      axios
        .post("delete_project_cabinet", {
          id: this.cabinet_selection[this.selected_project_cabinet_index]
            .cabinet_selection_id,
          is_change_order: this.is_change_order
        })
        .then(function(res) {
          if (res.data.status) {
            _self.is_change_order = "no";
            if (
              _self.cabinet_selection[_self.selected_project_cabinet_index]
                .default_cabinet == "true"
            ) {
              _self.cabinet_selection.splice(
                _self.selected_project_cabinet_index,
                1
              );
              if (_self.cabinet_selection.length > 0) {
                _self.cabinet_selection[0].default_cabinet = "true";
                _self.changeCabinetDefaultSelection();
              }
            } else {
              _self.cabinet_selection.splice(
                _self.selected_project_cabinet_index,
                1
              );
            }
          } else {
            _self.setAlert({
              show: true,
              variant: "error",
              message: res.data.message,
              dismissCountDown: 0
            });
          }
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
    },
    deleteProjectCabinetOrder() {
      let _self = this;
      this.cabinet_order_loading = true;
      axios
        .post("delete_project_cabinet_order", {
          id: this.cabinet_order_id,
          is_change_order: this.is_change_order
        })
        .then(function() {
          _self.is_change_order = "no";
          _self.getProjectCabinetOrder();
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
    },
    deleteProjectCountorTop() {
      let _self = this;
      this.add_counter_top_loading = true;
      axios
        .post("delete_project_countor_top", {
          id: this.counter_top_id,
          is_change_order: this.is_change_order
        })
        .then(function() {
          _self.is_change_order = "no";
          _self.getProjectCountorTop();
          _self.getProjectCounterTopItemJob();
          //  setTimeout(() => {
          //   _self.updateSaleQtyOfItem(_self.change_stock_item_id);
          //    }, 2000);
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    checkStonePrice(index) {
      if (this.stone_data[index].new_entry) {
        let price = this.getStonePrice(index);
        if (this.stone_data[index].standard_price > 0 && price > 0) {
          if (this.stone_data[index].standard_price != price) {
            this.active_stone_index = index;
            this.change_stone_price_dialog = true;
          } else {
            this.saveProjectStone(index);
          }
        } else {
          this.saveProjectStone(index);
        }
      } else {
        this.saveProjectStone(index);
      }
    },
    saveProjectStone(index) {
      this.stone_data[index].form_error = {};
      this.stone_data[index].project_id = this.selectedRows[0].project_id;
      this.stone_data[index].is_change_order = this.is_change_order;
      let _self = this;
      this.add_counter_top_loading = true;
      if (this.stone_data[index].new_entry) {
        axios
          .post("add_project_stone", this.stone_data[index])
          .then(function(res) {
            let data = res.data;
            if (!data.status) {
              for (let key in data.errors) {
                _self.stone_data[index].form_error[key] = data.errors[key][0];
              }
            } else {
              _self.is_change_order = "no";
              _self.stone_data[index].edit_mode = false;
              _self.stone_data[index].new_entry = false;
              _self.stone_data[index].project_stone_id =
                data.data.project_stone_id;

              if (_self.stone_data[index].change_price_in_master) {
                for (
                  let i = 0;
                  i < _self.stone_data[index].stone_vendor_list.length;
                  i++
                ) {
                  if (
                    _self.stone_data[index].stone_vendor_list[i].vendor_id ==
                      _self.stone_data[index].vendor_id &&
                    _self.stone_data[index].stone_vendor_list[i]
                      .price_override == "1"
                  ) {
                    _self.stone_data[index].stone_vendor_list[
                      i
                    ].override_price = _self.stone_data[index].standard_price;
                  }
                }
              }

              let selected_stone_name = "";
              _self.group_stone_list.filter(item => {
                if (item.item_id == _self.stone_data[index].stone_id) {
                  selected_stone_name = item.item_name;
                }
              });
              _self.selected_stone.push({
                text: selected_stone_name,
                value: _self.stone_data[index].stone_id
              });
              // _self.countertop_order_data.stone_id = _self.selected_stone[0].value
              _self.countertop_order_data.stone_id =
                _self.stone_data[index].stone_id;

              _self.changeCounterTopStone();

              _self.item_group_data.description = "Counter Top Order";
              _self.item_group_data.ids = [];
              _self.item_group_data.project_data_group_flag =
                _self.project_data_flag;
              _self.item_group_data.project_id =
                _self.selectedRows[0].project_id;
              axios
                .post("project_data_group", _self.item_group_data)
                .then(() => {
                  _self.item_group_data = {};
                  _self.item_group_error = {};
                })
                .catch(function() {});
            }
            _self.add_counter_top_loading = false;
          })
          .catch(function() {
            _self.add_counter_top_loading = false;
          });
      } else {
        axios
          .post("edit_project_stone", this.stone_data[index])
          .then(function(res) {
            let data = res.data;
            if (!data.status) {
              for (let key in data.errors) {
                _self.stone_data[index].form_error[key] = data.errors[key][0];
              }
            } else {
              _self.is_change_order = "no";
              _self.stone_data[index].edit_mode = false;
              let selected_stone_name = "";
              _self.group_stone_list.filter(item => {
                if (item.item_id == _self.stone_data[index].stone_id) {
                  selected_stone_name = item.item_name;
                }
              });
              _self.selected_stone[index].text = selected_stone_name;
              _self.selected_stone[index].value =
                _self.stone_data[index].stone_id;
              if (_self.selected_stone.length > 0) {
                // _self.countertop_order_data.stone_id = _self.selected_stone[0].value
                _self.countertop_order_data.stone_id =
                  _self.stone_data[index].stone_id;
                _self.changeCounterTopStone();
              }
              _self.getProjectCountorTop();
              _self.getProjectCounterTopItemJob();
            }
            _self.add_counter_top_loading = false;
          })
          .catch(function() {
            _self.add_counter_top_loading = false;
          });
      }
    },

    saveProjectCabinet(index) {
      this.cabinet_selection[index].form_error = {};
      this.cabinet_selection[
        index
      ].project_id = this.selectedRows[0].project_id;
      this.cabinet_selection[index].is_change_order = this.is_change_order;
      let _self = this;
      this.cabinet_order_loading = true;
      if (this.cabinet_selection[index].new_entry) {
        this.cabinet_selection[
          index
        ].cabinet_order_flag = this.cabinet_order_flag;
        axios
          .post("add_project_cabinet", this.cabinet_selection[index])
          .then(function(res) {
            let data = res.data;
            if (!data.status) {
              for (let key in data.errors) {
                _self.cabinet_selection[index].form_error[key] =
                  data.errors[key][0];
              }
            } else {
              _self.is_change_order = "no";
              _self.cabinet_selection[index].edit_mode = false;
              _self.cabinet_selection[index].new_entry = false;
              _self.cabinet_selection[index].cabinet_selection_id =
                data.data.cabinet_selection_id;
              if (_self.cabinet_selection.length == 1) {
                _self.cabinet_selection[0].default_cabinet = "true";
                _self.changeCabinetDefaultSelection();
              }
              if (_self.project_data_flag == "7") {
                _self.item_group_data.description = "Cabinet Order";
              } else {
                _self.item_group_data.description = "Closets";
              }
              _self.item_group_data.ids = [];
              _self.item_group_data.project_data_group_flag =
                _self.project_data_flag;
              _self.item_group_data.project_id =
                _self.selectedRows[0].project_id;
              axios
                .post("project_data_group", _self.item_group_data)
                .then(() => {
                  _self.item_group_data = {};
                  _self.item_group_error = {};
                })
                .catch(function() {});
            }
            _self.cabinet_order_loading = false;
          })
          .catch(function() {
            _self.cabinet_order_loading = false;
          });
      } else {
        axios
          .post("edit_project_cabinet", this.cabinet_selection[index])
          .then(function(res) {
            let data = res.data;
            if (!data.status) {
              for (let key in data.errors) {
                _self.cabinet_selection[index].form_error[key] =
                  data.errors[key][0];
              }
            } else {
              _self.is_change_order = "no";
              _self.cabinet_selection[index].edit_mode = false;
              // let selected_stone_name = ''
              // _self.stone_data[index].group_stone_list.filter((item) => {
              //   if(item.item_id == _self.stone_data[index].stone_id) {
              //     selected_stone_name = item.item_name
              //   }
              // })
              // _self.selected_stone[index].text = selected_stone_name;
              // _self.selected_stone[index].value = _self.stone_data[index].stone_id;
              // if(_self.selected_stone.length > 0) {
              //   _self.countertop_order_data.stone_id = _self.selected_stone[0].value
              //   _self.changeCounterTopStone();
              // }
              // _self.getProjectCountorTop()
            }
            _self.cabinet_order_loading = false;
          })
          .catch(function() {
            _self.cabinet_order_loading = false;
          });
      }
    },

    saveCabinetOrder() {
      this.cabinet_order_error = {};
      this.cabinet_order_data.project_id = this.selectedRows[0].project_id;
      this.cabinet_order_data.accessory_item_list = this.accessory_item_list;
      this.cabinet_order_data.is_change_order = this.is_change_order;
      let _self = this;
      this.cabinet_order_loading = true;
      this.cabinet_order_data.cabinet_order_flag = this.cabinet_order_flag;
      axios
        .post("add_project_cabinet_order", this.cabinet_order_data)
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.cabinet_order_error[key] = data.errors[key][0];
            }
          } else {
            _self.is_change_order = "no";
            _self.resetCabinetOrderData();
            _self.getProjectCabinetOrder();
            _self.setAlert({
              show: true,
              variant: "primary",
              message: data.message,
              dismissCountDown: 0
            });
          }
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
    },
    saveProjectCountorTop() {
      this.countertop_order_error = {};
      this.countertop_order_data.project_id = this.selectedRows[0].project_id;
      this.countertop_order_data.counter_cost = this.calculateCounterCost;
      this.countertop_order_data.sq_ft = this.total_sq_ft;
      this.countertop_order_data.is_change_order = this.is_change_order;
      let _self = this;
      this.add_counter_top_loading = true;
      axios
        .post("add_project_countor_top", this.countertop_order_data)
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.countertop_order_error[key] = data.errors[key][0];
            }
          } else {
            _self.is_change_order = "no";
            _self.resetCounterTopEntry();
            _self.getProjectCountorTop();
            _self.getProjectCounterTopItemJob();
            // setTimeout(() => {
            //   _self.updateSaleQtyOfItem(_self.countertop_order_data.stone_id);
            //   }, 2000);
            _self.setAlert({
              show: true,
              variant: "primary",
              message: data.message,
              dismissCountDown: 0
            });
          }
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },
    updateProjectCountorTop() {
      this.countertop_order_error = {};
      this.countertop_order_data.project_id = this.selectedRows[0].project_id;
      this.countertop_order_data.counter_cost = this.calculateCounterCost;
      this.countertop_order_data.sq_ft = this.total_sq_ft;
      this.countertop_order_data.project_counter_top_entry_id = this.edit_counter_top_id;
      this.countertop_order_data.is_change_order = this.is_change_order;
      let _self = this;
      this.add_counter_top_loading = true;

      axios
        .post("edit_project_countor_top", this.countertop_order_data)
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.countertop_order_error[key] = data.errors[key][0];
            }
          } else {
            _self.is_change_order = "no";
            _self.resetCounterTopEntry();
            _self.getProjectCountorTop();
            _self.getProjectCounterTopItemJob();

            _self.edit_countor_top_entry = false;
            _self.view_counter_top_screen = false;

            // setTimeout(() => {
            // _self.updateSaleQtyOfItem(_self.countertop_order_data.stone_id);
            //   }, 2000);

            _self.setAlert({
              show: true,
              variant: "primary",
              message: data.message,
              dismissCountDown: 0
            });
          }
          _self.add_counter_top_loading = false;
        })
        .catch(function() {
          _self.add_counter_top_loading = false;
        });
    },

    updateProjectCabinetOrder() {
      this.cabinet_order_error = {};
      this.cabinet_order_data.project_id = this.selectedRows[0].project_id;
      this.cabinet_order_data.product_cab_o_id = this.edit_product_cab_o_id;
      this.cabinet_order_data.is_change_order = this.is_change_order;
      let _self = this;
      this.cabinet_order_loading = true;
      axios

        .post("edit_project_cabinet_order", this.cabinet_order_data)
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.cabinet_order_error[key] = data.errors[key][0];
            }
          } else {
            _self.is_change_order = "no";
            _self.resetCabinetOrderData();
            _self.getProjectCabinetOrder();
            _self.edit_cabinet_order_flag = false;
            _self.view_cabinet_order_screen = false;
            _self.setAlert({
              show: true,
              variant: "primary",
              message: data.message,
              dismissCountDown: 0
            });
          }
          _self.cabinet_order_loading = false;
        })
        .catch(function() {
          _self.cabinet_order_loading = false;
        });
    },

    addRecord() {
      this.setData({ key: "add_modal", value: true });
    },
    editRecord(project_id, is_view_mode) {
      this.setData({ key: "edit_modal", value: true });
      this.setData({ key: "id", value: project_id });
      this.setData({ key: "is_view_mode", value: is_view_mode });
    },
    getAccessUsers(access_users) {
      let userData = access_users.map(item => {
        return `${item.user_details.full_name}`;
      });
      return userData.join(", ");
    },
    // getStone(index) {
    //   this.add_counter_top_loading = true
    //   this.stone_data[index].stone_id = null;
    //   this.stone_data[index].vendor_id = null;
    //   this.stone_data[index].change_price_in_master = false;
    //   let _self = this;
    //   axios
    //     .get("items_list?itemsPerPage=-1&item_type=1")
    //     // .get("items_list?itemsPerPage=-1&item_type=1&item_group="+this.stone_data[index].group_id)
    //     .then((response) => {
    //       _self.stone_data[index].group_stone_list = response.data.data.data;
    //       if(response.data.data.data.length == 1) {
    //         _self.stone_data[index].stone_id = response.data.data.data[0].item_id
    //         _self.changeStone(index);
    //       }
    //       _self.add_counter_top_loading = false
    //     })
    //     .catch(function () {
    //       _self.add_counter_top_loading = false
    //     });
    // },
    getStone() {
      // this.add_counter_top_loading = true;
      let _self = this;
      axios
        .get("get_items?itemsPerPage=-1&item_type=1")
        .then(response => {
          _self.group_stone_list = response.data.data;

          // _self.add_counter_top_loading = false;
        })
        .catch(function() {
          // _self.add_counter_top_loading = false;
        });
    },
    getAllTypeItem() {
      let _self = this;
      axios
        .get("get_items?itemsPerPage=-1&with=vendor")
        .then(response => {
          _self.all_type_item_list = response.data.data;
        })
        .catch(function() {});
    },
    getSink() {
      // this.loading = false;
      let _self = this;
      axios
        .get("get_items?itemsPerPage=-1&search=sink&with=vendor")
        .then(response => {
          _self.sink_list = response.data.data;
          if (_self.sink_list.length == 1) {
            _self.countertop_order_data.sink_id = _self.sink_list[0].item_id;
            _self.changeSink();
          }
        })
        .catch(function() {
          // _self.loading = false;
        });
    },
    getCutJob() {
      // this.loading = false;
      let _self = this;
      axios
        .get(
          "get_items?itemsPerPage=-1&item_type=2&sortBy=item_name&with=vendor"
        )
        .then(response => {
          _self.cut_job_list = response.data.data;

          if (_self.cut_job_list.length == 1) {
            _self.countertop_order_data.cut_job_id =
              _self.cut_job_list[0].item_id;
            _self.changeCutJob();
          }
        })
        .catch(function() {
          // _self.loading = false;
        });
    },
    changeStone(index) {
      this.add_counter_top_loading = true;
      this.stone_data[index].vendor_id = null;
      this.stone_data[index].change_price_in_master = false;
      let selected_stone_data = this.group_stone_list.filter(item => {
        return item.item_id == this.stone_data[index].stone_id;
      })[0];
      this.stone_data[index].stone_vendor_list = selected_stone_data.vendors;
      if (
        selected_stone_data.vendors &&
        selected_stone_data.vendors.length == 1
      ) {
        this.stone_data[index].vendor_id =
          selected_stone_data.vendors[0].vendor_id;
        this.changeVendor2(index);
      }
      this.add_counter_top_loading = false;
    },
    getUsers() {
      let _self = this;
      axios
        .get("get_users?itemsPerPage=-1")
        .then(response => {
          if (response.data.status) {
            _self.users = response.data.data;
          }
        })
        .catch(function() {});
    },
    getProjectSelectors() {
      let _self = this;
      axios
        .get("project_selectors")
        .then(response => {
          if (response.data.status) {
            _self.customer_list = response.data.data.customers;
          }
        })
        .catch(function() {});
    },
    resetFilter() {
      this.search = "";
      this.pagination.filters.tran_start_date = "";
      this.pagination.filters.tran_end_date = "";
      this.pagination.filters.date_filter = "";
      this.pagination.filters.type = "1";
      this.pagination.filters.p_active = "1";
      this.pagination.filters.customer = "";
      this.pagination.filters.status = "";
      this.pagination.filters.user = "";
      this.pagination.filters.assign_to = "";
      this.pagination.filters.access_to = "";
      this.getProjects();
    },
    parseDate(key) {
      if (key == "tran_start_date") {
        if (this.dateFormatted) {
          this.disable_dates = this.dateFormatted;
        } else {
          this.disable_dates = null;
        }
      }
      const [year, month, day] = this.dateFormatted.split("-");
      this.pagination.filters[key] = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.project_id == itemData.item.project_id) {
            item.expande_icon = "mdi-chevron-up";
            item.selected = true;
          } else {
            item.expande_icon = "mdi-chevron-down";
          }
          return item;
        });
      } else {
        this.items.data = this.items.data.map(function(item) {
          item.expande_icon = "mdi-chevron-down";
          return item;
        });
      }
    },
    deleteProjects() {
      let _self = this;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.project_id);
      });
      axios
        .post("delete_projects", {
          ids: ids
        })
        .then(function(response) {
          _self.setAlert({
            show: true,
            variant: response.data.variant,
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.getProjects();
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getProjects() {
      let _self = this;
      this.loading = "accent";
      this.pageData.project_type = this.$route.params.project_type;
      let url = parseParams(this.pageData);
      axios
        .get("project_list?with_balance=false&" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.items.data.forEach(item => {
            if (_self.selected_project === item.project_id) {
              item.selected = true;
              this.selectRecord(item.project_id);
            } else {
              item.selected = false;
            }
          });

          this.loading = false;
          this.getProjectsWithBalance();
        })
        .catch(function() {
          this.loading = false;
        });
    },
    getProjectsWithBalance() {
      let _self = this;
      let url = parseParams(this.pageData);
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.project_id);
      });
      axios
        .get("project_list?with_balance=true&" + url + "&selectedIds=" + ids)
        .then(response => {
          _self.total_value = response.data.totalValue;
          _self.total_invoice_amt = response.data.totalInvoiceAmt;
          _self.total_payment_due = response.data.totalPaymentDue;
          _self.total_received_money = response.data.totalReceivedMoney;
          _self.total_pending_invoice_amount =
            response.data.totalPendingInvoiceAmt;
          _self.total_balance = response.data.totalBalance;
        })
        .catch(function() {});
    },
    getTaskVendors() {
      let _self = this;
      axios
        .get("get_vendors")
        .then(response => {
          if (response.data.status) {
            _self.task_vendor_list = response.data.data;
          }
        })
        .catch(function() {});
    },
    getVendors() {
      //this.loading = false
      let _self = this;
      axios
        .get("vendor_list?itemsPerPage=-1&sortBy=v_name")
        .then(response => {
          _self.vendor_list = response.data.data.data;
          //_self.loading = false
        })
        .catch(function() {
          //_self.loading = false
        });
    },
    getJobs(flag, hideLoader) {
      if (!hideLoader) {
        this.loading = false;
      }
      console.log(flag);
      // let _self = this;
      // axios
      // .get("job_list?itemsPerPage=-1&sortBy=job_name")
      // .then(response => {
      //   console.log(_self.job_list, "_self.job_list");
      //   _self.job_list = response.data.data.data;
      //   _self.job_list.filter(item => {
      //     if (item.group_id == 40) {
      //       _self.edge_profile_list.push({
      //         text: item.job_name,
      //         value: item.job_id,
      //         sales_price: item.sales_price,
      //         vendor_id: item.vendor_id,
      //         group_id: item.group_id,
      //         px_override: item.px_override,
      //         override_price: item.override_price
      //       });
      //     }
      //     if (item.group_id == 41) {
      //       _self.elec_cut_out_list.push({
      //         text: item.job_name,
      //         value: item.job_id,
      //         sales_price: item.sales_price,
      //         vendor_id: item.vendor_id,
      //         group_id: item.group_id,
      //         px_override: item.px_override,
      //         override_price: item.override_price
      //       });
      //   }
      //   if (item.group_id == 42) {
      //     _self.sink_cut_out_list.push({
      //       text: item.job_name,
      //       value: item.job_id,
      //       sales_price: item.sales_price,
      //       vendor_id: item.vendor_id,
      //       group_id: item.group_id,
      //       px_override: item.px_override,
      //       override_price: item.override_price
      //     });
      //   }
      //   if (item.group_id == 43) {
      //     _self.cooktop_cut_out_list.push({
      //       text: item.job_name,
      //       value: item.job_id,
      //       sales_price: item.sales_price,
      //       vendor_id: item.vendor_id,
      //       group_id: item.group_id,
      //       px_override: item.px_override,
      //       override_price: item.override_price
      //     });
      //   }
      // });
      //   if (flag == "edit") {
      //     _self.getJobDetails(_self.active_item_job_index);
      //   }
      //   if (flag == "add") {
      //     _self.add_project_data[_self.active_item_job_index].item_job_id =
      //       _self.last_add_job_id;
      //     _self.getJobDetails(_self.active_item_job_index);
      //     _self.setJobData({ key: "last_add_job_id", value: "" });
      //   }
      //   if (!hideLoader) {
      //     _self.loading = false;
      //   }
      // })
      // .catch(function() {
      //   if (!hideLoader) {
      //     _self.loading = false;
      //   }
      // });
    },
    getAreas() {
      //this.loading = false
      let _self = this;
      axios
        .get("get_areas?itemsPerPage=-1&sortBy=name")
        .then(response => {
          _self.area_list = response.data.data;
          // console.log(_self.area_list, "area_list");
          //_self.loading = false
        })
        .catch(function() {
          //_self.loading = false
        });
    },
    getItems(flag, hideLoader) {
      if (!hideLoader) {
        this.loading = false;
      }
      let _self = this;
      axios
        .get("get_items?itemsPerPage=-1&item_type=0")
        .then(response => {
          _self.item_list = response.data.data;
          _self.counter_top_item_list = response.data.data;
          if (flag == "edit") {
            if (_self.active_flag == "group_item") {
              _self.getGroupItemDetails();
            } else {
              if (_self.$route.params.project_type == 1) {
                _self.getItemDetails(_self.active_item_job_index);
              } else {
                if (_self.from_add_edit_item == "stone") {
                  _self.getStoneDetails(_self.active_stone_select_index);
                  _self.getStone();
                }
                if (_self.from_add_edit_item == "counter_top") {
                  _self.getSink();
                  _self.getCutJob();
                  setTimeout(() => {
                    _self.changeSink();
                    _self.changeCutJob();
                    _self.changeVendorCutJob();
                  }, 1000);
                } else {
                  _self.getItemJobDetails(_self.active_item_job_index);
                  _self.getAllTypeItem();
                }
              }
            }
          }
          if (flag == "add") {
            if (_self.$route.params.project_type == 1) {
              _self.add_project_data[_self.active_item_job_index].item_job_id =
                _self.last_add_item_id;
              _self.getItemDetails(_self.active_item_job_index);
            } else {
              if (_self.from_add_edit_item == "stone") {
                _self.getStoneDetails(_self.active_stone_select_index);
              }
              if (_self.from_add_edit_item == "counter_top") {
                _self.getSink();
                _self.getCutJob();
                _self.countertop_order_data.sink_id = _self.last_add_item_id;
                _self.countertop_order_data.cut_job_id = _self.last_add_item_id;
                setTimeout(() => {
                  _self.changeSink();
                  _self.changeCutJob();
                }, 2000);
              } else {
                _self.item_job_data.item_job_id = _self.last_add_item_id;
                _self.getItemJobDetails(_self.active_item_job_index);
                _self.getAllTypeItem();
              }
            }
            _self.setItemData({ key: "last_add_item_id", value: "" });
          }
          if (!hideLoader) {
            _self.loading = false;
          }
        })
        .catch(function() {
          if (!hideLoader) {
            _self.loading = false;
          }
        });
    },
    getCounterTopItemList(item_type) {
      let _self = this;
      axios
        .get(
          "get_items?itemsPerPage=-1&item_type=" +
            item_type +
            "&sortBy=item_name"
        )
        .then(response => {
          _self.counter_top_item_list = response.data.data;
        })
        .catch(function() {});
    },
    geUom() {
      //this.loading = true
      let _self = this;
      axios
        .get("get_item_uom")
        .then(response => {
          if (response.data.status) {
            _self.uom_list = response.data.data;
            //_self.loading = false
          }
        })
        .catch(function() {
          //_self.loading = false
        });
    },
    // getStoneGroup() {
    //   axios
    //     .get("get_item_groups")
    //     .then((response) => {
    //       if (response.data.status) {
    //         // this.stone_group_list = response.data.stone_group;
    //         this.stone_group_list = response.data.item_group;
    //         this.getStone();

    //       }
    //     })
    //     .catch(function () {});
    // },
    // getSinkGroup() {
    //   let _self = this
    //   axios.get("group_list?itemsPerPage=-1&module=COUNTERTOP_ORDER")
    //     .then((response) => {
    //       _self.sink_group_list = response.data.data.data;
    //     })
    //     .catch(function () {

    //     });
    // },
    getCabinetType() {
      let _self = this;
      axios
        .get("cabinet_type_list?itemsPerPage=-1&cabinet_order=1")
        .then(response => {
          _self.cabinet_type_list = response.data.data.data;
        })
        .catch(function() {});
    },
    getCabinetStyle() {
      let _self = this;
      axios
        .get("cabinet_style_list?itemsPerPage=-1")
        .then(response => {
          _self.cabinet_style_list = response.data.data.data;
        })
        .catch(function() {});
    },
    getAccessory(width) {
      let _self = this;
      axios
        .get(
          "cabinet_list?itemsPerPage=-1&filter[cabinet_type_id]=15&filter[width]=" +
            width
        )
        .then(response => {
          _self.accessory_list = response.data.data.data;
        })
        .catch(function() {});
    },
    getItemSettings() {
      axios
        .get("get_item_setting")
        .then(response => {
          let data = response.data.data;
          for (let key in data) {
            this.setting_data[key] = data[key] == null ? 0 : data[key];
          }
        })
        .catch(function() {});
    },
    // getProjectTotalCalculation(){
    //    let _self = this

    //  axios
    //  .get("get_project_total_calculation")
    //     .then((response) => {
    //       _self.total_balance_flag  = true
    //       if(response.data.totalValue > 0) {313

    //         _self.total_value = parseFloat(response.data.totalValue).toFixed(2);
    //       } else {
    //         _self.total_value = null
    //       }
    //       if(response.data.totalInvoiceAmt > 0) {
    //         _self.total_invoice_amt = parseFloat(response.data.totalInvoiceAmt).toFixed(2);
    //       } else {
    //         _self.total_invoice_amt = null
    //       }
    //       if(response.data.totalPaymentDue > 0) {
    //         _self.total_payment_due = parseFloat(response.data.totalPaymentDue).toFixed(2);
    //       } else {
    //         _self.total_payment_due = null
    //       }
    //        if(response.data.totalPendingInvoiceAmt > 0) {
    //         _self.total_pending_invoice_amount = parseFloat(response.data.totalPendingInvoiceAmt).toFixed(2);
    //       } else {
    //         _self.total_pending_invoice_amount = null
    //       }
    //       if(response.data.totalBalance) {
    //         _self.total_balance =response.data.totalBalance;
    //       } else {
    //         _self.total_balance = null
    //       }
    //         this.loading = false;
    //       }).catch(function () {
    //       this.loading = false;
    //     });
    // },
    getProjectBalance(type, id) {
      this.loading = "accent";

      let ids = [];
      if (type == "single") {
        ids.push(id);

        this.items.data.forEach(item => {
          if (id === item.project_id) {
            item.selected = true;
          }
        });
      } else {
        this.selectedRows.map(function(item) {
          ids.push(item.project_id);
        });
      }
      axios
        .get("get_project_balance?project_ids=" + ids)
        .then(response => {
          this.getProjectsWithBalance();
          // _self.items = response.data.data;
          this.items.data = this.items.data.filter(item => {
            response.data.data.filter(fil => {
              if (item.project_id == fil.project_id) {
                item.project_balance_flag = true;
                item.project_value = fil.project_value;
                item.pending_invoice = fil.pending_invoice;
                item.invoice_amt = fil.invoice_amt;
                item.payment_due = fil.payment_due;
                item.balance = fil.balance;
                item.project_received_value = fil.project_received_value;
              }
            });
            return item;
          });
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },

    getInvoicedTransactionList(group_id, change_order, group_name) {
      let _self = this;
      axios
        .post("get_invoiced_transaction_list", {
          group_id: group_id,
          change_order: change_order,
          project_id: this.selectedRows[0].project_id
        })
        .then(function(res) {
          console.log(res.data.data, "transaction_list_dialogue");

          _self.transaction_list = res.data.data;
          _self.transaction_list_total = res.data.total;
          _self.transaction_list_inv_total = res.data.inv_total;
          (_self.transaction_group_name = group_name),
            (_self.transaction_list_dialogue = true);
        })
        .catch(function() {
          _self.transaction_list_dialogue = false;
        });
    },
    deleteSinkCutJob(counter_top_item_job_id, counter_top_id, type) {
      let _self = this;
      if (
        counter_top_item_job_id != undefined &&
        counter_top_item_job_id != ""
      ) {
        axios
          .post("delete_sink_cut_job", { id: counter_top_item_job_id })
          .then(function(response) {
            let data = response.data;
            _self.editCounterTop(counter_top_id);
            _self.setAlert({
              show: true,
              variant: "primary",
              message: data.message,
              dismissCountDown: 0
            });
          })
          .catch(function() {});
      } else {
        if (type == "sink") {
          _self.countertop_order_data.counter_top_sink_id = "";
          _self.countertop_order_data.sink_id = "";
          _self.countertop_order_data.group_id = "";
          _self.countertop_order_data.sink_qty = "";
          _self.countertop_order_data.sink_price = "";
          _self.countertop_order_data.vendor_id = "";
          _self.sink_vendor_list = [];
        }
        if (type == "job_cut") {
          _self.countertop_order_data.counter_top_cut_job_id = "";
          _self.countertop_order_data.cut_job_id = "";
          _self.countertop_order_data.cut_job_qty = "";
          _self.countertop_order_data.cut_job_price = "";
          _self.countertop_order_data.cut_job_vendor_id = "";
          _self.cut_job_vendor_list = [];
          _self.countertop_order_data.cut_job_qty = "";
        }
      }
    },
    logout() {
      logout(this.$router);
    }
  },
  mounted: function() {
    this.getUsers();
    this.getTaskVendors();
    this.getProjectSelectors();
    this.getProjectList();

    // this.getVendors();
    // this.getItems("", true);
    // // this.getJobs("", true);
    // this.getAreas();
    // this.geUom();
    // // this.getStoneGroup();
    // this.getStone();
    // this.getAllTypeItem();
    // // this.getSinkGroup();
    // this.getCounterTopItemList(0);
    // this.getSink();
    // this.getCutJob();
    // // this.getCabinetType();
    // // this.getCabinetStyle();
    // this.getItemSettings();
    localStorage.removeItem("is_from_project");
    localStorage.removeItem("redirect_to");
    localStorage.removeItem("co_group_id");
    localStorage.removeItem("co_item_id");
    localStorage.removeItem("co_co_id");
    localStorage.removeItem("co_project_id");
    localStorage.removeItem("is_from_dashboard");
  },
  created() {
    this.$watch(
      () => this.$route.params,
      () => {
        Object.assign(this.$data, intialData());

        this.getUsers();
        this.getProjectSelectors();
        // this.getVendors();
        // this.getItems("", true);
        // // this.getJobs("", true);
        // this.getAreas();
        // this.geUom();
        // // this.getStoneGroup();
        // this.getStone();
        // this.getAllTypeItem();
        // // this.getSinkGroup();
        // this.getSink();
        // this.getCutJob();
        // this.getCounterTopItemList(0);
        // // this.getCabinetType();
        // // this.getCabinetStyle();
        // this.getItemSettings();
        localStorage.removeItem("is_from_project");
        localStorage.removeItem("redirect_to");
        localStorage.removeItem("co_group_id");
        localStorage.removeItem("co_item_id");
        localStorage.removeItem("co_project_id");
        localStorage.removeItem("is_from_dashboard");
      }
    );
  }
};
</script>
<style>
.custome-height .v-list-item__icon {
  height: 10px !important;
}
.input-white-text input {
  color: white !important;
}
.input-white-text .v-select__selection--comma {
  color: white !important;
}
.input-white-text .theme--light.v-icon {
  color: white !important;
}
.disable-btn .v-input__slot {
  background-color: rgba(0, 0, 0, 0.12) !important;
  color: rgba(0, 0, 0, 0.26) !important;
}
.edit_row_height {
  height: 32px !important;
}
.padding_0_table td,
.padding_0_table th {
  padding: 0px 6px !important;
}
.bg-gray {
  background-color: #d5d5d5;
  cursor: not-allowed;
}
.bg-light-gray {
  background-color: #efefef;
}
</style>
<style scopped>
.v-badge__badge {
  height: 14px !important;
  font-size: 9px !important;
  padding: 3px;
  top: -9px !important;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0px;
}
</style>